import { KYMW0900Component } from './kymw0900.component';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';

import { CommonSetting } from './../../../commons/kymw00/common-setting';
import { PlanMediumTextModel } from './vo/kymw0900-plan-medium-text.model';
import type { GetPlanGoodsPointExchangePromotionResponse } from './api-services/get-plan-goods-point-exchange-promotion.service';
import { GetGoodsSupplyPriceResponse } from './api-services/get-goods-supply-price.service';
import { GetSelectedNvalMediumListResponse } from './api-services/get-selected-nval-medium-list.service';

/**
 * 商品企画メンテナンス画面の値を管理するクラス
 *
 * @export KYMW0900Model
 * @class KYMW0900Model
 */
export class KYMW0900Model {

  kymw0900Component: KYMW0900Component;
  kymw00Model = new KYMW00Model();

  public initItemCodeList: any = new Array<any>();
  // 選択アイテムコード
  public selectedItemCode: string = <string>'';
  // 初期表示管理データ（企画商品（Ｐコード情報））
  public initPlanGoodsBase: any = new Array<any>();
  /** 表示状態（0：編集モード、1：閲覧モード）*/
  public permission: string = <string>'';
  // 受注コード
  public orderCode: string = <string>'';
  // 媒体区分
  public mediumType: string = <string>'';
  // ロック情報
  public lockInfo: string = <string>'';
  // ロック成功
  public lockSucceeded: boolean = false;
  // Ｐコード
  public pCode: string = <string>'';
  // Ｐコードリスト
  public pCodeList: Array<any> = new Array<any>();
  // 選択Ｐコード
  public selectedPCode: string = <string>'';
  // 部門分類管理NO
  public classDivNum: string = <string>'';
  // バイヤーコード
  public buyerCode: string = <string>'';
  // 包材一括表示確認
  public packMaterialShowFlag: boolean = <boolean>false;
  // 部門コード
  public classCode: string = <string>'';
  // 大分類コード
  public largeClassCode: string = <string>'';
  // 中分類コード
  public middleClassCode: string = <string>'';
  // 小分類コード
  public smallClassCode: string = <string>'';
  // データ種別
  public dataType: string = <string>'';
  // 商品案内用商品名
  public guideGoodsName: string = <string>'';
  // 商品案内用規格名
  public guideStandardName: string = <string>'';
  // 登録日
  public registDate: string = <string>'';
  // 更新日
  public updateDate: string = <string>'';
  // 価格パターン
  public pricePatternList: Array<any> = new Array<any>();
  // ブランド区分
  public brandTypeList: Array<any> = new Array<any>();
  // セット区分
  public setDivList: Array<any> = new Array<any>();
  // 仕訳温度帯
  public assortTempDivList: Array<any> = new Array<any>();
  // 登場区分
  public appearDivList: Array<any> = new Array<any>();
  public appearDiv: string = <string>'';
  // 束ね企画回の終了受注コード
  public bundleCatalogOrderCode: string = <string>'';

  // 注文コード割当List いばらき
  public orderNumQuotaList_Ibaraki: Array<any> = new Array<any>();
  // 注文コード割当List とちぎ
  public orderNumQuotaList_Tochigi: Array<any> = new Array<any>();
  // 注文コード割当List ぐんま
  public orderNumQuotaList_Gunma: Array<any> = new Array<any>();
  // 注文コード割当List ちば
  public orderNumQuotaList_Chiba: Array<any> = new Array<any>();
  // 注文コード割当List さいたま
  public orderNumQuotaList_Saitama: Array<any> = new Array<any>();
  // 注文コード割当List とうきょう
  public orderNumQuotaList_Tokyo: Array<any> = new Array<any>();
  // 注文コード割当List ながの
  public orderNumQuotaList_Nagano: Array<any> = new Array<any>();
  // 注文コード割当List にいがた
  public orderNumQuotaList_Niigata: Array<any> = new Array<any>();
  // 初期表示管理データ（企画商品（アイテムグリッド情報））
  public initItemGridContent: any = new Array<any>();
  // 初期表示管理データ（企画商品（アイテム情報））
  public initPlanGoodsItem: any = new Array<any>();

  /**
 * 基本情報タブ保持データ
 */
  // お届け明細書用商品名（漢字）
  public deliveryGoodsNameKanji: string = <string>'';
  // お届け明細用商品名（カナ）
  public deliveryGoodsNameKana: string = <string>'';
  // お届け明細用規格名（漢字）
  public deliveryStandardNameKanji: string = <string>'';
  // お届け明細用規格名（カナ）
  public deliveryStandardNameKana: string = <string>'';
  // OCR商品名
  public ocrGoodsName: string = <string>'';
  // 消費税区分
  public consumeTaxDiv: string = <string>'';
  // 消費税率
  public consumeTaxDivRate: string = <string>'';
  // サイクル期間
  public cycleTerm: string = <string>'';
  // ＥＤＬＰ商品区分
  public edlpDiv: string = <string>'';
  // ユニットプライス区分
  public unitPriceDiv: string = <string>'';
  // ユニットプライス係数
  public unitPriceCoefficient: string = <string>'';
  // ユニットプライス単位
  public unitPriceUnit: string = <string>'';
  // 賞味期間
  public consumeTerm: string = <string>'';
  // 消費期限
  public consumeByDate: string = <string>'';
  // 残賞味期間（配達時）
  public leaveConsumeTerm: string = <string>'';
  // 商品室内温度帯区分
  public roomTempZoneDiv: string = <string>'';
  // 関連Ｐコード（旧）
  public relationPcodeOld: string = <string>'';
  // 関連Ｐコード（新）
  public relationPcodeNew: string = <string>'';
  // 目隠し区分
  public blindDiv: string = <string>'';
  // ｅフレンズ送信要否
  public eFriendsSendDiv: boolean = <boolean>false;
  // コマ配置予定区分
  public komaScheduleDiv: string = <string>'';
  // 酒類コード
  public liquorCode: string = <string>'';
  // アルコール分別
  public alcoholType: string = <string>'';
  // 容器形態
  public containerForm: string = <string>'';
  // 容器容量
  public containerCapacity: string = <string>'';

  /**
   * 会員生協タブ保持データ
   */
  // 価格パターン連動マーク一覧（データグリッド・タイトル）
  public pricePatternLinkMarkList: Array<any> = new Array<any>();
  // 選択価格パターン
  public pricePatternLinkMarkCode: string = <string>'';
  // 会員生協マーク一覧
  public coopMarkList: Array<any> = new Array<any>();
  public allcoopValue: boolean = <boolean>false;
  public allcoopValue2: boolean = <boolean>false;
  // 会員生協価格一覧
  public coopPriceList: Array<any> = new Array<any>();
  // 供給（今回）
  public allthistimeSupplyPrice: string = <string>'';
  // 仕入（今回）
  public allthistimeCostPrice: string = <string>'';
  // 通常媒体フラグ(PLAN_GOODS_BASE)
  public RegularFlg: string = <string>'';
  public readonly REGULAR_FLG_ON: string = <string>'1';
  public readonly REGULAR_FLG_OFF: string = <string>'0';
  public readonly USE_REGULAR_FLAG_ON: string = <string>'1';
  public readonly USE_REGULAR_FLAG_OFF: string = <string>'0';
  // 会員生協タブ： アイテムコードが空かどうかを判別するリスト
  public coopPriceListItemCodeEmpty = new Array(
    {coopCode: this.kymw00Model.COOP_CODE_IB, flg: false}, 
    {coopCode: this.kymw00Model.COOP_CODE_TO, flg: false}, 
    {coopCode: this.kymw00Model.COOP_CODE_GU, flg: false},
    {coopCode: this.kymw00Model.COOP_CODE_TI, flg: false},
    {coopCode: this.kymw00Model.COOP_CODE_SA, flg: false},
    {coopCode: this.kymw00Model.COOP_CODE_TK, flg: false},
    {coopCode: this.kymw00Model.COOP_CODE_NA, flg: false},
    {coopCode: this.kymw00Model.COOP_CODE_NI, flg: false},
  );

  /**
   * 詳細情報タブ保持データ
   */
  // 詳細情報
  public coopDetailList: Array<any> = new Array<any>();
  // 産地コメント操作ロック（不要？）
  public producingAreaCommentLock: boolean = <boolean>true;
  // 表組用商品名
  public listingGoodsName: string = <string>'';
  // 表組用項目リスト
  public listingItemList: Array<any> = new Array<any>();
  public readonly DETAIL_USE_REGULAR_FLAG_ON: string = <string>'1';
  public readonly DETAIL_USE_REGULAR_FLAG_OFF: string = <string>'0';

  /**
   * マーク情報タブ保持データ
   */
  // マーク情報
  public markList: Array<any> = new Array<any>();
  // 選択マーク情報
  public selectedMarkList: Array<any> = new Array<any>();
  // 活性非活性フラグ
  public markFlag: boolean = <boolean>false;
  // マーク1ヘッダー
  public mark1Header: string = <string>'';
  // マーク3ヘッダー
  public mark3Header: string = <string>'';
  // マーク4ヘッダー
  public mark4Header: string = <string>'';
  // マーク5ヘッダー
  public mark5Header: string = <string>'';

  /**
   * 付加情報タブ、保健機能タブ保持データ
   */
  // 文字情報種別1～21
  public textInfoDivArray: Array<any> = new Array(21);
  // 文字情報連番1～21
  public textKindNumArray: Array<any> = new Array(21);
  // 商品説明
  public textInfo1: string = <string>'';
  // キャッチコピー
  public textInfo2: string = <string>'';
  // おすすめコメント(吹き出し)
  public textInfo3: string = <string>'';
  // 便利情報（囲み）
  public textInfo4: string = <string>'';
  // 便利情報（商品構成内容）
  public textInfo5: string = <string>'';
  // 便利情報（その他）
  public textInfo6: string = <string>'';
  // 便利情報（ｅフレンズ）
  public textInfo7: string = <string>'';
  // 便利情報（サイズ他）
  public textInfo8: string = <string>'';
  // 取扱注意
  public textInfo9: string = <string>'';
  // バイヤーコメント
  public textInfoA: string = <string>'';
  // EC用商品説明
  public textInfoB: string = <string>'';
  // 便利情報（月齢情報）
  public textInfoC: string = <string>'';
  // 人気商品情報
  public textInfoD: string = <string>'';
  // 健康管理情報
  public textInfoE: string = <string>'';
  // 成分情報
  public textInfoF: string = <string>'';
  // 吸水量
  public textInfoG: string = <string>'';
  // 調理時間の目安
  public textInfoH: string = <string>'';
  // 〇人前情報
  public textInfoI: string = <string>'';
  // 材料
  public textInfoJ: string = <string>'';
  // ご家庭で用意いただくもの
  public textInfoK: string = <string>'';
  // 前回の文字情報
  public oldTextInfoList: Array<any> = new Array(10);

  /**
   * 発注物流タブ保持データ
   */
  // 臭い商品区分
  public stinkGoodsDiv: string = <string>'';
  // ケース供給区分
  public caseSupplyDiv: string = <string>'';
  // 長期保存区分
  public longKeepDiv: string = <string>'';
  // 入荷場所区分
  public arrivalAreaDiv: string = <string>'';
  // 入荷許可品温
  public arrivalGoodsTemp: string = <string>'';
  // 入荷管理日数
  public arrivalAdminDays: string = <string>'';
  // 業態区分
  public dutiesFormDiv: string = <string>'';
  // 業態区分（デイリー）
  public dutiesFormDailyDiv: string = <string>'';
  // 業態区分（スポット）
  public dutiesFormSpotDiv: string = <string>'';

  /**
   * 組合員の声タブ保持データ
   */
  // 一括反映（組合員の声）
  public inquiryContentsAll: string = <string>'';
  // 一括反映（受付番号）
  public receiptNumAll: string = <string>'';
  // 生協コード1～8
  public coopCodeArray: Array<any> = new Array<any>(9);
  // 生協名称1～8
  public coopNameArray: Array<any> = new Array<any>(9);
  // 生協選択ロック1～8
  public selectLockArray: Array<any> = new Array<any>(9);
  // 生協選択フラグ1～8
  public selectValueArray: Array<any> = new Array<any>(9);
  // 組合員の声1～8
  public inquiryContentsArray: Array<any> = new Array<any>(9);
  // 組合員の声1～8(変更前)
  public inquiryContentsArrayBefore: Array<any> = new Array<any>(9);
  // 受付番号1～8
  public receiptNumArray: Array<any> = new Array<any>(9);
  // 組合員の声押下ボタン（いばらき：0 ～ にいがた：7、一括反映：-1）
  public selectInquiryContentsButton: number = <number>-1;
  // 組合員の声（各会員生協から呼び出された『組合員の声選択』画面からの戻り値）
  public selectInquiryContents: string = <string>'';
  // 受付番号（各会員生協から呼び出された『組合員の声選択』画面からの戻り値）
  public selectReceiptNum: string = <string>'';
  // データバインド用
  public selectValue1: boolean = <boolean>false;
  public selectValue2: boolean = <boolean>false;
  public selectValue3: boolean = <boolean>false;
  public selectValue4: boolean = <boolean>false;
  public selectValue5: boolean = <boolean>false;
  public selectValue6: boolean = <boolean>false;
  public selectValue7: boolean = <boolean>false;
  public selectValue8: boolean = <boolean>false;

  /**
   * 計画数タブ保持データ
   */
  // 計画ＰＩ値
  public planPInum: string = <string>'';
  // 計画数一覧
  public planList: Array<any> = new Array<any>();
  // 計画数一覧（退避）
  public planListBackup: Array<any> = new Array<any>();
  // 計画数一覧(値変更時の比較用。直前のデータを保持する)
  public oldPlannumList: Array<any> = new Array<any>();
  public oldLimitnumPersonList: Array<any> = new Array<any>();
  public oldLimitnumTotalList: Array<any> = new Array<any>();
  // 合計計画数
  public plannumTotal: string = <string>'';

  /**
   * 案内タブ保持データ
   */
  // 案内一覧
  public guideList: Array<any> = new Array<any>();
  // 次回案内媒体区分リスト
  public nextGuideMediumTypeList: Array<any> = new Array<any>();

  /**
   * 保健機能タブ保持データ
   */
  // 届出番号 誌面掲載フラグ
  public licencedNoValue: boolean = <boolean>false;
  // 届出番号
  public licencedNo: string = <string>'';
  // 届出表示・許可表示
  public licencedDescription: string = <string>'';
  // 届出表示・許可表示
  public licencedDescriptionDef: string = <string>'';
  // 届出表示・許可表示固定メッセージ
  public descriptionMsg: string = <string>'';

  /**
   * プロモ設定タブ保持データ
   */
  // 商品会員生協供給価格
  public coopSupplyPriceList: GetGoodsSupplyPriceResponse[] = [];

  // 抽選商品プロモーション： このプロモーション設定を使用するフラグ
  public lotteryPromotionFlg: boolean = <boolean>false;
  // 抽選商品プロモーション： 抽選商品基本マスタVOリスト
  public planGoodsLotteryList: Array<any> = new Array<any>();

  // ポイント交換商品プロモーション： 注文コード割当コード一覧
  public pointExchangeOrderNumQuotaCodeList: Array<any> = new Array<any>();
  // ポイント交換商品プロモーション： このプロモーション設定を使用するフラグ
  public pointPromotionFlg: boolean = <boolean>false;
  // ポイント交換商品情報リスト
  public pointExchangeList: Array<any> = new Array<any>();
  // ポイント交換商品情報リスト 画面表示用
  public pointExchangeListDisplay: Array<any> = new Array<any>();
  // ポイント交換商品プロモーション： 追加ボタン活性制御
  public pointExchangeAddDisable: boolean = <boolean>false;

  // 1物N価媒体プロモーション： 注文コード割当コード一覧
  public nvalOrderNumQuotaCodeList: Array<any> = new Array<any>();
  // 1物N価媒体プロモーション： このプロモーション設定を使用するフラグ
  public nvalPromotionFlg: boolean = <boolean>false;
  // 1物N価媒体プロモーション： 受注コードリスト
  public nvalOrderCodeList: Array<any> = new Array<any>();
  // 1物N価媒体プロモーション： 1物N価媒体プロモーション情報リスト
  public nvalPromotionList: Array<any> = new Array<any>();
  // 1物N価媒体プロモーション： 1物N価媒体プロモーション情報リスト 画面表示用
  public nvalPromotionListDisplay: Array<any> = new Array<any>();
  // 1物N価媒体プロモーション： 媒体リスト
  public nvalMediumTypeList: Array<GetSelectedNvalMediumListResponse> = new Array<GetSelectedNvalMediumListResponse>();
  // 1物N価媒体プロモーション： 追加ボタン活性制御
  public nvalAddDisable: boolean = <boolean>false;
  // 1物N価媒体プロモーション： 1物N価詳細区分リスト
  public nvalDetailDevList: Array<any> = new Array<any>();
  // 1物N価媒体プロモーション： 束ね期間VOリスト
  public nvalBundlePeriodVOList: Array<any> = new Array<any>();

  // クーポン商品プロモーション： 注文コード割当コード一覧
  public couponOrderNumQuotaCodeList: Array<any> = new Array<any>();
  // クーポン商品プロモーション： このプロモーション設定を使用するフラグ
  public couponPromotionFlg: boolean = <boolean>false;
  // クーポン商品プロモーション： クーポンプロモーション情報リスト
  public couponPromotionList: Array<any> = new Array<any>();
  // クーポン商品プロモーション： クーポンプロモーション情報リスト 画面表示用
  public couponPromotionListDisplay: Array<any> = new Array<any>();
  // クーポン商品プロモーション： 追加ボタン活性制御
  public couponPromotionAddDisable: boolean = <boolean>false;

  public static readonly DISCOUNT_PRICE_FORMAT = '本体　{0}円（税込　{1}円）';
  public static readonly DISCOUNT_UNIT_PRICE_SUFFIX = '円引きクーポン';
  public static readonly DISCOUNT_RATE_SUFFIX = '％引きクーポン';

  /**
   * タグタブ保持データ
   */
  // タグ一覧
  public tagList: Array<any> = new Array<any>();

  /**
   * EC設定タブ保持データ
   */
  // 企画商品EC情報： 広告用フラグ
  public cmFlg: boolean = <boolean>false;
  // 企画商品EC情報： おすすめフラグ
  public recommendFlg: boolean = <boolean>false;
  // 企画商品EC情報： 購入限度額表示フラグ
  public orderLimitFlg: boolean = <boolean>false;
  // 企画商品EC情報： Web限定フラグ
  public webLimitFlg: boolean = <boolean>false;
  // 企画商品EC情報： おすすめコメント表示フラグ
  public recommendCommentFlg: boolean = <boolean>false;
  // 企画商品EC情報： 注文トラン商品区分
  public orderGoodsDiv: string = <string>'';
  // 企画商品EC情報： 最低注文数
  public minOrderNum: string = <string>'';
  // 企画商品EC情報： 最高注文数
  public maxOrderNum: string = <string>'';
  // 企画商品EC情報： 非表示フラグ
  public nonDispFlg: boolean = <boolean>false;
  // EC使用画像情報： EC使用画像リスト
  public imageList: Array<any> = new Array<any>();
  // EC使用画像情報： 取扱生協リスト
  public enableCoopList: Array<any> = new Array<any>();
  // EC使用画像情報： 選択生協コード
  public selectCoopImage: string = <string>'';
  // EC使用画像情報： 画像リストマップ
  public imageMap: any = new Object();
  // 在庫数情報： 在庫限定フラグ
  public stockLimitFlg: boolean = <boolean>false;
  // 在庫数情報： 在庫数(合計)
  public stockNumTotal: string = <string>'';
  // 在庫数情報： 初期在庫数非表示フラグ
  public stockNumShowFlg: boolean = <boolean>false;
  // 在庫数情報： ブランド名
  public brandName: string = <string>'';
  // 在庫数情報： 在庫リスト
  public stockList: Array<any> = new Array<any>();
  // グルーピング情報： グルーピングコード
  public groupingCode: string = <string>'';
  // グルーピング情報： グルーピングリスト
  public groupingList: Array<any> = new Array<any>();
  // グルーピング情報： グルーピングコードリスト
  public groupingCodeList: Array<any> = new Array<any>();
  // Webリンク情報： コープ商品URLタイトル
  public coopGoodsUrlTitle: string = <string>'';
  // Webリンク情報： コープ商品URL
  public coopGoodsUrl: string = <string>'';
  // Webリンク情報： 関連情報URLタイトル
  public relatedUrlTitle: string = <string>'';
  // Webリンク情報： 関連情報URL
  public relatedUrl: string = <string>'';

  /**
   * アイコン設定タブ保持データ
   */
  // アイコン情報：すべての生協に同一の設定
  public allcoopValueIcon: boolean = <boolean>false;
  // アイコン情報一覧
  public iconList: Array<any> = new Array<any>();
  // 選択アイコン情報一覧
  public selectedIconList: Array<any> = new Array<any>();
  // アイコン情報一覧非活性フラグリスト (アイテムコードが未入力の場合、true)
  public iconListDisable = new Array<boolean>();

  /**
   * 予約設定タブ保持データ
   */
  // 予約設定情報： 表示フラグ
  public preOrderFlag = false;
  // 予約設定情報： 商品計画数予測リスト
  public goodsPlanNumList = [];
  // 予約設定情報： 予約詳細情報リスト
  public preOrderDetailList = [];
  // 予約設定情報： 予約詳細情報リスト 画面表示用
  public preOrderDetailListDisplay = [];
  // 予約設定情報： 予約詳細情報リスト 全選択
  public goodsPlanNumListEnableFlgAll = false;
  // 予約設定情報： 注文コード割当コードリスト
  public preOrderOrderNumQuotaCodeList = [];
  // 予約設定情報： 取り扱われていない生協名
  public notUseCoopName: string = <string>'';
  // 予約設定情報： 価格パターンに対応する供給単価（0:通常、1:特価１、2:特価２、3:特価３）
  public preOrderSupplyPriceList = [];
  /**
   * 代表生協順（さ、い、と、ぐ、ち、とう、な、に）
   */
  public coopDaihyoOrder = [
    this.kymw00Model.COOP_CODE_SA,
    this.kymw00Model.COOP_CODE_IB,
    this.kymw00Model.COOP_CODE_TO,
    this.kymw00Model.COOP_CODE_GU,
    this.kymw00Model.COOP_CODE_TI,
    this.kymw00Model.COOP_CODE_TK,
    this.kymw00Model.COOP_CODE_NA,
    this.kymw00Model.COOP_CODE_NI,
  ]

  /**
   * アイテム情報保持データ
   */
  // アイテムリスト
  public itemCodeList: Array<any> = new Array<any>();
  // アイテムコード情報リスト（アイテムコード毎のアイテム情報）
  public itemCodeInfoList: Array<any> = new Array<any>();
  // アイテムコード情報リスト（アイテムコード毎の栄養成分操作情報）
  public itemCodeNutritionalInfoList: Array<any> = new Array<any>();
  // 複数栄養成分タブ 分析単位データグリッドの選択中の行(index)
  public selectedDtgNutrientUnitListMultiIndex: number = <number>0;

  /**
   * アイテムコード情報（表示用）
   */
  // アイテムコードの選択位置
  public selectedItemCodeIndex: number = <number>0;
  // アイテムコード
  public itemCode: string = <string>'';
  // JANコード
  public janCode: string = <string>'';
  // JANコード識別フラグ
  public janCodeDiv: boolean = <boolean>false;
  // 配達企画回
  public delivCatalogID: string = <string>'';
  // ＦＣ・ＭＣ手数料
  public fcmcFee: string = <string>'';
  // 特殊発注区分
  public specialOrderType: string = <string>'';
  // 在庫繰越区分
  public stockType: string = <string>'';
  // 分納指定回数
  public installmentTimes: string = <string>'';
  // 物流滞留日数
  public pdPilingUpDays: string = <string>'';
  // ＩＴＦコード
  public itfCode: string = <string>'';
  // 発注単位区分
  public orderUnitType: string = <string>'';
  // メーカー希望小売価格(参考)区分
  public makerType: string = <string>'';
  // メーカー希望小売価格(参考)価格
  public makerPrice: string = <string>'';
  // 発注先取引先
  public orderClientCode: string = <string>'';
  // 発注先取引先名称
  public orderClientName: string = <string>'';
  // 支払先取引先
  public payeeClientCode: string = <string>'';
  // 支払先取引先名称
  public payeeClientName: string = <string>'';
  // 価格バンドル
  public bundlePrice: string = <string>'';
  // 確定入数
  public fixContainNum: string = <string>'';
  // 組数
  public setQuantity: string = <string>'';
  // ｅＢＡＳＥ仕様書No
  public ebaseSpecCode: string = <string>'';
  // 仕様書適用日
  public specApplyDate: string = <string>'';
  // メーカー名称
  public makerName: string = <string>'';
  // メーカー名称表示
  public makerNamePublishType: boolean = <boolean>false;
  // ピースサイズ（縦）
  public peaceSizeLength: string = <string>'';
  // ピースサイズ（横）
  public peaceSizeWidth: string = <string>'';
  // ピースサイズ（高）
  public peaceSizeHight: string = <string>'';
  // ピース重量
  public peaceWeight: string = <string>'';
  // ケースサイズ（縦）
  public caseSizeLength: string = <string>'';
  // ケースサイズ（横）
  public caseSizeWidth: string = <string>'';
  // ケースサイズ（高）
  public caseSizeHight: string = <string>'';
  // ケース重量
  public caseWeight: string = <string>'';
  // 文字情報種別1
  public specTextInfoDiv1: string = <string>'';
  // 原産国加工地
  public stringValue1: string = <string>'';
  // 文字情報種別2
  public specTextInfoDiv2: string = <string>'';
  // 原材料情報
  public stringValue2: string = <string>'';
  // 文字情報種別3
  public specTextInfoDiv3: string = <string>'';
  // コンタミ情報
  public stringValue3: string = <string>'';
  // 文字情報種別4
  public specTextInfoDiv4: string = <string>'';
  // カロリー情報
  public stringValue4: string = <string>'';
  // 文字情報種別5
  public specTextInfoDiv5: string = <string>'';
  // 添加物情報
  public stringValue5: string = <string>'';
  // 遺伝子組換表示区分
  public geneRecombinationDiv: string = <string>'';
  // 文字情報種別6
  public specTextInfoDiv6: string = <string>'';
  // 遺伝子組換
  public stringValue6: string = <string>'';
  // アレルゲン調査対象
  public allergenTergetType: string = <string>'';
  // アレルゲン情報
  public allergenInfo: Array<any> = new Array<any>();
  // アレルゲン活性非活性フラグ
  public allergenFlag: boolean = <boolean>false;
  // 分析単位
  public analysisUnit: string = <string>'';
  // 熱量(Kcal)
  public calolie: string = <string>'';
  // たんぱく質(g)
  public protein: string = <string>'';
  // 脂質(g)
  public lipid: string = <string>'';
  // 炭水化物(g)
  public carbohydrate: string = <string>'';
  // ナトリウム(mg)
  public sodium: string = <string>'';

  // [栄養成分タブ] 表示用・分析単位リスト
  // 分析連番：String
  // 分析単位：String
  public nutrientUnitList: Array<any> = new Array<any>();

  // [栄養成分タブ] 表示用・栄養成分詳細リスト
  // 栄養成分詳細：Object
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  // 表示区分：String
  // 階層：String
  public nutrientDetailList: Array<any> = new Array<any>();

  // [栄養成分タブ] 表示用・栄養成分備考
  public nutrientNote: string = <string>'';

  // [栄養成分タブ] 複数栄養成分あり
  public hasMultiNutrientInfo: boolean = <boolean>false;

  // [栄養成分タブ] 栄養成分情報 hidden
  // 栄養成分情報リスト：Array<any>
  // 栄養成分情報：Object
  // 分析連番：String
  // 分析単位：String
  // 栄養成分備考：String
  // 栄養成分詳細リスト：Array<any>
  // 栄養成分詳細：Object
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  // 表示区分：String
  // 階層：String
  public hiddenNutrientComponentList: Array<any> = new Array<any>();


  // [複数栄養成分タブ] 表示用・分析単位リスト
  // 分析連番：String
  // 分析単位：String
  public nutrientUnitListMulti: Array<any> = new Array<any>();

  // [複数栄養成分タブ] 表示用・栄養成分詳細リスト
  // 栄養成分詳細：Object
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  // 表示区分：String
  // 階層：String
  public nutrientDetailListMulti: Array<any> = new Array<any>();

  // [複数栄養成分タブ] 表示用・栄養成分備考
  public nutrientNoteMulti: string = <string>'';

  // [複数栄養成分タブ] 栄養成分情報 hidden
  // 栄養成分情報リスト：Array<any>
  // 栄養成分情報：Object
  // 分析連番：String
  // 分析単位：String
  // 栄養成分備考：String
  // 栄養成分詳細リスト：Array<any>
  // 栄養成分詳細：Object
  // 栄養成分名：String
  // 栄養成分量：String
  // 栄養成分単位：String
  // 表示区分：String
  // 階層：String
  public hiddenNutrientComponentListMulti: Array<any> = new Array<any>();

  // 栄養成分情報  アイテム毎に分析連番の最大値を保持
  public saveAnalysisSeqNo: Array<any> = new Array<any>();
  // コードマスタＰ栄養情報リスト(栄養成分新規登録で使用する元データ)
  public codeMasterpNutritionalList: Array<any> = new Array<any>();

  // マークグループ
  public markGroupList: Array<any> = new Array<any>();
  // マークグループ選択値
  public markGroup: string = null;
  // マーク情報
  public markInfoList: Array<any> = new Array<any>();
  // マーク情報（初期情報保持）
  public markInfoListMain: Array<any> = new Array<any>();

  // 環境区分なし／あり
  public ecologyDiv: string = <string>'';
  public goodsEcologyFlag: boolean = <boolean>false;
  // 環境区分
  public goodsEcology: Array<any> = new Array<any>();

  // 温暖化防止
  public goodsGWStop: Array<any> = new Array<any>();
  // 容器包装材
  public containPackingList: Array<any> = new Array<any>();
  public containPacking: Array<any> = new Array<any>();
  // 文字情報種別1～6
  public textInfoDivItemArray: Array<any> = new Array(9);
  // 文字情報一覧
  public mediumTextList: Array<any> = new Array<any>();

  /**
   * コンテンツ情報
   */
  // アレルゲンリスト（連想配列）
  public allergenListContents: Array<any> = new Array<any>();
  // 会員生協リスト（連想配列）
  public coopListContents: Array<any> = new Array<any>();
  // 環境区分リスト（連想配列）
  public ecologyDivListContents: Array<any> = new Array<any>();
  // 温暖化防止関連商品リスト（連想配列）
  public gwStopGoodsListContents: Array<any> = new Array<any>();
  // 容器包装材リスト（連想配列）
  public containListContents: Array<any> = new Array<any>();
  // 価格バンドル（連想配列）
  public bundlePriceListContents: Array<any> = new Array<any>();
  // 供給促進マークリスト：全体を管理（連想配列）
  public promoteMarkListContents: Array<any> = new Array<any>();
  // 連想配列キーの連結文字
  public DELIMITER: string = <string>' ';
  // 背景色切替用受注コード
  public backgroundColorOrderCode: string = <string>'';
  // 背景色(CommonSettingから取得した背景色)
  public backgroundColor: string = getComputedStyle(document.documentElement).getPropertyValue('--contents-background-color');
  // デフォルト消費税区分
  public defaultConsumeTaxDiv: string = <string>'';
  // デフォルト消費税率
  public defaultConsumeTaxRate: string = <string>'';
  // Wjimoグリッド内のコントロールの活性非活性
  public isDisabledForGrid: boolean = <boolean>false;
  // 企画確定後フラグ（EC設定タブ、アイコンタブで項目を活性化するために使用する）
  public isConfirmed: boolean = <boolean>false;
  // 企画確定後フラグ（プロモ設定タブで項目を活性化するために使用する）
  public isConfirmedForPromo: boolean = <boolean>false;

  // -------------------------------
  // 処理
  // -------------------------------

  /**
   * 編集カウントをインクリメント
   */
  public addEditCount(): void {
    // 編集カウントをインクリメント
    this.kymw0900Component.editCount++;
  }

  /**
   * 初期画面表示処理
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setINITScreen(serverData: any): void {
    this.setItemCodeList(serverData.getItemCodeListVO);
    this.setPlanGoodsBase(serverData.getPlanGoodsBaseVO);
    this.setItemGridContent(serverData.resultItemGridContentDataVO);
    this.setPlanGoodsItem(serverData.getPlanGoodsItemVO);
  }


  /**
   * アイテムコード設定
   *
   * @param {*} itemCodeListVO
   * @memberof KYMW0900Model
   */
  public setItemCodeList(itemCodeListVO: any): void {

    // サーバからの受信データに値が入っているか確認する
    if (itemCodeListVO != null) {

      const responseList: Array<any> = itemCodeListVO.ItemCodeList;
      const tempItemCodeList: Array<any> = new Array<any>();

      for (let i = Number(0); i < responseList.length; i++) {
        const ob: any = new Array<any>();
        ob.ItemCode = responseList[i].ItemCode;
        tempItemCodeList.push(ob);
      }

      this.itemCodeList = tempItemCodeList;
      this.selectedItemCode = responseList[0].ItemCode;

      // 初期表示データ（アイテムコード一覧）を設定
      this.initItemCodeList = itemCodeListVO;

      // 価格パターンを設定
      this.pricePatternList = this.updateCodeList(itemCodeListVO.PricePatternList, true);

      // ブランド区分を設定
      this.brandTypeList = this.updateCodeList(itemCodeListVO.BrandTypeList, true);

      // セット区分を設定
      this.setDivList = this.updateCodeList(itemCodeListVO.SetDivList, true);

      // 仕分温度帯区分を設定
      this.assortTempDivList = this.updateCodeList(itemCodeListVO.AssortTempDivList, true);

      // 登場区分を設定
      this.appearDivList = this.updateCodeList(itemCodeListVO.ApperDivList);

      // 注文コード割当を設定
      if (itemCodeListVO.OrderNumQuota != null) {
        this.updateOrderNumQuotaList(itemCodeListVO.OrderNumQuota);
      }
    } else {
      // 画面制御を設定（初期表示時の閲覧モードと表示は違う）
      this.setScreenModeInfo();
    }
  }

  /**
   * 閲覧モードを設定
   *
   * @memberof KYMW0900Model
   */
  public setScreenModeInfo(): void {
    // エラーメッセージを表示する。
    this.kymw0900Component.dialogServiceSub.openAlertGetMessage('S0101', ['']);

    // 閲覧モードを設定
    this.kymw0900Component.setScreenMode('true');
    this.kymw0900Component.cmb_PCode.nativeElement.disabled = true;
  }


  /**
   * 企画商品（Ｐコード情報）設定
   *
   * @private
   * @param {*} serverData
   * @memberof KYMW0900Model
   */
  private setPlanGoodsBase(planGoodsBaseVO: any): void {

    // サーバからの受信データに値が入っているか確認する
    if (planGoodsBaseVO != null) {
      // アイテムコードが取得されていれば、企画商品（Ｐコード情報）を表示
      if (this.initItemCodeList != null) {

        // Ｐコード共通データ設定
        this.setPCodeCommon(planGoodsBaseVO);
        // Ｐコード基本情報タブデータ設定
        this.setPCodeBase(planGoodsBaseVO);
        // Ｐコード会員生協タブデータ設定
        this.setPCodeCoop(planGoodsBaseVO);
        // Ｐコード詳細情報タブデータ設定
        this.setPCodeDetail(planGoodsBaseVO);
        // Ｐコードマークタブデータ設定
        this.setPCodeMark(planGoodsBaseVO);
        // Ｐコード付加情報タブデータ設定
        this.setPCodeTextInfo(planGoodsBaseVO);
        // Ｐコード発注物流タブデータ設定
        this.setPCodeOrderPD(planGoodsBaseVO);
        // Ｐコード組合員の声タブデータ設定
        this.setPCodePublishVoice(planGoodsBaseVO);
        // Ｐコード計画数タブデータ設定
        this.setPCodePlanNum(planGoodsBaseVO);
        // Ｐコード案内タブデータ設定
        // this.setPCodeGuide(planGoodsBaseVO);
        // Ｐコードアイコンタブデータ設定
        this.setPCodeIcon(planGoodsBaseVO);

        // 部門コードの初期値設定
        this.kymw0900Component.cmb_ClassCode.setClassCode(this.classCode);
        // 大分類の初期値設定
        this.kymw0900Component.cmb_LargeClassCode.setLargeClassCode(this.largeClassCode);
        // 中分類の初期値設定
        this.kymw0900Component.cmb_MiddleClassCode.setMiddleClassCode(this.middleClassCode);
        // // 小分類の初期値設定
        this.kymw0900Component.cmb_SmallClassCodeList.setSmallClassCode(this.smallClassCode);
        // 消費税区分の初期値設定
        this.kymw0900Component.cmb_ConsumeTaxDivList.setCodeValue(this.consumeTaxDiv);
        // サイクル期間の初期値設定
        this.kymw0900Component.cmb_CycleTerm.setCodeValue(this.cycleTerm);
        // ＥＤＬＰ商品区分の初期値設定
        this.kymw0900Component.cmb_EdlpDiv.setCodeValue(this.edlpDiv);
        // 商品案内温度帯区分の初期値設定
        this.kymw0900Component.cmb_RoomTempZoneDiv.setCodeValue(this.roomTempZoneDiv);
        // ユニットプライス区分の初期値設定
        this.kymw0900Component.cmb_UnitPriceDiv.setCodeValue(this.unitPriceDiv);
        // 目隠し区分の初期値設定
        this.kymw0900Component.cmb_BlindDiv.setCodeValue(this.blindDiv);
        // コマ配置予定区分の初期値設定
        this.kymw0900Component.cmb_KomaScheduleDiv.setCodeValue(this.komaScheduleDiv);
        // 酒類コードの初期値設定
        this.kymw0900Component.cmb_LiquorCode.setCodeValue(this.liquorCode);
        // 容器形態の初期値設定
        this.kymw0900Component.cmb_ContainerForm.setCodeValue(this.containerForm);
        // 臭い商品区分
        this.kymw0900Component.cmb_StinkGoodsDivList.setCodeValue(this.stinkGoodsDiv);
        // ケース供給区分
        this.kymw0900Component.cmb_CaseSupplyDivList.setCodeValue(this.caseSupplyDiv);
        // 長期保存区分
        this.kymw0900Component.cmb_LongKeepDivList.setCodeValue(this.longKeepDiv);
        // 入荷場所区分
        this.kymw0900Component.cmb_ArrivalAreaDivList.setCodeValue(this.arrivalAreaDiv);
        // 業態区分（デイリー）
        this.kymw0900Component.cmb_DutiesFormDailyDiv.setCodeValue(this.dutiesFormDailyDiv);
        // 業態区分（スポット）
        this.kymw0900Component.cmb_DutiesFormSpotDiv.setCodeValue(this.dutiesFormSpotDiv);
        // 届出表示・許可表示固定メッセージ
        this.licencedDescriptionDef = planGoodsBaseVO.PCodeTextInfo.DescriptionMsg;
      }
      // 初期表示データ（企画商品（Ｐコード情報））を設定
      this.initPlanGoodsBase = planGoodsBaseVO;
    }
    // 画面背景色の制御
    this.backgroundColorChange();
  }

  /**
   * 企画商品設定
   *
   * @param {*} serverData
   * @memberof KYMW0900Model
   */
  public setItemGridContent(serverData: any): void {

    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {

      // アレルゲンリスト（連想配列）の設定
      if (serverData.AllergenList != null) {
        const tempCollection: Array<any> = serverData.AllergenList;
        for (let i = Number(0); i < tempCollection.length; i++) {
          this.allergenListContents[PlessViewUtilsSub.nullToBlank(tempCollection[i].AllergenDiv)] = tempCollection[i];
        }
      }

      // 会員生協リスト（連想配列）の設定
      if (serverData.CoopList != null) {
        const tempCollection = serverData.CoopList;
        for (let i = Number(0); i < tempCollection.length; i++) {
          this.coopListContents[PlessViewUtilsSub.nullToBlank(tempCollection[i].CoopCode)] = tempCollection[i];
        }
      }
      // マークグループリストの初期化
      const tempGroupCodeList: Array<any> = new Array<any>();
      // 重複を除外するための連想配列を作成
      // マークグループリストの先頭に空白を設定
      let ob = {
        MarkGroup: '',
        MarkGroupName: '',
      };
      tempGroupCodeList.push(ob);

      // 供給促進マークリスト（Array<any>）の設定
      if (serverData.PromoteMarkList != null) {
        const tempMarkList: Array<any> = serverData.PromoteMarkList;

        for (let i = Number(0); i < tempMarkList.length; i++) {
          // マークグループリストの設定（２件目以降にグループコードを重複しないように設定）
          if (tempGroupCodeList.findIndex(({ MarkGroup }) => MarkGroup === tempMarkList[i].PromoteMarkGroupCode) === -1) {
            ob = {
              MarkGroup: tempMarkList[i].PromoteMarkGroupCode,
              MarkGroupName: tempMarkList[i].PromoteMarkGroupName
            };
            tempGroupCodeList.push(ob);
          }
        }
      }
      this.markGroupList = tempGroupCodeList;
      // 供給促進マークリスト（連想配列）の設定
      if (serverData.PromoteMarkList != null) {
        const tempCollection = serverData.PromoteMarkList;
        for (let i = Number(0); i < tempCollection.length; i++) {
          this.promoteMarkListContents[PlessViewUtilsSub.nullToBlank(tempCollection[i].PromoteMarkCode)] = tempCollection[i];
        }
      }
      // 環境区分リスト（連想配列）の設定
      if (serverData.EcologyDivList != null) {
        const tempCollection = serverData.EcologyDivList;
        for (let i = Number(0); i < tempCollection.length; i++) {
          this.ecologyDivListContents[PlessViewUtilsSub.nullToBlank(tempCollection[i].EcologyDiv)] = tempCollection[i];
        }
      }

      // 温暖化防止関連商品リスト（連想配列）の設定
      if (serverData.GWStopGoodsList != null) {
        const tempCollection = serverData.GWStopGoodsList;
        for (let i = Number(0); i < tempCollection.length; i++) {
          this.gwStopGoodsListContents[PlessViewUtilsSub.nullToBlank(tempCollection[i].GWStopGoodsDiv)] = tempCollection[i];
        }
      }
      // 容器包装材リスト（連想配列）の設定
      if (serverData.ContainList != null) {
        const tempCollection = serverData.ContainList;
        for (let i = Number(0); i < tempCollection.length; i++) {
          this.containListContents[PlessViewUtilsSub.nullToBlank(
            tempCollection[i].ContainDiv) + this.DELIMITER + PlessViewUtilsSub.nullToBlank(
              tempCollection[i].ContainKind)] = tempCollection[i];
        }
      }
      // 初期表示データ（企画商品（アイテムグリッド情報））を設定
      this.initItemGridContent = serverData;
    }
  }

  /**
   * 企画商品（アイテム情報）設定
   *
   * @param {*} planGoodsItemVO
   * @memberof KYMW0900Model
   */
  public setPlanGoodsItem(planGoodsItemVO: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (planGoodsItemVO != null) {
      // 企画商品（アイテムグリッド情報）、企画商品（Ｐコード情報）が取得されていれば、企画商品（アイテム情報）を表示
      if (this.initItemGridContent != null && this.initPlanGoodsBase != null) {
        if (planGoodsItemVO.ItemCodeList != null) {
          // アイテムコード情報リスト（アイテムコード毎のアイテム情報）を設定
          this.itemCodeInfoList = planGoodsItemVO.ItemCodeList;
          // 後の処理のために、複数栄養成分タブ用格納データの型の確認を行い、必要であれば型を変更する
          for (let i = Number(0); i < this.itemCodeInfoList.length; i++) {
            if (this.itemCodeInfoList[i].ItemCodeNutritionalMulti != null) {
              let kataArray: boolean = <boolean>true;
              let kataObj: boolean = <boolean>true;
              if (this.itemCodeInfoList[i].ItemCodeNutritionalMulti instanceof Array) {
                // 配列の場合
                kataArray = true;
              } else {
                // 配列以外の場合
                kataObj = true;
              }

              // 1件の場合はサーバ側からObject型で送られてくる -->> Array<any>にしたい
              if (kataObj && !kataArray) {
                // 1件目の各項目を一時保存
                const retObj = {
                  AnalysisSeqNo: this.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.AnalysisSeqNo,
                  AnalysisUnit: this.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.AnalysisUnit,
                  NutrientComponentList: this.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.NutrientComponentList,
                  NutritionalNote: this.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.NutritionalNote,
                };
                // Array<any>に変更
                this.itemCodeInfoList[i].ItemCodeNutritionalMulti.List = Array<any>();
                // 一時保存した各項目の値を、Array<any>変更後に対して戻す
                this.itemCodeInfoList[i].ItemCodeNutritionalMulti.List.push(retObj);
              }
            }
          }

          // アイテムコード情報リスト（アイテムコード毎の栄養成分操作情報）の初期データを設定
          this.itemCodeNutritionalInfoList = new Array<any>();
          if (this.itemCodeInfoList.length > 0) {
            this.setPlanGoodsItemNutritional(this.itemCodeInfoList);
          }

          // コードマスタＰ栄養情報リストを設定
          this.setCodeMasterpNutritional(planGoodsItemVO.CodeMasterpNutritional.CodeMasterpNutritionalList);
          // アイテムコードの１件目を表示項目に設定
          if (this.itemCodeInfoList.length > 0) {
            this.setPlanGoodsItemForDisp(this.itemCodeInfoList,
              PlessViewUtilsSub.nullToBlank(this.itemCodeInfoList[0].ItemCodeCommon.ItemCode));
            // 価格バンドル（連想配列）の設定
            this.bundlePriceListContents = new Array<any>();
            for (let i = Number(0); i < this.itemCodeInfoList.length; i++) {
              this.bundlePriceListContents[PlessViewUtilsSub.nullToBlank(this.itemCodeInfoList[i].ItemCodeCommon.ItemCode)]
                = PlessViewUtilsSub.nullToBlank(this.itemCodeInfoList[i].ItemCodeBase.BundlePrice);
            }
          }
        }
        if (planGoodsItemVO.ItemCodeList != null) {
          const tempMarkInfo: Array<any> = planGoodsItemVO.ItemCodePromote.PromoteMarkList;
          // アイテムコード情報プロモーションマークタブデータ設定
          this.setItemCodePromote(tempMarkInfo);
        }
      }
      // 初期表示データ（企画商品（アイテム情報））を設定
      this.initPlanGoodsItem = planGoodsItemVO;
    }

    // 取得した商品企画メンテナンス情報を画面に反映する。
    // ①「基本情報タブ」を選択状態にする。（自動設定？）
    // ②「登録日」「更新日」の日時情報を表示する。
    // ③「アイテム情報編集」の「アイテムコード」をコード順の１つ目を表示状態にする。
    // ④「アイテムタブ」を選択状態にする。（自動設定？）
    // ⑤部門コードチェック処理を行う。
    // 部門コードを取得し、「詳細情報タブ」の産地コメント１、産地コメント２の入力状態を設定する。
    // 「01：農産」の場合、産地コメント1、2を入力可能にする。
    // 「01以外」の場合、産地コメント1、2を入力不可にする。
    this.changeHomeCommentProperties(this.classCode);
    // 価格一覧の仕入価格の計算を行う（価格バンドルの情報がそろったこのタイミングで計算する）
    this.updateCostPriceForBundleChange(this.bundlePrice, this.coopPriceList);
    // 価格一覧のアイテムコードで表示設定を行う
    this.updateCoopRelateDataInit();
    // 編集カウントをクリア
    this.kymw0900Component.clearEditCount();
  }

  /**
   * アイテムコード情報プロモーションタブデータ設定
   *
   * @private
   * @param {*} data
   * @memberof KYMW0900Model
   */
  private setItemCodePromote(data: any): void {

    // 供給促進マーク一覧（データグリッド）の初期化
    if (this.markInfoList === null) {
      this.markInfoList = new Array<any>();
      this.markInfoListMain = new Array<any>();
    }

    if (data != null) {
      // 供給促進マーク一覧（データグリッド）の設定
      const tempMarkInfo: Array<any> = data;
      const markInfoListMain: Array<any> = Array<any>();

      for (let i = Number(0); i < tempMarkInfo.length; i++) {
        const coopXml = {
          MarkCode: PlessViewUtilsSub.zeroPadding(3, PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMarkCode)),
          MarkGroupCode: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMarkGroupCode),
          MarkName: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMarkName),
          SelectValue1: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark0) === '1' ? true : false,
          SelectValue2: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark1) === '1' ? true : false,
          SelectValue3: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark2) === '1' ? true : false,
          SelectValue4: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark3) === '1' ? true : false,
          SelectValue5: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark4) === '1' ? true : false,
          SelectValue6: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark5) === '1' ? true : false,
          SelectValue7: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark6) === '1' ? true : false,
          SelectValue8: PlessViewUtilsSub.nullToBlank(tempMarkInfo[i].PromoteMark7) === '1' ? true : false,
        };
        markInfoListMain.push(coopXml);
      }
      this.markInfoList = PlessViewUtilsSub.getCloneArray(markInfoListMain);
      this.markInfoListMain = PlessViewUtilsSub.getCloneArray(markInfoListMain);
    }
  }

  /**
   * 仕入価格変更
   *
   * @param {String} viewBundlePrice
   * @param {Object} priceDataProvider
   * @memberof KYMW0900Model
   */
  public updateCostPriceForBundleChange(viewBundlePrice: string, priceDataProvider: any): void {

    // 価格バンドルを更新
    this.bundlePrice = viewBundlePrice;
    this.setBundlePriceForItemCode(this.selectedItemCode, this.bundlePrice);

    // 現在表示中の会員生協価格一覧（データグリッド）を取得
    const viewCoopPriceList: Array<any> = priceDataProvider;

    // 再作成用の会員生協価格一覧リストの初期化
    const tempCoopPriceList: Array<any> = new Array<any>();

    let settingCostPrice: number;
    for (let i = Number(0); i < viewCoopPriceList.length; i++) {
      const enabledB: string = <string>viewCoopPriceList[i].Enabled;
      if (enabledB === '0' || enabledB === 'false') {
        // 非活性の場合、そのままセット。
        tempCoopPriceList.push(viewCoopPriceList[i]);
        continue;
      }

      // 各会員生協のアイテムコードがアイテム情報編集のアイテムコードと同じ場合
      if (viewCoopPriceList[i].SelectItemCode === this.itemCode) {
        const costPric: string = <string>viewCoopPriceList[i].ThistimeCostPrice;
        if (PlessViewUtilsSub.isEmpty(costPric)) {
          // 表示内容をそのままセット
          settingCostPrice = Number(costPric);
        } else {
          // ・「今回仕入価格」と各生協に紐付くアイテム情報の価格バンドルを乗じた値を「仕入価格」にセット
          const tt = Number(costPric);
          const ss: number = this.getBundlePriceForItemCode(viewCoopPriceList[i].SelectItemCode);
          settingCostPrice = Number(Number(tt) * Number(ss.toFixed(2)));
        }
      } else {
        // 各会員生協のアイテムコードがアイテム情報編集のアイテムコードと異なる場合

        // 表示内容をそのままセット
        settingCostPrice = viewCoopPriceList[i].CostPrice;
      }

      const coopXml = {
        CoopCode: viewCoopPriceList[i].CoopCode,
        CoopNum: i,
        CoopName: viewCoopPriceList[i].CoopName,
        CoopShortName: viewCoopPriceList[i].CoopShortName,
        SelectValue: viewCoopPriceList[i].SelectValue,
        SelectItemCode: viewCoopPriceList[i].SelectItemCode,
        SelectPricePattern: viewCoopPriceList[i].SelectPricePattern,
        LSupplyPricecoefficient: viewCoopPriceList[i].LSupplyPricecoefficient,
        SupplyPricecoefficient: viewCoopPriceList[i].SupplyPricecoefficient,
        SupplyPriceSpecial1: viewCoopPriceList[i].SupplyPriceSpecial1,
        SupplyPriceSpecial2: viewCoopPriceList[i].SupplyPriceSpecial2,
        ThistimeSupplyPrice: viewCoopPriceList[i].ThistimeSupplyPrice,
        LCostPriceCoefficient: viewCoopPriceList[i].LCostPriceCoefficient,
        CostPriceCoefficient: viewCoopPriceList[i].CostPriceCoefficient,
        CostPriceSpecial1: viewCoopPriceList[i].CostPriceSpecial1,
        CostPriceSpecial2: viewCoopPriceList[i].CostPriceSpecial2,
        ThistimeCostPrice: viewCoopPriceList[i].ThistimeCostPrice,
        CostPrice: settingCostPrice,
        Enabled: viewCoopPriceList[i].Enabled,
        Caption: viewCoopPriceList[i].Caption,
        DealCoopDiv: viewCoopPriceList[i].DealCoopDiv,
        PromotionDiv: viewCoopPriceList[i].PromotionDiv,
        SupplyPriceToolTipText: viewCoopPriceList[i].SupplyPriceToolTipText,
        CostPriceToolTipText: viewCoopPriceList[i].CostPriceToolTipText,
        UseRegularFlg: viewCoopPriceList[i].UseRegularFlg,
        EnabledCheck: viewCoopPriceList[i].EnabledCheck,
      };
      tempCoopPriceList.push(coopXml);
    }
    // 作成したものを価格一覧（データグリッド）に再設定
    this.coopPriceList = tempCoopPriceList;
  }

  /**
   * 価格一覧の入力欄活性化
   *
   * @memberof KYMW0900Model
   */
  public enableCoopPrice(item: any) {
    item.Enabled = '1';
  }

  /**
   * 価格一覧の入力欄非活性化、入力値もクリアする
   *
   * @memberof KYMW0900Model
   */
  public disableCoopPrice(item: any) {
    item.Enabled = '0';
    item.LSupplyPricecoefficient = '';
    item.ThistimeSupplyPrice = '';
  }

  /**
   * 会員生協情報更新
   *
   * @memberof KYMW0900Model
   */
  public updateCoopRelateDataInit(): void {
    // ★1
    const priceList = this.coopPriceList;
    let coopCode: string = <string>'';
    let coopNum: number = <number>0;
    let selectItemCode: string = <string>'';

    for (let i = Number(0); i < priceList.length; i++) {

      selectItemCode = PlessViewUtilsSub.nullToBlank(priceList[i].SelectItemCode);
      coopCode = PlessViewUtilsSub.nullToBlank(priceList[i].CoopCode);
      coopNum = priceList[i].CoopNum;

      if (!(PlessViewUtilsSub.isEmpty(selectItemCode) || selectItemCode === '0')) {
        // ・会員生協タブ「マーク一覧」の当該会員生協の行の各マーク（001、005、010、999）を
        // 　チェック操作可能（活性化）にする。
        this.setCoopMarkListEnabled(coopCode, true);
      }

      // ・組合員の声タブの当該会員生協の「生協チェック」「組合員の声ボタン」「クリアボタン」を
      // 　操作可能（活性化）にする。
      this.setPublishHistoryEnabled(coopNum, true);

      // ・当該会員生協の「価格パターン」「今回供給価格」「今回仕入価格」の活性制御。
      if (this.RegularFlg === this.REGULAR_FLG_ON) {
        this.coopPriceList[i].EnabledCheck = true;
        if (this.coopPriceList[i].SelectValue && !PlessViewUtilsSub.isEmpty(this.coopPriceList[i].SelectItemCode) && this.coopPriceList[i].SelectItemCode !== 0) {
          // 価格パターンや今回供給価格、今回仕入価格は、「選択」と「アイテムコード」の両方が入力されているときに有効にする
          this.enableCoopPrice(this.coopPriceList[i]);
        } else {
          this.disableCoopPrice(this.coopPriceList[i]);
        }
      } else {
        this.disableCoopPrice(this.coopPriceList[i]);
      }

      // ・詳細情報タブ「情報一覧」の当該会員生協の行（ブランド区分、セット区分、仕分温度帯、
      // 　産地コメント１、産地コメント２）を入力可能（活性化）にする。
      // 　※尚、「産地コメント１、２」の入力可否（活性化）判断は、部門コードチェック処理で判断する。
      this.setCoopDetailListEnabled(coopCode, priceList[i].SelectValue);

      // ・計画数タブ「計画数一覧」の当該会員生協の行（計画数、限定数量総数、限定数量個人）を
      // 　入力可能（活性化）にする。
      // ・計画数タブ「計画数一覧」の合計行に、各会員生協の入力可能（活性化）状態の「計画数」合計と
      // 　「限定数量総数」合計を計算しセットする。
      this.setPlanNumListEnabled(coopCode, priceList[i].SelectValue);
    }
  }

  /**
   * 価格バンドル設定
   *
   * @param {string} itemCode
   * @param {string} bundleNum
   * @memberof KYMW0900Model
   */
  public setBundlePriceForItemCode(itemCode: string, bundleNum: string): void {
    if (this.bundlePriceListContents[itemCode] !== undefined) {
      this.bundlePriceListContents[itemCode] = bundleNum;
    }
  }

  /**
   * 価格バンドル取得
   *
   * @param {String} itemCode
   * @returns {int}
   * @memberof KYMW0900Model
   */
  public getBundlePriceForItemCode(itemCode: string): number {
    if (this.bundlePriceListContents[itemCode] !== undefined) {
      return Number(this.bundlePriceListContents[itemCode]);
    } else {
      return -1;
    }
  }

  /**
   * 【アイテムコード変更】
   * 価格一覧でアイテムコードが変更されたときに、関連する会員生協の
   * 情報を更新する
   * （ItemCodeComboBoxRendererからのコールバック）
   *
   */
  public updateCoopRelateData(selectCoopCode: string, selectItemCode: string, selectCoopNum: string): void {
    const index = this.coopPriceList.findIndex((coopPrice) => coopPrice.CoopCode === selectCoopCode);
    // ・会員生協別の「アイテムコード」の選択状態を判定する。
    // ①【未選択状態】（空白状態）の場合

    if (PlessViewUtilsSub.isEmpty(selectItemCode) || selectItemCode === '0') {
      // ・当該会員生協の「選択」をチェック解除状態にする。
      this.coopPriceList[index].SelectValue = false;
    } else {
      if (this.coopPriceList[index].EnabledCheck ) {
        // ・当該会員生協の「選択」をチェック状態にする。
        this.coopPriceList[index].SelectValue = true;
      }
      // ②【選択値有】の場合
      // ・会員生協タブ「マーク一覧」の当該会員生協の行の各マーク（001、005、010、999）を
      // 　チェック操作可能（活性化）にする。
      this.setCoopMarkListEnabled(selectCoopCode, true);

      // ・詳細情報タブ「情報一覧」の当該会員生協の行（ブランド区分、セット区分、仕分温度帯、
      // 　産地コメント１、産地コメント２）を入力可能（活性化）にする。
      // 　※尚、「産地コメント１、２」の入力可否（活性化）判断は、部門コードチェック処理で判断する。
      this.setCoopDetailListEnabled(selectCoopCode, true);
    }

    const target = this.kymw0900Component.itemRelatedCoop_CoopTab.find(_ => _.CoopCode == selectCoopCode);
    if (target) target.ItemCode = selectItemCode;

    // 選択チェックあり かつ アイテムコード選択時に 価格パターンなど入力欄を活性化
    if (this.coopPriceList[index].SelectValue && !PlessViewUtilsSub.isEmpty(selectItemCode) && selectItemCode !== '0') {
      this.enableCoopPrice(this.coopPriceList[index])
    } else {
      this.disableCoopPrice(this.coopPriceList[index])
    }
  }

  /**
   * 会員生協タブ「マーク一覧」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 会員生協コード
   * @param enabled  活性：true、非活性：false
   */
  private setCoopMarkListEnabled(coopCode: string, enabled: boolean): void {
    // 会員生協マーク一覧の再設定
    const coopMarkList: Array<any> = PlessViewUtilsSub.getCloneArray(this.kymw0900Component.coopMarkList);

    for (let i = Number(0); i < this.kymw0900Component.coopMarkList.length; i++) {
      // 当該会員生協の場合
      if (coopCode === this.kymw0900Component.coopMarkList[i].CoopCode) {
        if (enabled) {
          const coopXml = {
            CoopCode: PlessViewUtilsSub.nullToBlank(this.kymw0900Component.coopMarkList[i].CoopCode),
            CoopNum: i,
            CoopName: PlessViewUtilsSub.nullToBlank(this.kymw0900Component.coopMarkList[i].CoopName),
            Mark1Value: this.kymw0900Component.coopMarkList[i].Mark1Value,
            Mark2Value: this.kymw0900Component.coopMarkList[i].Mark2Value,
            Mark3Value: this.kymw0900Component.coopMarkList[i].Mark3Value,
            Mark4Value: this.kymw0900Component.coopMarkList[i].Mark4Value,
            Mark5Value: this.kymw0900Component.coopMarkList[i].Mark5Value,
            DealCoopDiv: this.kymw0900Component.coopMarkList[i].DealCoopDiv,
            Enabled: enabled ? '1' : '0',
          };
          coopMarkList.splice(i, 1, coopXml);
        } else {
          const coopXml = {
            CoopCode: PlessViewUtilsSub.nullToBlank(this.kymw0900Component.coopMarkList[i].CoopCode),
            CoopNum: i,
            CoopName: PlessViewUtilsSub.nullToBlank(this.kymw0900Component.coopMarkList[i].CoopName),
            Mark1Value: false,
            Mark2Value: false,
            Mark3Value: false,
            Mark4Value: false,
            Mark5Value: false,
            DealCoopDiv: this.kymw0900Component.coopMarkList[i].DealCoopDiv,
            Enabled: '0',
          };
          coopMarkList.splice(i, 1, coopXml);
        }
      }
      this.coopMarkList = coopMarkList;
      this.kymw0900Component.coopMarkList = coopMarkList;
    }
  }

  /**
   * 基本情報タブの税率コンボボックスの値を取得する
   *
   * @return  税率コンボボックスの値
   */
  public getConsumeTaxDiv(): string {
    return this.consumeTaxDiv;
  }

  /**
   * 基本情報タブの税率を取得する
   *
   * @return  税率
   */
  public getConsumeTaxDivRate(): string {
    return this.consumeTaxDivRate;
  }

  /**
   * 会員生協タブの価格項目ToolTip表示テキストを取得する
   *
   * @param taxDiv 消費税区分
   * @param taxDivRate
   * @param price
   * @return  toolTipテキスト
   */
  public getCoopPriceListToolTip(taxDiv: string, taxDivRate: string, price: string): string {
    let toolTipText: string = <string>'';

    if (PlessViewUtilsSub.isEmpty(price)) {
      return toolTipText;
    }
    const nPrice = Number(price);
    const nTax = Number(taxDivRate);

    switch (taxDiv) {
      case '9': // 内税
        toolTipText = taxDiv + ':内税・' + taxDivRate + '%・' + price + '・' + price;
        break;
      case '0': // 外税
        const calcResult = String((nPrice * (1 + (nTax / 100))).toFixed(2));
        toolTipText = taxDiv + ':外税・' + taxDivRate + '%・' + price + '・' + PlessViewUtilsSub.trailingZeroSuppress(calcResult, 0);
        break;
      case '1': // 免税
        toolTipText = taxDiv + ':免税・' + taxDivRate + '%・' + price + '・' + price;
        break;
      case '2': // 非課税
        toolTipText = taxDiv + ':非課税・' + taxDivRate + '%・' + price + '・' + price;
        break;
      case '3': // 課税対象外
        toolTipText = taxDiv + ':課税対象外・' + taxDivRate + '%・' + price + '・' + price;
        break;
      default:
        break;
    }
    return toolTipText;
  }

  public backgroundColorChange(): void {
    const taxChangeFlg: string = CommonSetting.getVal('TAX_CHANGE_FLG');			// 消費税切替可能フラグ
    const taxChangeOrderCode: string = CommonSetting.getVal('TAX_CHANGE_ORDER_CODE');	// 消費税切替受注コード
    const taxColorJudgeRate: string = CommonSetting.getVal('TAX_COLOR_JUDGE_RATE');		// 画面背景色切替判定消費税率
    const backgroundColorOrderCode: string = this.backgroundColorOrderCode;					// 背景色切替用受注コード
    const consumeTaxDivRate: string = this.consumeTaxDivRate;			// 消費税率
    const kymw0900MColorN: string = CommonSetting.getVal('KYMW0900_M_COLOR_N');		// 商品企画メンテナンス画面背景色(マスタ・通常税率)
    const kymw0900MColorR: string = CommonSetting.getVal('KYMW0900_M_COLOR_R');		// 商品企画メンテナンス画面背景色(マスタ・軽減税率)
    const kymw0900WColorN: string = CommonSetting.getVal('KYMW0900_W_COLOR_N');		// 商品企画メンテナンス画面背景色(ワーク・通常税率)
    const kymw0900WColorR: string = CommonSetting.getVal('KYMW0900_W_COLOR_R');		// 商品企画メンテナンス画面背景色(ワーク・軽減税率)

    // 消費税切替可能フラグが「1:切替可能」(消費税・並行稼働中)の場合

    if (taxChangeFlg === '1') {
      // 背景色切替用受注コードが、消費税切替受注コード よりも前の場合
      if (backgroundColorOrderCode < taxChangeOrderCode) {
        // 入力されている消費税率が、画面背景色切替判定消費税率と同じ場合
        if (consumeTaxDivRate === taxColorJudgeRate) {
          this.backgroundColor = kymw0900MColorN;
        } else {
          // 入力されている消費税率が、画面背景色切替判定消費税率と異なる場合
          this.backgroundColor = kymw0900MColorR;
        }
      } else {
        // 背景色切替用受注コードが、消費税切替受注コード 以降の場合
        // 入力されている消費税率が、画面背景色切替判定消費税率と同じ場合
        if (consumeTaxDivRate === taxColorJudgeRate) {
          this.backgroundColor = kymw0900WColorN;
        } else {
          // 入力されている消費税率が、画面背景色切替判定消費税率と異なる場合
          this.backgroundColor = kymw0900WColorR;
        }
      }
    } else {
      // 消費税切替可能フラグが「0:切替不可」(消費税・並行稼働終了)の場合
      // 入力されている消費税率が、画面背景色切替判定消費税率と同じ場合
      if (consumeTaxDivRate === taxColorJudgeRate) {
        this.backgroundColor = kymw0900MColorN;
      } else {
        // 入力されている消費税率が、画面背景色切替判定消費税率と異なる場合
        this.backgroundColor = kymw0900MColorR;
      }
    }
  }

  /**
 * デフォルト消費税情報取得
 * @param serverData デフォルト消費税情報のサーバ取得データ
 */
  public setConsumeTax(data: any): void {
    // 「消費税区分」、「消費税率」のチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw0900Component.cmb_ConsumeTaxDivList.selectedCodeValue)	// 「消費税区分」が未入力の場合
      && PlessViewUtilsSub.isEmpty(this.consumeTaxDivRate)) {
      // 「消費税率」が未入力の場合
      // 取得結果を反映する
      this.consumeTaxDiv = PlessViewUtilsSub.trim(data.DefaultConsumeTaxDiv);
      this.consumeTaxDivRate = data.DefaultConsumeTaxRate;
      this.kymw0900Component.cmb_ConsumeTaxDivList.setCodeValue(this.consumeTaxDiv);
    }
    // 画面背景色の制御
    this.backgroundColorChange();
  }

  /**
   * 詳細情報タブ「情報一覧」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 会員生協コード
   * @param enabled  活性：true、非活性：false
   */
  private setCoopDetailListEnabled(coopCode: string, enabled: boolean): void {

    // 現在表示中の詳細情報一覧（データグリッド）の設定
    const viewCoopDetailList = this.coopDetailList;
    const target = viewCoopDetailList.find(item => item.CoopCode === coopCode);
    // 非活性のときは、注文コード割当コードをクリアする
    target.OrderNumQuotaCode = !enabled || target.DetailUseRegularFlg !== this.DETAIL_USE_REGULAR_FLAG_ON ? '' : target.OrderNumQuotaCode;

    this.coopDetailList = viewCoopDetailList;
  }


  /**
   * 組合員の声タブの当該会員生協の活性／非活性を更新する
   *
   * @param coopCoop 各会員生協コード
   * @param disabled  活性：true、非活性：false
   * @param selectedBlank  会員タブ.価格一覧.アイテムコード空白：true、会員タブ.価格一覧.アイテムコード選択値有：false
   */
  public setPublishHistoryEnabled(coopCoop: number, disabled: boolean, selectedBlank: boolean = false): void {
    // 閲覧モード時の設定
    if (this.permission === '1') {
      disabled = false;
    }

    // ・組合員の声タブの当該会員生協の「生協チェック」「組合員の声ボタン」「クリアボタン」を
    // 　操作可能（活性化）／操作不可（非活性）にする。
    // ・非活性の場合は、組合員の声タブの当該会員生協の「生協チェック」をチェック解除状態にする。
    switch (coopCoop) {
      // いばらき
      case 0:
        if (!disabled) {
          this.selectValue1 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[0] = disabled;
        }
        break;
      // とちぎ
      case 1:
        if (!disabled) {
          this.selectValue2 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[1] = disabled;
        }
        break;
      // ぐんま
      case 2:
        if (!disabled) {
          this.selectValue3 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[2] = disabled;
        }
        break;
      // ちば
      case 3:
        if (!disabled) {
          this.selectValue4 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[3] = disabled;
        }
        break;
      // さいたま
      case 4:
        if (!disabled) {
          this.selectValue5 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[4] = disabled;
        }
        break;
      // とうきょう
      case 5:
        if (!disabled) {
          this.selectValue6 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[5] = disabled;
        }
        break;
      // ながの
      case 6:
        if (!disabled) {
          this.selectValue7 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[6] = disabled;
        }
        break;
      // にいがた
      case 7:
        if (!disabled) {
          this.selectValue8 = disabled;
        }
        if (this.permission === '1' || !selectedBlank) {
          this.selectLockArray[7] = disabled;
        }
        break;
    }
  }

  /**
   * 計画数タブ「計画数一覧」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 会員生協コード
   * @param enabled  活性：true、非活性：false
   * @param selectedBlank  会員タブ.価格一覧.アイテムコード空白：true、会員タブ.価格一覧.アイテムコード選択値有：false
   */
  public setPlanNumListEnabled(coopCode: string, disabled: boolean, selectedBlank: boolean = false): void {

    let coopXml = {};
    // 計画数（合計）
    let planNumTotal: number = <number>0;
    // 限定数量総数（合計）
    let limitnumTotal: number = <number>0;
    // 限定数量総数（個人）
    let limitnumPerson: number = <number>0;

    // 変更用
    const tempPlanList = this.planList;

    // 2行目以降にある当該会員生協の計画数を再設定
    for (let i = Number(1); i < this.planList.length; i++) {
      // 当該会員生協の場合
      if (coopCode === this.planList[i].CoopCode) {
        coopXml = ({
          CoopCode: this.planList[i].CoopCode,
          CoopName: this.planList[i].CoopName,
          PlanNumAiPrediction: this.planList[i].PlanNumAiPrediction,
          Plannum: disabled ? (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(this.planList[i].Plannum))
            ? '0' : this.planList[i].Plannum) : '',
          LimitnumTotal: disabled ? (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(this.planList[i].Plannum))
            ? '0' : this.planList[i].LimitnumTotal) : '',
          LimitnumPerson: disabled ? (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(this.planList[i].Plannum))
            ? '0' : this.planList[i].LimitnumPerson) : '',
          DeliveryLeadTimeType: this.planList[i].DeliveryLeadTimeType,
          DelivCatalogID: this.planList[i].DelivCatalogID,
          Enabled: selectedBlank ? this.planList[i].Enabled : PlessViewUtilsSub.booleanTOString(disabled),
        });
        tempPlanList.splice(i, 1, coopXml);
      }
      // 合計に加算
      planNumTotal += Number(this.planList[i].Plannum);
      limitnumTotal += Number(this.planList[i].LimitnumTotal);
      limitnumPerson += Number(this.planList[i].LimitnumPerson);
    }

    // 1行目に合計計画数を設定する
    coopXml = ({
      CoopCode: '',
      CoopName: '合計',
      PlanNumAiPrediction: this.planList[0].PlanNumAiPrediction,
      Plannum: String(planNumTotal),
      LimitnumTotal: limitnumTotal,
      LimitnumPerson: '',
      DeliveryLeadTimeType: '',
      DelivCatalogID: '',
      Enabled: '1',
    });
    tempPlanList.splice(0, 1, coopXml);

    // 比較用のリストに値を保持する
    this.planList = tempPlanList;
    this.setOldPlanList();
  }

  /**
   * 計画数の変更前データを設定する
   * 計画数の合計計算の実行判定で使用する
   */
  public setOldPlanList(): void {

    this.oldPlannumList = new Array<any>();
    this.oldLimitnumPersonList = new Array<any>();
    this.oldLimitnumTotalList = new Array<any>();
    this.planListBackup = new Array<any>();

    // 値が変更されたかチェックする
    for (let i = Number(1); i < this.planList.length; i++) {
      this.oldPlannumList.push(this.planList[i].Plannum);
      this.oldLimitnumPersonList.push(this.planList[i].LimitnumPerson);
      this.oldLimitnumTotalList.push(this.planList[i].LimitnumTotal);
    }

    // バックアップは合計行も含める
    for (let j = Number(0); j < this.planList.length; j++) {
      this.planListBackup.push({
        CoopCode: this.planList[j].CoopCode,
        CoopName: this.planList[j].CoopName,
        PlanNumAiPrediction: this.planList[j].PlanNumAiPrediction,
        Plannum: this.planList[j].Plannum,
        LimitnumTotal: this.planList[j].LimitnumTotal,
        LimitnumPerson: this.planList[j].LimitnumPerson,
        DeliveryLeadTimeType: this.planList[j].DeliveryLeadTimeType,
        DelivCatalogID: this.planList[j].DelivCatalogID,
        Enabled: this.planList[j].Enabled,
      });
    }
  }

  /**
   * 案内タブ「案内一覧」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 生協コード
   * @param enabled  活性：true、非活性：false
   */
  public setNextGuideListEnabled(coopCode: string, enabled: boolean): void {
    const guideList: Array<any> = this.guideList;

    // 会員生協マーク一覧の再設定
    for (let i = Number(0); i < this.guideList.length; i++) {
      // 当該会員生協の場合
      if (coopCode === this.guideList[i].CoopCode) {
        const coopXml = {
          CoopCode: this.guideList[i].CoopCode,
          CoopName: this.guideList[i].CoopName,
          OrderNum: this.guideList[i].OrderNum,
          AppearDiv: this.guideList[i].AppearDiv,
          // 次回案内（媒体） 
          // EC媒体は常に活性となるため、会員一覧で未選択の場合はEC媒体以外を非活性・空欄にする
          NextGuideMap: enabled ? this.guideList[i].NextGuideMap : this.setNextGuide_ECOnly(this.guideList[i].NextGuideMap),
          // 登場区分を活性にする（次回案内(媒体)は会員タブの選択チェック有無による）
          Enabled: '1',
        };
        guideList.splice(i, 1, coopXml);
        break;
      }
    }
    this.guideList = guideList;
  }

  /**
   * 案内タブ「案内一覧」
   * 次回案内（媒体）のEC媒体のみ表示する
   * @param nextGuideMap 
   * @returns 
   */
  private setNextGuide_ECOnly(nextGuideMap): Array<any> {
    const EC = this.nextGuideMediumTypeList.find(medium => medium.MediumType === 'EC0');
    const tempAry = new Array();
    for (const guide of Object.keys(nextGuideMap)) {
      if (guide == EC?.MediumType) {
        tempAry[guide] = nextGuideMap[guide];
      }
    }
    return tempAry;
  }

  /**
   *「詳細情報タブ」産地コメント入力属性変更
   *
   * @memberof KYMW0900Model
   */
  public changeHomeCommentProperties(viewClassCode: string): void {

    // 部門コードを設定
    this.classCode = viewClassCode;

    // 部門コードが「01：農産」の場合、入力可能とする
    if (viewClassCode === '01') {
      this.producingAreaCommentLock = false;
      for (const item of this.coopDetailList) {
        item.ProducingAreaComment1 = item.BackProducingAreaComment1;
        item.ProducingAreaComment2 = item.BackProducingAreaComment2;
      }
    } else {
      this.producingAreaCommentLock = true;
      for (const item of this.coopDetailList) {
        item.ProducingAreaComment1 = '';
        item.ProducingAreaComment2 = '';
      }
    }
  }


  /**
   * コードマスタＰ栄養成分情報を用意する
   *
   * @private
   * @memberof KYMW0900Model
   */
  private setCodeMasterpNutritional(data: any): void {

    if (data != null) {
      const nutritionalList: any = data;
      this.codeMasterpNutritionalList = new Array<any>();

      // 栄養成分詳細リストの元データを生成
      for (let i = Number(0); i < nutritionalList.length; i++) {
        const nutrientDetail = nutritionalList[i];

        const obj = {
          nutritionalName: '',
          nutritionalQuantity: '',
          nutritionalUnit: '',
          nutritionalCode: '',
          publishDiv: '',
          hirearchy: '',
        };
        obj.nutritionalName = nutrientDetail.NutritionalName;
        obj.nutritionalQuantity = '';
        obj.nutritionalUnit = nutrientDetail.NutritionalUnit;
        obj.nutritionalCode = nutrientDetail.NutritionalCode;
        obj.publishDiv = nutrientDetail.PublishDiv;
        obj.hirearchy = nutrientDetail.Hirearchy;

        this.codeMasterpNutritionalList.push(obj);
      }
    }
  }

  /**
   * 企画商品（表示用のアイテム情報）を設定する
   *
   * @param itemCodeInfo アイテムコード情報データ
   */
  private setPlanGoodsItemNutritional(itemCodeInfoList: Array<any>): void {

    for (let i = Number(0); i < itemCodeInfoList.length; i++) {
      let maxSeqNo: string = <string>'0';
      let seqNo: string = <string>'0';

      const nutritionalInfo = {
        itemCode: itemCodeInfoList[i].ItemCodeCommon.ItemCode,
        itemCodeNutritional: Array<any>(),
        itemCodeNutritionalMulti: Array<any>(),
      };

      /////////////////////////
      // 栄養成分タブ
      /////////////////////////
      const itemCodeNutritional: Array<any> = new Array<any>();

      if (itemCodeInfoList[i].ItemCodeNutritional != null &&
        itemCodeInfoList[i].ItemCodeNutritional.List[0] != null) {
        const nutrientComponent = {
          analysisSeqNo: PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritional.List[0].AnalysisSeqNo),
          analysisUnit: PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritional.List[0].AnalysisUnit),
          nutritionalNote: PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritional.List[0].NutritionalNote),
          nutrientDetailList: Array<any>(),
          maintenanceDivUnit: '',
          maintenanceDivNote: '',
        };
        // 栄養成分詳細
        const nutrientDetailList: Array<any> = new Array<any>();
        if (itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList != null) {
          for (let j = Number(0);
            j < itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List.length; j++) {
            const nutrientDetail = {
              NutritionalName: PlessViewUtilsSub.nullToBlank(
                itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List[j].NutritionalName),
              NutritionalQuantity: PlessViewUtilsSub.nullToBlank(
                itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List[j].NutritionalQuantity),
              NutritionalUnit: PlessViewUtilsSub.nullToBlank(
                itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List[j].NutritionalUnit),
              NutritionalCode: PlessViewUtilsSub.nullToBlank(
                itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List[j].NutritionalCode),
              PublishDiv: PlessViewUtilsSub.nullToBlank(
                itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List[j].PublishDiv),
              Hirearchy: PlessViewUtilsSub.nullToBlank(
                itemCodeInfoList[i].ItemCodeNutritional.List[0].NutrientComponentList.List[j].Hirearchy),
              // メンテナンス種別(栄養成分量用)
              MaintenanceDivQuantity: '',
              // '':処理無し、'I':データ追加、'U':データ更新、'D':データ削除'
            };
            nutrientDetailList.push(nutrientDetail);
          }
          nutrientComponent.nutrientDetailList = nutrientDetailList;
          this.nutrientDetailList = nutrientDetailList;
        }
        nutrientComponent.maintenanceDivUnit = '';	// メンテナンス種別(分析単位用)
        // '':処理無し、'I':データ追加、'U':データ更新、'D':データ削除'
        nutrientComponent.maintenanceDivNote = '';	// メンテナンス種別(栄養成分備考用)
        // '':処理無し、'I':データ追加、'U':データ更新、'D':データ削除'

        itemCodeNutritional.push(nutrientComponent);
        nutritionalInfo.itemCodeNutritional = itemCodeNutritional;

        // 1件以上存在する場合
        if (itemCodeInfoList[i].ItemCodeNutritional != null) {
          // 1件目に位置づけ
          // this.kymw0900Component.dtg_NutrientUnitList.select(0);
        }
      } else {
        nutritionalInfo.itemCodeNutritional = new Array<any>();
        this.nutrientDetailList = new Array<any>();
      }

      /////////////////////////
      // 複数栄養成分タブ
      /////////////////////////
      const itemCodeNutritionalMulti: Array<any> = new Array<any>();
      if (itemCodeInfoList[i].ItemCodeNutritionalMulti != null && itemCodeInfoList[i].ItemCodeNutritionalMulti.List !== undefined) {
        for (let k = Number(0); k < itemCodeInfoList[i].ItemCodeNutritionalMulti.List.length; k++) {
          seqNo = PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].AnalysisSeqNo);
          // 処理中の分析連番が、保持中の連番よりも大きい場合
          if (!PlessViewUtilsSub.isEmpty(seqNo)) {
            if (Number(seqNo) > Number(maxSeqNo)) {
              // 保持中の連番に、処理中の分析連番の値を設定
              maxSeqNo = seqNo;
            }
          }

          const nutrientComponentMulti = {
            analysisSeqNo:
              PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].AnalysisSeqNo),
            analysisUnit:
              PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].AnalysisUnit),
            nutritionalNote:
              PlessViewUtilsSub.nullToBlank(itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutritionalNote),
            nutrientDetailList: Array<any>(),
            maintenanceDivUnit: '',
            maintenanceDivNote: '',
          };

          // 栄養成分詳細
          const nutrientDetailListMulti: Array<any> = new Array<any>();
          if (itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList != null) {
            for (let l = Number(0);
              l < itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List.length; l++) {
              const nutrientDetailMulti = {
                nutritionalName: PlessViewUtilsSub.nullToBlank(
                  itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List[l].NutritionalName),
                nutritionalQuantity: PlessViewUtilsSub.nullToBlank(
                  itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List[l].NutritionalQuantity),
                nutritionalUnit: PlessViewUtilsSub.nullToBlank(
                  itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List[l].NutritionalUnit),
                nutritionalCode: PlessViewUtilsSub.nullToBlank(
                  itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List[l].NutritionalCode),
                publishDiv: PlessViewUtilsSub.nullToBlank(
                  itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List[l].PublishDiv),
                hirearchy: PlessViewUtilsSub.nullToBlank(
                  itemCodeInfoList[i].ItemCodeNutritionalMulti.List[k].NutrientComponentList.List[l].Hirearchy),
                // メンテナンス種別(栄養成分量用)
                maintenanceDivQuantity: '',
                // '':処理無し、'I':データ追加、'U':データ更新、'D':データ削除'
              };
              nutrientDetailListMulti.push(nutrientDetailMulti);
            }
            nutrientComponentMulti.nutrientDetailList = nutrientDetailListMulti;
          }

          nutrientComponentMulti.maintenanceDivUnit = '';	// メンテナンス種別(分析単位用)
          // '':処理無し、'I':データ追加、'U':データ更新、'D':データ削除'
          nutrientComponentMulti.maintenanceDivNote = '';	// メンテナンス種別(栄養成分備考用)
          // '':処理無し、'I':データ追加、'U':データ更新、'D':データ削除'

          itemCodeNutritionalMulti.push(nutrientComponentMulti);
        }
        nutritionalInfo.itemCodeNutritionalMulti = itemCodeNutritionalMulti;

        // 分析単位の件数を確認
        const row: number = itemCodeInfoList[i].ItemCodeNutritionalMulti.List.length;
      } else {
        nutritionalInfo.itemCodeNutritionalMulti = new Array<any>();
        this.nutrientDetailListMulti = new Array<any>();
      }
      // 栄養成分操作情報へ格納
      this.itemCodeNutritionalInfoList.push(nutritionalInfo);
      // 保持中の連番を、アイテム毎の分析連番領域に設定
      this.saveAnalysisSeqNo.push(maxSeqNo);
    }
  }



  /**
   * 企画商品（表示用のアイテム情報）を設定する
   *
   * @param dispData アイテムコード情報データ
   * @param itemCode アイテムコードの選択値
   */
  private setPlanGoodsItemForDisp(dispData: Array<any>, itemCode: string): void {
    // 選択されたアイテムコードと一致するアイテムコード情報データを設定
    for (let i = Number(0); i < dispData.length; i++) {
      if (PlessViewUtilsSub.nullToBlank(dispData[i].ItemCodeCommon.ItemCode) === itemCode) {
        // アイテムコードの選択位置設定
        this.selectedItemCodeIndex = i;

        // アイテムコード情報共通データ設定
        this.setItemCodeCommon(dispData[i].ItemCodeCommon);
        // アイテムコード情報アイテムタブデータ設定
        this.setItemCodeBase(dispData[i].ItemCodeBase);
        // アイテムコード情報仕様書１タブデータ設定
        this.setItemCodeSpec1(dispData[i].ItemCodeSpec1, i);
        // アイテムコード情報仕様書２タブデータ設定
        this.setItemCodeSpec2(dispData[i].ItemCodeSpec2);
        // アイテムコード情報栄養成分タブデータ設定
        this.setItemCodeNutritional(dispData[i].ItemCodeNutritional);
        // アイテムコード情報複数栄養成分タブデータ設定
        this.setItemCodeNutritionalMulti(dispData[i].ItemCodeNutritionalMulti);
        // アイテムコード情報環境タブデータ設定
        this.setItemCodeEcology(dispData[i].ItemCodeEcology);

        // 特殊発注区分の初期値設定
        this.kymw0900Component.cmb_SpecialOrderTypeList.setCodeValue(this.specialOrderType);
        // 在庫繰越区分の初期値設定
        this.kymw0900Component.cmb_StockTypeList.setCodeValue(this.stockType);
        // 発注単位区分の初期値設定
        this.kymw0900Component.cmb_OrderUnitType.setCodeValue(this.orderUnitType);
        // メーカー希望小売価格(参考)区分の初期値設定
        this.kymw0900Component.cmb_MakerType.setCodeValue(this.makerType);
        // 遺伝子組換表示区分の初期値設定
        this.kymw0900Component.cmb_GeneRecombinationDivList.setCodeValue(this.geneRecombinationDiv);
        // アレルゲン調査対象の初期値設定
        this.kymw0900Component.cmb_AllergenTergetType.setCodeValue(this.allergenTergetType);
        this.selectedItemCodeIndex = i;
      }
    }
  }

  /**
 * アイテムコード情報共通データを設定する
 *
 * @param data アイテムコード情報データ（アイテムコード共通）
 */
  private setItemCodeCommon(data: any): void {
    // アイテムコード
    this.itemCode = PlessViewUtilsSub.nullToBlank(data.ItemCode);
    // JANコード
    this.janCode = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.JANCode));

    // JANコード識別フラグ
    if (!PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(data.JANCodeDiv)) && data.JANCodeDiv === '1') {
      this.janCodeDiv = true;
    } else {
      this.janCodeDiv = false;
    }
  }

  /**
   * アイテムコード情報アイテムタブデータ設定
   *
   * @private
   * @param {*} data
   * @memberof KYMW0900Model
   */
  private setItemCodeBase(data: any) {
    // 値の初期化を行う
    // ※アイテムのコンボボックス変更時、バインディングを行うために対応している
    this.fcmcFee = null;
    this.specialOrderType = null;
    this.stockType = null;
    this.installmentTimes = null;
    this.pdPilingUpDays = null;
    this.itfCode = null;
    this.orderUnitType = null;
    this.makerType = null;
    this.makerPrice = null;
    this.orderClientCode = null;
    this.orderClientName = null;
    this.payeeClientCode = null;
    this.payeeClientName = null;
    this.bundlePrice = null;
    this.fixContainNum = null;
    this.setQuantity = null;

    // ＦＣ・ＭＣ手数料
    this.fcmcFee = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.FCMCFee));

    // 特殊発注区分
    this.specialOrderType = PlessViewUtilsSub.nullToBlank(data.SpecialOrderType);

    // 在庫繰越区分
    this.stockType = PlessViewUtilsSub.nullToBlank(data.StockType);

    // 分納指定回数
    this.installmentTimes = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.InstallmentTimes));

    // 物流滞留日数
    this.pdPilingUpDays = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PDPilingUpDays));

    // ＩＴＦコード
    this.itfCode = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.ITFCode));

    // 発注単位区分
    this.orderUnitType = PlessViewUtilsSub.nullToBlank(data.OrderUnitType);

    // メーカー希望小売価格(参考)区分
    this.makerType = PlessViewUtilsSub.nullToBlank(data.PriceType);

    // メーカー希望小売価格(参考)価格
    this.makerPrice = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.MakerPrice));

    // 発注先取引先
    this.orderClientCode = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.OrderClientCode));

    // 発注先取引先名称
    this.orderClientName = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.OrderClientName));

    // 支払先取引先
    this.payeeClientCode = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PayeeClientCode));

    // 支払先取引先名称
    this.payeeClientName = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PayeeClientName));

    // 価格バンドル
    this.bundlePrice = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.BundlePrice));

    // 確定入数
    this.fixContainNum = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.FixContainNum));

    // 組数
    this.setQuantity = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.SetQuantity));
  }

  // アイテムコード情報仕様書１タブデータ設定
  private setItemCodeSpec1(data: any, count: number) {
    // 値の初期化を行う
    // ※アイテムのコンボボックス変更時、バインディングを行うために対応している
    // Boolean型はnullにできないため、フラグを反転させる
    this.ebaseSpecCode = null;
    this.specApplyDate = null;
    this.makerName = null;
    this.makerNamePublishType = !this.makerNamePublishType;
    this.peaceSizeLength = null;
    this.peaceSizeWidth = null;
    this.peaceSizeHight = null;
    this.peaceWeight = null;
    this.caseSizeLength = null;
    this.caseSizeWidth = null;
    this.caseSizeHight = null;
    this.caseWeight = null;
    this.geneRecombinationDiv = null;
    this.specTextInfoDiv1 = null;
    this.stringValue1 = null;
    this.specTextInfoDiv2 = null;
    this.stringValue2 = null;
    this.specTextInfoDiv3 = null;
    this.stringValue3 = null;
    this.specTextInfoDiv4 = null;
    this.stringValue4 = null;
    this.specTextInfoDiv5 = null;
    this.stringValue5 = null;
    this.specTextInfoDiv6 = null;
    this.stringValue6 = null;
    this.geneRecombinationDiv = null;

    // ｅＢＡＳＥ仕様書No
    this.ebaseSpecCode = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.EBaseSpecCode));

    // 仕様書適用日
    this.specApplyDate = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.SpecApplyDate));

    // メーカー名称
    this.makerName = PlessViewUtilsSub.nullToBlank(data.MakerName);

    // メーカー名称表示
    if (data.MakerNamePublishType === '1') {
      this.makerNamePublishType = true;
    } else {
      this.makerNamePublishType = false;
    }

    // ピースサイズ（縦）
    this.peaceSizeLength = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PeaceSizeLength));

    // ピースサイズ（横）
    this.peaceSizeWidth = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PeaceSizeWidth));

    // ピースサイズ（高）
    this.peaceSizeHight = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PeaceSizeHight));

    // ピース重量
    this.peaceWeight = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PeaceWeight));

    // ケースサイズ（縦）
    this.caseSizeLength = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.CaseSizeLength));

    // ケースサイズ（横）
    this.caseSizeWidth = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.CaseSizeWidth));

    // ケースサイズ（高）
    this.caseSizeHight = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.CaseSizeHight));

    // ケース重量
    this.caseWeight = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.CaseWeight));

    // アイテム文字情報の初期化
    this.textInfoDivItemArray = this.initialInfoDivItemArray();

    let textInfoDiv: string = <string>'';
    // アイテム文字情報リストの取得
    if (data.TextInfoList !== undefined) {
      const tempTextInfoList: Array<any> = data.TextInfoList;
      // アイテム文字情報種別（TextKindID）でどの項目に割り当てるか判定する
      for (let i = Number(0); i < tempTextInfoList.length; i++) {
        switch (PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID)) {
          // 原産国加工地
          case '005':
            // 文字情報種別1
            this.specTextInfoDiv1 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 原産国加工地
            this.stringValue1 = PlessViewUtilsSub.nullToBlank(String(tempTextInfoList[i].StringValue));
            break;
          // 原材料情報
          case '014':
            // 文字情報種別2
            this.specTextInfoDiv2 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 原材料情報
            this.stringValue2 = PlessViewUtilsSub.nullToBlank(String(tempTextInfoList[i].StringValue));
            break;
          // コンタミ情報
          case '013':
            // 文字情報種別3
            this.specTextInfoDiv3 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // コンタミ情報
            this.stringValue3 = PlessViewUtilsSub.nullToBlank(String(tempTextInfoList[i].StringValue));
            break;
          // カロリー情報
          case '010':
            // 文字情報種別4
            this.specTextInfoDiv4 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // カロリー情報
            this.stringValue4 = PlessViewUtilsSub.nullToBlank(String(tempTextInfoList[i].StringValue));
            break;
          // 添加物情報
          case '006':
            // 文字情報種別5
            this.specTextInfoDiv5 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 添加物情報
            this.stringValue5 = PlessViewUtilsSub.nullToBlank(String(tempTextInfoList[i].StringValue));
            break;
          // 遺伝子組換
          case '007':
            // 文字情報種別6
            this.specTextInfoDiv6 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 遺伝子組換
            this.stringValue6 = PlessViewUtilsSub.nullToBlank(String(tempTextInfoList[i].StringValue));
            break;
          default:
            break;
        }
      }
    } else {
      // 原産国加工地
      this.specTextInfoDiv1 = '005';
      this.stringValue1 = '';
      // 原材料情報
      this.specTextInfoDiv2 = '014';
      this.stringValue2 = '';
      // コンタミ情報
      this.specTextInfoDiv3 = '013';
      this.stringValue3 = '';
      // カロリー情報
      this.specTextInfoDiv4 = '010';
      this.stringValue4 = '';
      // 添加物情報
      this.specTextInfoDiv5 = '006';
      this.stringValue5 = '';
      // 便利情報（その他）
      this.specTextInfoDiv6 = '007';
      this.stringValue6 = '';
    }
    // 遺伝子組換表示区分
    this.geneRecombinationDiv = PlessViewUtilsSub.nullToBlank(data.GeneRecombinationDiv);
  }

  /**
 * 文字情報種別(アイテム)を初期化
 */
  private initialInfoDivItemArray(): Array<any> {

    // 要素は６個で固定
    const initialArray: Array<any> = new Array(6);
    // 0番目 = 005
    initialArray[0] = '005';
    // 1番目 = 014
    initialArray[1] = '014';
    // 2番目 = 013
    initialArray[2] = '013';
    // 3番目 = 010
    initialArray[3] = '010';
    // 4番目 = 006
    initialArray[4] = '006';
    // 5番目 = 007
    initialArray[5] = '007';
    return initialArray;
  }

  /**
   * アイテムコード情報仕様書２タブデータを設定する
   *
   * @private
   * @param {*} data
   * @memberof KYMW0900Model
   */
  private setItemCodeSpec2(data: any): void {

    // 値の初期化を行う
    // ※アイテムのコンボボックス変更時、バインディングを行うために対応している
    this.analysisUnit = null;
    this.calolie = null;
    this.protein = null;
    this.lipid = null;
    this.carbohydrate = null;
    this.sodium = null;

    // アレルゲン調査対象
    this.allergenTergetType = data.AllergenTargetType;

    // アレルゲン情報一覧（データグリッド）の初期化
    if (this.allergenInfo === null) {
      this.allergenInfo = new Array<any>();
    }

    if (data.AllergenList != null) {
      // アレルゲン情報一覧（データグリッド）の設定
      const tempAllergenInfo: Array<any> = data.AllergenList;
      const AllergenInfo: Array<any> = new Array<any>();

      for (let i = Number(0); i < tempAllergenInfo.length; i++) {
        const coopXml = {
          SelectValue: PlessViewUtilsSub.nullToBlank(tempAllergenInfo[i].AllergenSelect) === '1' ? true : false,
          AllergenCode: PlessViewUtilsSub.nullToBlank(tempAllergenInfo[i].AllergenDiv),
          AllergenName: PlessViewUtilsSub.nullToBlank(this.allergenListContents[PlessViewUtilsSub.nullToBlank(
            tempAllergenInfo[i].AllergenDiv)].AllergenName),
          PublishDiv: PlessViewUtilsSub.nullToBlank(this.allergenListContents[PlessViewUtilsSub.nullToBlank(
            tempAllergenInfo[i].AllergenDiv)].PublishDiv),
          ComponentValue: PlessViewUtilsSub.nullToBlank(tempAllergenInfo[i].ComponentAllergenSelect),
        };
        AllergenInfo.push(coopXml);
      }
      this.allergenInfo = AllergenInfo;
    }

    // 分析単位
    this.analysisUnit = PlessViewUtilsSub.nullToBlank(data.AnalysisUnit);

    // 熱量(Kcal)
    this.calolie = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.Calorie));

    // たんぱく質(g)
    this.protein = PlessViewUtilsSub.nullToBlank(data.Protein);

    // 脂質(g)
    this.lipid = PlessViewUtilsSub.nullToBlank(data.Lipid);

    // 炭水化物(g)
    this.carbohydrate = PlessViewUtilsSub.nullToBlank(data.Carbohydrate);

    // ナトリウム(mg)
    this.sodium = PlessViewUtilsSub.nullToBlank(data.Sodium);
  }

  // アイテムコード情報栄養成分タブデータ設定
  private setItemCodeNutritional(data: any) {

    if (data != null) {
      if (data.List != null && data.List.length > 0) {
        this.hiddenNutrientComponentList = Array<any>();
        const unitList = Array<any>();
        // 分析連番、分析単位
        const coopXml = {
          AnalysisSeqNo: PlessViewUtilsSub.nullToBlank(Number(data.List[0].AnalysisSeqNo)),
          AnalysisUnit: PlessViewUtilsSub.nullToBlank(String(data.List[0].AnalysisUnit)),
        };
        unitList.push(coopXml);
        this.nutrientUnitList = unitList;

        // 栄養成分詳細
        const nutrientDetailList = Array<any>();
        for (let j = Number(0); j < data.List[0].NutrientComponentList.List.length; j++) {
          const nutrientDetail = data.List[0].NutrientComponentList.List[j];
          const detailXml = {
            NutritionalName: PlessViewUtilsSub.nullToBlank(String(nutrientDetail.NutritionalName)),
            NutritionalQuantity: PlessViewUtilsSub.nullToBlank(String(nutrientDetail.NutritionalQuantity)),
            NutritionalUnit: PlessViewUtilsSub.nullToBlank(String(nutrientDetail.NutritionalUnit)),
            NutritionalCode: PlessViewUtilsSub.nullToBlank(String(nutrientDetail.NutritionalCode)),
            PublishDiv: PlessViewUtilsSub.nullToBlank(String(nutrientDetail.PublishDiv)),
            Hirearchy: PlessViewUtilsSub.nullToBlank(String(nutrientDetail.Hirearchy)),
          };
          nutrientDetailList.push(detailXml);
        }

        // 栄養成分備考
        this.nutrientNote = PlessViewUtilsSub.nullToBlank(data.List[0].NutritionalNote);
        const hiddenNutrientComponentList = new Array<any>();

        // hidden項目へのセット
        const hiddenNutrientComponent = {
          analysisSeqNo: PlessViewUtilsSub.nullToBlank(String(data.List[0].AnalysisSeqNo)),
          analysisUnit: PlessViewUtilsSub.nullToBlank(String(data.List[0].AnalysisUnit)),
          nutritionalNote: PlessViewUtilsSub.nullToBlank(String(data.List[0].NutritionalNote)),
          nutrientDetailList: nutrientDetailList,
        };
        // hiddenに格納
        hiddenNutrientComponentList.push(hiddenNutrientComponent);
        this.hiddenNutrientComponentList = hiddenNutrientComponentList;

        this.nutrientUnitList = unitList;
        // hidden項目の最初の分析単位を表示
        this.changeNutrientInfoList(0);
      } else {
        this.nutrientUnitList = Array<any>();
        this.nutrientDetailList = Array<any>();
        this.nutrientNote = '';
        this.hiddenNutrientComponentList = Array<any>();
      }
    } else {
      this.nutrientUnitList = Array<any>();
      this.nutrientDetailList = Array<any>();
      this.nutrientNote = '';
      this.hiddenNutrientComponentList = Array<any>();
    }
  }

  /**
   * 栄養成分タブにある栄養成分情報の表示の入れ替え
   *
   * @param {number} idx
   * @memberof KYMW0900Model
   */
  public changeNutrientInfoList(idx: number): void {
    if (this.hiddenNutrientComponentList.length > idx) {
      this.nutrientDetailList = this.hiddenNutrientComponentList[idx].nutrientDetailList;
      this.nutrientNote = this.hiddenNutrientComponentList[idx].nutritionalNote;
    } else {
      this.nutrientNote = '';
    }
    this.kymw0900Component.dtg_NutrientComponentList.editableCollectionView.refresh();
  }

  /**
   * 複数栄養成分タブにある栄養成分情報の表示の入れ替え
   *
   * @param {number} idx
   * @memberof KYMW0900Model
   */
  public changeNutrientInfoListMulti(idx: number): void {
    if (this.hiddenNutrientComponentListMulti.length > idx && idx >= 0) {
      this.nutrientDetailListMulti = this.hiddenNutrientComponentListMulti[idx].nutrientDetailList;
      this.nutrientNoteMulti = this.hiddenNutrientComponentListMulti[idx].nutritionalNote;
    } else {
      this.nutrientNoteMulti = '';
    }
  }

  /**
   * アイテムコード情報複数栄養成分タブデータ設定
   *
   * @private
   * @param {*} data
   * @memberof KYMW0900Model
   */
  private setItemCodeNutritionalMulti(data: any) {
    if (data != null) {
      if (data.List != null) {
        this.hiddenNutrientComponentListMulti = new Array<any>();
        const multiUnitList = new Array<any>();

        for (let i = Number(0); i < data.List.length; i++) {
          // 分析連番、分析単位
          const coopXml = {
            AnalysisSeqNo: PlessViewUtilsSub.nullToBlank(String(data.List[i].AnalysisSeqNo)),
            AnalysisUnit: PlessViewUtilsSub.nullToBlank(String(data.List[i].AnalysisUnit)),
          };
          multiUnitList.push(coopXml);
          // 栄養成分詳細
          const multiNutrientDetailList = new Array<any>();
          for (let j = Number(0); j < data.List[i].NutrientComponentList.List.length; j++) {
            const multiNutrientDetail = data.List[i].NutrientComponentList.List[j];
            const multiDetailXml = {
              NutritionalName: PlessViewUtilsSub.nullToBlank(String(multiNutrientDetail.NutritionalName)),
              NutritionalQuantity: PlessViewUtilsSub.nullToBlank(String(multiNutrientDetail.NutritionalQuantity)),
              NutritionalUnit: PlessViewUtilsSub.nullToBlank(String(multiNutrientDetail.NutritionalUnit)),
              NutritionalCode: PlessViewUtilsSub.nullToBlank(String(multiNutrientDetail.NutritionalCode)),
              PublishDiv: PlessViewUtilsSub.nullToBlank(String(multiNutrientDetail.PublishDiv)),
              Hirearchy: PlessViewUtilsSub.nullToBlank(String(multiNutrientDetail.Hirearchy)),
            };
            multiNutrientDetailList.push(multiDetailXml);
          }
          // 栄養成分備考
          this.nutrientNoteMulti = PlessViewUtilsSub.nullToBlank(String(data.List[i].NutritionalNote));
          const hiddenNutrientComponentListMulti: Array<any> = new Array<any>();
          // hidden項目へのセット
          const hiddenNutrientComponent = {
            analysisSeqNo: PlessViewUtilsSub.nullToBlank(String(data.List[i].AnalysisSeqNo)),
            analysisUnit: PlessViewUtilsSub.nullToBlank(String(data.List[i].AnalysisUnit)),
            nutritionalNote: PlessViewUtilsSub.nullToBlank(String(data.List[i].NutritionalNote)),
            nutrientDetailList: multiNutrientDetailList,
          };
          // hiddenに格納
          this.hiddenNutrientComponentListMulti.push(hiddenNutrientComponent);
        }
        this.nutrientUnitListMulti = multiUnitList;
        // hidden項目の最初の分析単位を表示
        this.changeNutrientInfoListMulti(0);
      } else {
        this.nutrientUnitListMulti = [];
        this.nutrientDetailListMulti = [];
        this.nutrientNoteMulti = '';
        this.hiddenNutrientComponentListMulti = [];
      }
    } else {
      this.nutrientUnitListMulti = [];
      this.nutrientDetailListMulti = [];
      this.nutrientNoteMulti = '';
      this.hiddenNutrientComponentListMulti = [];
    }

    // 複数の分析単位が存在する場合
    if (0 < this.hiddenNutrientComponentListMulti.length) {
      this.hasMultiNutrientInfo = true;
      this.kymw0900Component.cnv_MultiNutrientTab.isDisabled = false;	// タブを活性にする
    } else {
      // 変更前のアイテムが複数栄養成分ありで複数栄養成分タブを開いていた場合
      // かつ変更後のアイテムが複数栄養成分なしの場合、アイテム欄のタブ選択を栄養成分にする
      if (this.kymw0900Component.tab_item.selectedIndex === 5) {
        this.kymw0900Component.tab_item.selectedIndex = 4;
      }
      this.hasMultiNutrientInfo = false;
      this.kymw0900Component.cnv_MultiNutrientTab.isDisabled = true;		// タブを非活性にする
    }
  }

  /**
   * アイテムコード情報環境タブデータを設定する
   *
   * @private
   * @param {*} data
   * @memberof KYMW0900Model
   */
  private setItemCodeEcology(data: any): void {

    // 値の初期化を行う
    // ※アイテムのコンボボックス変更時、バインディングを行うために対応している
    this.ecologyDiv = null;

    // 環境区分なし／あり
    this.ecologyDiv = data.EcologyDivFlag;

    // 環境区分一覧（データグリッド）の初期化
    if (this.goodsEcology === null) {
      this.goodsEcology = new Array<any>();
    }

    if (data.EcologyDivList != null) {
      // 環境配慮商品情報一覧（データグリッド）の設定
      const tempGoodsEcology: Array<any> = data.EcologyDivList;
      const goodsEcology: Array<any> = new Array<any>();
      for (let i = Number(0); i < tempGoodsEcology.length; i++) {
        const coopXml = {
          SelectValue: PlessViewUtilsSub.nullToBlank(tempGoodsEcology[i].EcologyDivSelect) === '1' ? true : false,
          EcologyDiv: PlessViewUtilsSub.nullToBlank(tempGoodsEcology[i].EcologyDiv),
          EcologyGoodsName: PlessViewUtilsSub.nullToBlank(
            this.ecologyDivListContents[PlessViewUtilsSub.nullToBlank(
              tempGoodsEcology[i].EcologyDiv)].EcologyDivName),
          Enabled: PlessViewUtilsSub.nullToBlank(data.EcologyDivFlag),
        };
        goodsEcology.push(coopXml);
      }
      this.goodsEcology = goodsEcology;
    }
    if (this.ecologyDiv === '1') {
      this.goodsEcologyFlag = true;
    } else {
      this.goodsEcologyFlag = false;
    }

    // 温暖化防止一覧（データグリッド）の初期化
    if (this.goodsGWStop === null) {
      this.goodsGWStop = new Array<any>();
    }

    if (data.GWStopGoodsList != null) {
      // 温暖化防止一覧（データグリッド）の設定
      const tempGoodsGWStop: Array<any> = data.GWStopGoodsList;
      const goodsGWStop: Array<any> = new Array<any>();

      for (let i = Number(0); i < tempGoodsGWStop.length; i++) {
        const coopXml = {
          SelectValue: tempGoodsGWStop[i].GWStopGoodsDivSelect === '1' ? true : false,
          GWStopGoodsDiv: PlessViewUtilsSub.nullToBlank(tempGoodsGWStop[i].GWStopGoodsDiv),
          GoodsGWStopName: PlessViewUtilsSub.nullToBlank(
            this.gwStopGoodsListContents[PlessViewUtilsSub.nullToBlank(
              tempGoodsGWStop[i].GWStopGoodsDiv)].GWStopGoodsDivName),
        };
        goodsGWStop.push(coopXml);
      }
      this.goodsGWStop = goodsGWStop;
    }

    // 容器包装材一覧（データグリッド）の初期化
    if (this.containPackingList === null) {
      this.containPackingList = new Array<any>();
    }

    if (data.ContainList != null) {
      // 容器包装材一覧（データグリッド）の設定
      const tempContainPacking: Array<any> = data.ContainList;
      const containPacking: Array<any> = new Array<any>();
      for (let i = Number(0); i < tempContainPacking.length; i++) {
        const coopXml = {
          SelectValue: tempContainPacking[i].ContainSelect === '1' ? true : false,
          ContainDiv: PlessViewUtilsSub.nullToBlank(tempContainPacking[i].ContainDiv),
          ContainDivName: PlessViewUtilsSub.nullToBlank(
            this.containListContents[PlessViewUtilsSub.nullToBlank(
              tempContainPacking[i].ContainDiv) + this.DELIMITER + PlessViewUtilsSub.nullToBlank(
                tempContainPacking[i].ContainKind)].ContainDivName),
          ContainKind: PlessViewUtilsSub.nullToBlank(tempContainPacking[i].ContainKind),
          ContainKindName: PlessViewUtilsSub.nullToBlank(
            this.containListContents[PlessViewUtilsSub.nullToBlank(
              tempContainPacking[i].ContainDiv) + this.DELIMITER + PlessViewUtilsSub.nullToBlank(
                tempContainPacking[i].ContainKind)].ContainKindName),
          PackMaterialWeight: PlessViewUtilsSub.nullToBlank(tempContainPacking[i].PackMaterialWeight),
        };
        containPacking.push(coopXml);
      }
      this.containPackingList = containPacking;
    }
  }


  /**
   * コードリスト更新
   *
   * @private
   * @memberof KYMW0900Model
   */
  private updateCodeList(codeList: any, blank = true, latestInfo = false): Array<any> {

    // 戻り値定義
    let returnArrayCollection: Array<any> = new Array<any>();

    // NULLチェック
    if (codeList === null) {
      // 空白行を追加
      returnArrayCollection.push(this.getBlankObject('', ''));
      return returnArrayCollection;
    }

    const tempCodeList: any = codeList;
    let index: number = <number>0;

    // 先頭空白追加
    if (blank) {
      tempCodeList.unshift(this.getBlankObject('', ''));
      index += 1;
    }

    // 最新情報表示
    if (latestInfo) {
      tempCodeList.push(this.getBlankObject('*', '最新情報'), index);
      index += 1;
    }

    // コード+：+名称追加
    for (; index < tempCodeList.length; index++) {
      tempCodeList[index].CodeValueName = tempCodeList[index].CodeValue + ':' + tempCodeList[index].CodeName;
    }

    // 戻り値に設定
    returnArrayCollection = tempCodeList;

    return returnArrayCollection;
  }

  /**
   * コードリスト更新
   *
   * @memberof KYMW0900Model
   */
  public updateOrderNumQuotaCodeList(data: any) {
    // 戻り値定義
    let returnArrayCollection: Array<any> = new Array<any>();

    // NULLチェック
    if (data === null) {
      // 空白行を追加
      returnArrayCollection.push(this.getBlankObject('', ''));
      return returnArrayCollection;
    }

    const tempCodeList: any = data;
    let index: number = <number>0;

    // コード+：+名称追加
    for (; index < tempCodeList.length; index++) {
      tempCodeList[index].OrderNumQuotaCodeName = tempCodeList[index].OrderNumQuotaCode + ':' + tempCodeList[index].OrderNumQuotaName;
    }

    // 戻り値に設定
    returnArrayCollection = tempCodeList;

    return returnArrayCollection;
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @memberof KYMW0900Model
   */
  private getBlankObject(codeValue: string, codeName: string): any {

    let CodeValueName = <string>'';
    if (!PlessViewUtilsSub.isEmpty(codeValue) && !PlessViewUtilsSub.isEmpty(codeName)) {
      CodeValueName = codeValue + ':' + codeName;
    } else {
      CodeValueName = codeValue + codeName;
    }
    const ob = {
      CodeDiv: [''],
      CodeValue: [codeValue],
      CodeName: [codeName],
      CodeValueName: [CodeValueName],
      CodeDivName: [''],
      Reserve1: [''],
      Reserve2: [''],
      ReserveNum1: [''],
      ReserveNum2: [''],
      SortNum: [''],
      StartOrderCode: [''],
      EndOrderCode: [''],
    };
    return ob;
  }

  /**
   * Ｐコード共通データを設定する
   *
   * @private
   * @param {*} data
   * @memberof KYMW0900Model
   */
  private setPCodeCommon(data: any): void {

    // 受注コード
    this.orderCode = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.OrderCode);

    // Ｐコードリスト
    this.pCode = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.PCode);

    // 部門分類管理NO
    this.classDivNum = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeCommon.ClassDivNum));

    // バイヤーコード
    this.buyerCode = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeCommon.BuyerCode));

    // 包材一括表示確認
    if (data.PCodeCommon.PackMaterialShowFlg === '1') {
      this.packMaterialShowFlag = true;
    } else {
      this.packMaterialShowFlag = false;
    }
    // 本登録済みの場合は包材一括表示確認を編集不可にする
    if (data.PCodeCommon.AdmitStatus === '2') {
      this.kymw0900Component.chk_PackMaterialShowFlag.nativeElement.disabled = true;
    }

    // 業態区分がスポット媒体の場合、業態区分（デイリー）を編集不可にする
    if (this.permission !== '1') {
      if (data.PCodeCommon.DutiesFormDiv === '3') {
        this.kymw0900Component.cmb_DutiesFormDailyDiv.disabled = true;
      }
    }

    // 部門コード
    this.classCode = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.ClassCode);

    // 大分類コード
    this.largeClassCode = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.LargeClassCode);

    // 中分類コード
    this.middleClassCode = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.MiddleClassCode);

    // 小分類コード
    this.smallClassCode = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.SmallClassCode);

    // データ種別
    this.dataType = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.DataType);

    // 商品案内用商品名
    this.guideGoodsName = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.GuideGoodsName);

    // 商品案内用規格名
    this.guideStandardName = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.GuideStandardName);

    // 媒体区分
    this.mediumType = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.MediumType);

    // 登録日時
    this.registDate = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.RegistDate);

    // 更新日時
    this.updateDate = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.UpdateData);

    // 業態区分
    this.dutiesFormDiv = PlessViewUtilsSub.nullToBlank(data.PCodeCommon.DutiesFormDiv);
  }

  /**
   * Ｐコード基本情報タブデータを設定する
   *
   * @private
   * @param {any} data
   * @memberof KYMW0900Model
   */
  private setPCodeBase(data: any): void {
    // 初期化
    this.deliveryGoodsNameKanji = null;
    this.deliveryGoodsNameKana = null;
    this.deliveryStandardNameKanji = null;
    this.deliveryStandardNameKana = null;
    this.defaultConsumeTaxDiv = null;
    this.defaultConsumeTaxRate = null;
    this.ocrGoodsName = null;
    this.consumeTaxDiv = null;
    this.consumeTaxDivRate = null;
    this.cycleTerm = null;
    this.edlpDiv = null;
    this.roomTempZoneDiv = null;
    this.unitPriceDiv = null;
    this.unitPriceCoefficient = null;
    this.unitPriceUnit = null;
    this.consumeTerm = null;
    this.consumeByDate = null;
    this.leaveConsumeTerm = null;
    this.relationPcodeOld = null;
    this.relationPcodeNew = null;
    this.blindDiv = null;
    this.komaScheduleDiv = null;
    this.liquorCode = null;
    this.alcoholType = null;
    this.containerForm = null;
    this.containerCapacity = null;

    // お届け明細用商品名（漢字）
    if (PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(data.PCodeBase.DeliveryGoodsNameKanji))) {
      this.deliveryGoodsNameKanji = '商品案内用商品名';
    } else {
      this.deliveryGoodsNameKanji = data.PCodeBase.DeliveryGoodsNameKanji;
    }
    // お届け明細用商品名（カナ）
    this.deliveryGoodsNameKana = PlessViewUtilsSub.nullToBlank(data.PCodeBase.DeliveryGoodsNameKana);

    // お届け明細用規格名（漢字）
    if (data.PCodeBase.DeliveryStandardNameKanji === null ||
      PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(data.PCodeBase.DeliveryStandardNameKanji))) {
      this.deliveryStandardNameKanji = '商品案内用規格名';
    } else {
      this.deliveryStandardNameKanji = data.PCodeBase.DeliveryStandardNameKanji;
    }
    // お届け明細用規格名（カナ）
    this.deliveryStandardNameKana = PlessViewUtilsSub.nullToBlank(data.PCodeBase.DeliveryStandardNameKana);

    // OCR商品名
    if (data.PCodeBase.OcrGoodsName === null || PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.trim(
      data.PCodeBase.OcrGoodsName))) {
      this.ocrGoodsName = '商品案内用商品名';
    } else {
      this.ocrGoodsName = PlessViewUtilsSub.nullToBlank(data.PCodeBase.OcrGoodsName);
    }

    // 消費税区分
    this.consumeTaxDiv = PlessViewUtilsSub.nullToBlank(data.PCodeBase.ConsumeTaxDiv);

    // 消費税率
    this.consumeTaxDivRate = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.ConsumeTaxRate));

    // デフォルト消費税区分
    this.defaultConsumeTaxDiv = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.DefaultConsumeTaxDiv));

    // デフォルト消費税率
    this.defaultConsumeTaxRate = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.DefaultConsumeTaxRate));

    // サイクル期間
    this.cycleTerm = PlessViewUtilsSub.nullToBlank(data.PCodeBase.CycleTerm);

    // ＥＤＬＰ商品区分
    this.edlpDiv = PlessViewUtilsSub.nullToBlank(data.PCodeBase.EdlpDiv);

    // 商品案内温度帯区分
    this.roomTempZoneDiv = PlessViewUtilsSub.nullToBlank(data.PCodeBase.GuideTempZoneDiv);

    // ユニットプライス区分
    this.unitPriceDiv = PlessViewUtilsSub.nullToBlank(data.PCodeBase.UnitPriceDiv);

    // ユニットプライス係数
    this.unitPriceCoefficient = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.UnitPriceCoefficient));

    // ユニットプライス単位
    this.unitPriceUnit = PlessViewUtilsSub.nullToBlank(data.PCodeBase.UnitPriceUnit);

    // 賞味期間
    this.consumeTerm = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.ConsumeTerm));

    // 消費期限
    this.consumeByDate = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.ConsumeByDate));

    // 残賞味期間（配達時）
    this.leaveConsumeTerm = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.LeaveConsumeTerm));

    // 関連Ｐコード（旧）
    this.relationPcodeOld = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.RelationPCodeOld));

    // 関連Ｐコード（新）
    this.relationPcodeNew = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.RelationPCodeNew));

    // 目隠し区分
    this.blindDiv = PlessViewUtilsSub.nullToBlank(data.PCodeBase.BlindDiv);

    // ｅフレンズ送信要否
    if (data.PCodeBase.EFriendsSendDiv === '1') {
      this.eFriendsSendDiv = true;
    } else {
      this.eFriendsSendDiv = false;
    }

    // コマ配置予定区分
    this.komaScheduleDiv = PlessViewUtilsSub.nullToBlank(data.PCodeBase.KomaScheduleDiv);

    // 酒類コード
    this.liquorCode = PlessViewUtilsSub.nullToBlank(data.PCodeBase.LiquorCode);

    // アルコール分別
    this.alcoholType = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.AlocoholType));

    // 容器形態
    this.containerForm = PlessViewUtilsSub.nullToBlank(data.PCodeBase.ContainerForm);

    // 容器容量
    this.containerCapacity = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeBase.ContainerCapacity));

    // 背景色切替用受注コード
    this.backgroundColorOrderCode = PlessViewUtilsSub.nullToBlank(data.PCodeBase.BackgroundColorOrderCode);

  }

  /**
   * Ｐコード会員生協タブデータを設定する
   *
   * @private
   * @memberof KYMW0900Model
   */
  private setPCodeCoop(data: any): void {

    // 通常媒体フラグ(PLAN_GOODS_BASE)の取得
    this.RegularFlg = data.PCodeCoop.RegularFlg;

    // 会員生協マーク一覧（データグリッド）の初期化
    if (this.coopMarkList === null) {
      this.coopMarkList = new Array<any>();
    }

    // 会員生協価格一覧（データグリッド）の初期化
    if (this.coopPriceList === null) {
      this.coopPriceList = new Array<any>();
    }

    const coopMarkList: Array<any> = new Array<any>();

    if (data != null) {

      // 価格パターン連動マーク一覧（データグリッド・タイトル）の取得
      this.pricePatternLinkMarkList = data.PCodeCoop.PricePatternLinkMarkList;
      this.mark1Header = this.pricePatternLinkMarkList[0].PricePatternLinkMarkName;
      this.mark3Header = this.pricePatternLinkMarkList[2].PricePatternLinkMarkName;
      this.mark4Header = this.pricePatternLinkMarkList[3].PricePatternLinkMarkName;
      this.mark5Header = this.pricePatternLinkMarkList[4].PricePatternLinkMarkName;
      // 項番2231 END 障害管理NO.U01884対応

      // 会員生協マーク一覧（データグリッド）の取得
      const tempCoopMarkList: Array<any> = data.PCodeCoop.CoopSystemMarkList;
      // 会員生協価格一覧（データグリッド）の取得
      const tempPriceList: Array<any> = data.PCodeCoop.CoopPriceList;

      for (let i = Number(0); i < tempCoopMarkList.length; i++) {
        const coopXml = {
          CoopCode: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].CoopCode),
          CoopNum: i,
          CoopName: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].PlanCoopName),
          Mark1Value: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].SystemMark1) === '1' ? true : false,
          Mark2Value: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].SystemMark2) === '1' ? true : false,
          Mark3Value: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].SystemMark3) === '1' ? true : false,
          Mark4Value: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].SystemMark4) === '1' ? true : false,
          Mark5Value: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].SystemMark5) === '1' ? true : false,
          DealCoopDiv: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].DealCoopDiv) === '1' ? true : false,
          Enabled: '1',
        };
        coopMarkList.push(coopXml);
      }
      this.coopMarkList = coopMarkList;
      this.kymw0900Component.coopMarkList = PlessViewUtilsSub.getCloneArray(coopMarkList);
      const coopPriceList: Array<any> = new Array<any>();
      // Pコード変更時に再表示するためリストを空にする
      this.kymw0900Component.itemRelatedCoop_CoopTab = [];
      // 会員生協価格一覧（データグリッド）の設定
      for (let i = Number(0); i < tempPriceList.length; i++) {

        const capStr: Array<any> = new Array<any>();
        for (let j = Number(0); j < this.itemCodeList.length; j++) {
          capStr.push({ Caption: this.itemCodeList[j].ItemCode });
        }
        const coopXml = {
          CoopCode: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].CoopCode),
          CoopNum: i,
          CoopName: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].PlanCoopName),
          CoopShortName: PlessViewUtilsSub.nullToBlank(tempCoopMarkList[i].CoopShortName),
          SelectValue: tempPriceList[i].UseRegularFlg === this.USE_REGULAR_FLAG_ON,
          SelectItemCode: PlessViewUtilsSub.nullToBlank(tempPriceList[i].ItemCode),
          SelectPricePattern: PlessViewUtilsSub.nullToBlank(tempPriceList[i].PricePatern),
          LSupplyPricecoefficient: PlessViewUtilsSub.nullToBlank(tempPriceList[i].SupplyPriceCoefficient),
          SupplyPricecoefficient: PlessViewUtilsSub.nullToBlank(tempPriceList[i].SupplyPriceCoefficient),
          SupplyPriceSpecial1: PlessViewUtilsSub.nullToBlank(tempPriceList[i].SupplyPriceSpecial1),
          SupplyPriceSpecial2: PlessViewUtilsSub.nullToBlank(tempPriceList[i].SupplyPriceSpecial2),
          ThistimeSupplyPrice: PlessViewUtilsSub.nullToBlank(tempPriceList[i].ThisTimeSupplyPrice),
          LCostPriceCoefficient: PlessViewUtilsSub.nullToBlank(tempPriceList[i].CostPriceCoefficient),
          CostPriceCoefficient: PlessViewUtilsSub.nullToBlank(tempPriceList[i].CostPriceCoefficient),
          CostPriceSpecial1: PlessViewUtilsSub.nullToBlank(tempPriceList[i].CostPriceSpecial1),
          CostPriceSpecial2: PlessViewUtilsSub.nullToBlank(tempPriceList[i].CostPriceSpecial2),
          ThistimeCostPrice: PlessViewUtilsSub.nullToBlank(tempPriceList[i].ThisTimeCostPrice),
          CostPrice: PlessViewUtilsSub.nullToBlank(tempPriceList[i].CostPrice),
          Enabled: '1',
          DealCoopDiv: PlessViewUtilsSub.nullToBlank(tempPriceList[i].EnableMode) === 'true' ? true : false,
          PromotionDiv: tempPriceList[i].PromotionDiv,
          Caption: capStr,
          SupplyPriceToolTipText: this.getCoopPriceListToolTip(this.consumeTaxDiv, this.consumeTaxDivRate,
            PlessViewUtilsSub.nullToBlank(tempPriceList[i].ThisTimeSupplyPrice)),
          CostPriceToolTipText: this.getCoopPriceListToolTip(this.consumeTaxDiv, this.consumeTaxDivRate,
            PlessViewUtilsSub.nullToBlank(tempPriceList[i].ThisTimeCostPrice)),
          UseRegularFlg: tempPriceList[i].UseRegularFlg,
          EnabledCheck: tempPriceList[i].EnabledCheck,
        };
        coopPriceList.push(coopXml);
        this.kymw0900Component.itemRelatedCoop_CoopTab.push({CoopCode: coopXml.CoopCode, ItemCode: coopXml.SelectItemCode});
      }
      this.coopPriceList = coopPriceList;
      if (this.classCode === '01') {
        this.producingAreaCommentLock = false;
      }

      // バンドル固定の場合の非活性制御
      for (let i = Number(0); i < this.coopPriceList.length; i++) {
        const promotionDiv: string = this.coopPriceList[i].PromotionDiv;
        if (promotionDiv === 'B' || promotionDiv === 'P') {
          // 一括反映ボタンを非活性にする
          this.kymw0900Component.plessEnabled(this.kymw0900Component.btn_BatchReflection, false);
        }
      }
    }
  }

  /**
   * Ｐコード詳細情報タブデータを設定する
   *
   * @param data サーバからのレスポンスのデータ部分
   */
  private setPCodeDetail(data: any): void {
    // 初期化
    this.listingGoodsName = null;

    // 詳細情報一覧（データグリッド）の初期化
    if (this.coopDetailList === null) {
      this.coopDetailList = new Array<any>();
    }

    // 表組用項目一覧（データグリッド）の初期化
    if (this.listingItemList === null) {
      this.listingItemList = new Array<any>();
    }

    const coopDetailList = new Array<any>();

    let coopXml = {};
    if (data != null) {
      // 詳細情報一覧（データグリッド）の設定
      const tempCoopdetailList = data.PCodeDetail.CoopInfoList;
      for (let i = Number(0); i < tempCoopdetailList.length; i++) {
        coopXml = {
          CoopCode: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].CoopCode),
          CoopName: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].PlanCoopName),
          BrandType: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].BrandType),
          SetDiv: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].SetDiv),
          AssortTempDiv: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].AssortTempDiv),
          OrderNumQuotaCode: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].OrderNumQuotaCode),
          ProducingAreaComment1: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].ProducingAreaComment1),
          ProducingAreaComment2: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].ProducingAreaComment2),
          DetailUseRegularFlg: tempCoopdetailList[i].DetailUseRegularFlg,
          Enabled: this.coopPriceList[i].Enabled,
          ClassCode: this.classCode,
          BackProducingAreaComment1: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].ProducingAreaComment1),
          BackProducingAreaComment2: PlessViewUtilsSub.nullToBlank(tempCoopdetailList[i].ProducingAreaComment2),
        };
        coopDetailList.push(coopXml);
      }
      this.coopDetailList = coopDetailList;

      // 表組用項目一覧（データグリッド）の設定
      const listingItemList = new Array<any>();
      if (data.PCodeDetail.ListingItemList !== undefined) {
        const tempListingItemList = data.PCodeDetail.ListingItemList;
        for (let i = Number(0); i < tempListingItemList.length; i++) {
          coopXml = {
            ListingItemID: PlessViewUtilsSub.nullToBlank(tempListingItemList[i].ListingItemID),
            ListingItemName: PlessViewUtilsSub.nullToBlank(tempListingItemList[i].ListingItemName),
            DispContents: PlessViewUtilsSub.nullToBlank(tempListingItemList[i].DispContents),
          };
          listingItemList.push(coopXml);
        }
        this.listingItemList = listingItemList;
      }
    }
    // 表組用商品名
    this.listingGoodsName = PlessViewUtilsSub.nullToBlank(data.PCodeDetail.ListingGoodsName);
  }

  /**
   * Ｐコードマーク情報タブデータを設定する
   *
   * @param data サーバからのレスポンスのデータ部分
   */
  private setPCodeMark(data: any): void {

    // マーク情報一覧の初期化
    if (this.markList === null) {
      this.markList = new Array<any>();
    }

    // 選択マーク一覧の初期化
    if (this.selectedMarkList === null) {
      this.selectedMarkList = new Array<any>();
    }

    // 処理を整理
    // data!=null かつ data.PCodeMark!=nullかつdata.PCodeMarkに配列が存在している
    // かつ data.PCodeMark.GoodsMarkListに配列が存在している
    if (data != null && data.PCodeMark != null && !PlessViewUtilsSub.isEmptyArray(data.PCodeMark) &&
      !PlessViewUtilsSub.isEmptyArray(data.PCodeMark.GoodsMarkList)) {
      // マーク情報一覧を設定
      const tempMarkList = new Array<any>();
      const tempSelectMarkList = new Array<any>();
      for (let i = Number(0); i < data.PCodeMark.GoodsMarkList.length; i++) {
        tempMarkList.push({
          SelectValue: PlessViewUtilsSub.nullToBlank(data.PCodeMark.GoodsMarkList[i].GoodsMark) === '1' ? true : false,
          // MarkCodeRenderの処理をPlessViewUtilsSubで代用
          MarkCode: PlessViewUtilsSub.zeroPadding(3, PlessViewUtilsSub.nullToBlank(data.PCodeMark.GoodsMarkList[i].GoodsMarkCode)),
          MarkGroup: PlessViewUtilsSub.nullToBlank(data.PCodeMark.GoodsMarkList[i].GoodsMarkGroupCode),
          MarkName: PlessViewUtilsSub.nullToBlank(data.PCodeMark.GoodsMarkList[i].GoodsMarkName),
          MarkCaption: PlessViewUtilsSub.nullToBlank(data.PCodeMark.GoodsMarkList[i].GoodsMarkCaption),
        });
        if (tempMarkList[i].SelectValue) {
          tempSelectMarkList.push(tempMarkList[i]);
        }
      }
      this.markList = tempMarkList;
      // マーク情報一覧、選択マーク一覧（データグリッド）の設定
      this.createSelectedMarkList(tempSelectMarkList);
    }
  }

  /**
   * 選択マーク一覧（データグリッド）の設定を行う
   * チェック行のデータを基に表示用のフォーマットに変換する
   */
  public createSelectedMarkList(selectList: Array<any>): void {

    const tempSelectList = new Array<any>();

    if (selectList != null && !PlessViewUtilsSub.isEmptyArray(selectList)) {

      // 昇順に並び替え(マークグループ,マークコードの順)
      const tempMarkSelectList = selectList;
      tempMarkSelectList.sort(function (a, b) {
        if (Number(a.MarkGroup) > Number(b.MarkGroup)) {
          return 1;
        }
        if (Number(a.MarkGroup) < Number(b.MarkGroup)) {
          return -1;
        }
        if (Number(a.MarkCode) > Number(b.MarkCode)) {
          return 1;
        }
        if (Number(a.MarkCode) < Number(b.MarkCode)) {
          return -1;
        }
        return 0;
      });

      // 初期化
      let keyMarkGroup: string = <string>'';
      let dispCaption: string = <string>'';
      let dispName: string = <string>'';

      // var dispXML: XML;
      for (let i = Number(0); i <= tempMarkSelectList.length; i++) {
        // １行目の場合はキーを設定
        if (i === 0) {
          keyMarkGroup = tempMarkSelectList[i].MarkGroup;
        } else if (i === tempMarkSelectList.length) {
          // 配列最後の場合
          tempSelectList.push({
            MarkCaption: dispName,
            MarkName: dispCaption,
          });
          break;
        }

        if (keyMarkGroup !== tempMarkSelectList[i].MarkGroup) {
          // キーが変わったとき、または配列の最終処理の場合に追加
          tempSelectList.push({
            MarkCaption: dispName,
            MarkName: dispCaption,
          });
          // キーの上書き
          keyMarkGroup = tempMarkSelectList[i].MarkGroup;
          // dispNameのクリア
          dispName = '';
        } else {
          // 同一グループコードの場合は「,」区切りで内容を表示する
          if (dispName.length > 0) {
            dispName += ',';
          }
        }
        // ループ処理の終わりにデータを設定
        dispName += tempMarkSelectList[i].MarkName;
        dispCaption = tempMarkSelectList[i].MarkCaption;
      }
    }
    this.selectedMarkList = tempSelectList;
  }

  /**
   * Ｐコード付加情報タブデータを設定する
   *
   * @param data サーバからのレスポンスのデータ部分
   */
  private setPCodeTextInfo(data: any): void {
    // 初期化
    this.textInfo1 = null;
    this.textInfo2 = null;
    this.textInfo3 = null;
    this.textInfo4 = null;
    this.textInfo5 = null;
    this.textInfo6 = null;
    this.textInfo7 = null;
    this.textInfo8 = null;
    this.textInfo9 = null;
    this.textInfoA = null;
    this.textInfoB = null;
    this.textInfoC = null;
    this.textInfoD = null;
    this.textInfoE = null;
    this.textInfoF = null;
    this.textInfoG = null;
    this.textInfoH = null;
    this.textInfoI = null;
    this.textInfoJ = null;
    this.textInfoK = null;
    this.licencedNo = null;
    this.licencedDescription = null;

    // 文字情報種別1～21の初期化
    this.textInfoDivArray = this.initialInfoDivArray();
    // 文字情報連番1～21の初期化
    this.textKindNumArray = new Array(21);

    if (data.PCodeTextInfo.TextInfoList !== undefined) {
      // 商品付随文字情報リストの取得
      const tempTextInfoList: Array<any> = data.PCodeTextInfo.TextInfoList;

      // 商品付随文字情報種別（TextKindID）でどの項目に割り当てるか判定する
      for (let i = Number(0); i < tempTextInfoList.length; i++) {
        switch (PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID)) {
          // 商品説明
          case '001':
            // 文字情報種別1
            this.textInfoDivArray[0] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番1
            this.textKindNumArray[0] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 商品説明
            this.textInfo1 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // キャッチコピー
          case '004':
            // 文字情報種別2
            this.textInfoDivArray[1] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番2
            this.textKindNumArray[1] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // キャッチコピー
            this.textInfo2 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // おすすめコメント（吹き出し）
          case '018':
            // 文字情報種別3
            this.textInfoDivArray[2] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番3
            this.textKindNumArray[2] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // おすすめコメント(吹き出し)
            this.textInfo3 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 便利情報（囲み）
          case '019':
            // 文字情報種別4
            this.textInfoDivArray[3] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番4
            this.textKindNumArray[3] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 便利情報（囲み）
            this.textInfo4 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 便利情報（商品構成内容）
          case '008':
            // 文字情報種別5
            this.textInfoDivArray[4] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番5
            this.textKindNumArray[4] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 便利情報（商品構成内容）
            this.textInfo5 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 便利情報（その他）
          case '023':
            // 文字情報種別6
            this.textInfoDivArray[5] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番6
            this.textKindNumArray[5] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 便利情報（その他）
            this.textInfo6 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 便利情報（eフレンズ）
          case '022':
            // 文字情報種別7
            this.textInfoDivArray[6] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番7
            this.textKindNumArray[6] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 便利情報（ｅフレンズ）
            this.textInfo7 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 便利情報（サイズ他）
          case '024':
            // 文字情報種別8
            this.textInfoDivArray[7] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番8
            this.textKindNumArray[7] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 便利情報（サイズ他）
            this.textInfo8 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 取扱注意
          case '003':
            // 文字情報種別9
            this.textInfoDivArray[8] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番9
            this.textKindNumArray[8] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 取扱注意
            this.textInfo9 = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 届出番号
          case '032':
            // 文字情報種別10
            this.textInfoDivArray[9] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番10
            this.textKindNumArray[9] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 届出番号
            this.licencedNo = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            // 届出番号 誌面掲載フラグ
            if (!PlessViewUtilsSub.isEmpty(this.licencedNo)) {
              // 値が入力されている場合はtrue
              this.licencedNoValue = true;
            }
            break;
          // 届出表示・許可表示
          case '033':
            // 文字情報種別11
            this.textInfoDivArray[10] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番11
            this.textKindNumArray[10] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 届出表示・許可表示
            this.licencedDescription = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // EC用商品説明
          case '034':
            // 文字情報種別12
            this.textInfoDivArray[11] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番12
            this.textKindNumArray[11] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // EC用商品説明
            this.textInfoB = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 便利情報（月齢情報）
          case '035':
            // 文字情報種別12
            this.textInfoDivArray[12] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番12
            this.textKindNumArray[12] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 月齢情報
            this.textInfoC = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 人気商品情報
          case '039':
            // 文字情報種別13
            this.textInfoDivArray[13] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番13
            this.textKindNumArray[13] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 人気商品情報
            this.textInfoD = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 健康管理情報
          case '036':
            // 文字情報種別14
            this.textInfoDivArray[14] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番14
            this.textKindNumArray[14] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 健康管理情報
            this.textInfoE = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 成分情報
          case '037':
            // 文字情報種別14
            this.textInfoDivArray[15] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番14
            this.textKindNumArray[15] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 成分情報
            this.textInfoF = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 吸水量
          case '038':
            // 文字情報種別15
            this.textInfoDivArray[16] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番15
            this.textKindNumArray[16] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 吸水量
            this.textInfoG = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 調理時間の目安
          case '040':
            // 文字情報種別16
            this.textInfoDivArray[17] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番16
            this.textKindNumArray[17] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 調理時間の目安
            this.textInfoH = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 〇人前情報
          case '041':
            // 文字情報種別17
            this.textInfoDivArray[18] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番17
            this.textKindNumArray[18] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 〇人前情報
            this.textInfoI = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // 材料
          case '042':
            // 文字情報種別18
            this.textInfoDivArray[19] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番18
            this.textKindNumArray[19] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // 材料
            this.textInfoJ = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          // ご家庭で用意いただくもの
          case '043':
            // 文字情報種別19
            this.textInfoDivArray[20] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindID);
            // 文字情報連番19
            this.textKindNumArray[20] = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].TextKindNum);
            // ご家庭で用意いただくもの
            this.textInfoK = PlessViewUtilsSub.nullToBlank(tempTextInfoList[i].StringValue);
            break;
          default:
            break;
        }
      }
    } else {
      // 商品説明
      this.textInfoDivArray[0] = '001';
      this.textKindNumArray[0] = '';
      this.textInfo1 = '';
      // キャッチコピー
      this.textInfoDivArray[1] = '004';
      this.textKindNumArray[1] = '';
      this.textInfo2 = '';
      // おすすめコメント（吹き出し）
      this.textInfoDivArray[2] = '018';
      this.textKindNumArray[2] = '';
      this.textInfo3 = '';
      // 便利情報（囲み）
      this.textInfoDivArray[3] = '019';
      this.textKindNumArray[3] = '';
      this.textInfo4 = '';
      // 便利情報（商品構成内容）
      this.textInfoDivArray[4] = '008';
      this.textKindNumArray[4] = '';
      this.textInfo5 = '';
      // 便利情報（その他）
      this.textInfoDivArray[5] = '023';
      this.textKindNumArray[5] = '';
      this.textInfo6 = '';
      // 便利情報（eフレンズ）
      this.textInfoDivArray[6] = '022';
      this.textKindNumArray[6] = '';
      this.textInfo7 = '';
      // 便利情報（サイズ他）
      this.textInfoDivArray[7] = '024';
      this.textKindNumArray[7] = '';
      this.textInfo8 = '';
      // 取扱注意
      this.textInfoDivArray[8] = '003';
      this.textKindNumArray[8] = '';
      this.textInfo9 = '';
      // 届出番号
      this.textInfoDivArray[9] = '032';
      this.textKindNumArray[9] = '';
      this.licencedNoValue = false;
      this.licencedNo = '';
      // 届出表示・許可表示
      this.textInfoDivArray[10] = '033';
      this.textKindNumArray[10] = '';
      this.licencedDescription = '';
      // EC用商品説明
      this.textInfoDivArray[11] = '034';
      this.textKindNumArray[11] = '';
      this.textInfoB = '';
      // 便利情報（月齢情報）
      this.textInfoDivArray[12] = '035';
      this.textKindNumArray[12] = '';
      this.textInfoC = '';
      // 人気商品情報
      this.textInfoDivArray[13] = '039';
      this.textKindNumArray[13] = '';
      this.textInfoD = '';
      // 健康管理情報
      this.textInfoDivArray[14] = '036';
      this.textKindNumArray[14] = '';
      this.textInfoE = '';
      // 成分情報
      this.textInfoDivArray[15] = '037';
      this.textKindNumArray[15] = '';
      this.textInfoF = '';
      // 吸水量
      this.textInfoDivArray[16] = '038';
      this.textKindNumArray[16] = '';
      this.textInfoG = '';
      // 調理時間の目安
      this.textInfoDivArray[17] = '040';
      this.textKindNumArray[17] = '';
      this.textInfoH = '';
      // 〇人前情報
      this.textInfoDivArray[18] = '041';
      this.textKindNumArray[18] = '';
      this.textInfoI = '';
      // 材料
      this.textInfoDivArray[19] = '042';
      this.textKindNumArray[19] = '';
      this.textInfoJ = '';
      // ご家庭で用意いただくもの
      this.textInfoDivArray[20] = '043';
      this.textKindNumArray[20] = '';
      this.textInfoK = '';
    }
    // 変更有無確認用のリストを初期化
    for (let j = Number(0); j < 10; j++) {
      this.oldTextInfoList[j] = '';
    }

    // バイヤーコメント
    this.textInfoA = PlessViewUtilsSub.nullToBlank(data.PCodeTextInfo.BuyerComment);
  }

  /**
   * 文字情報種別初期化
   *
   * @private
   * @returns {Array<any>}
   * @memberof KYMW0900Model
   */
  private initialInfoDivArray(): Array<any> {
    // 要素は21個
    const initialArray = new Array(11);
    // 0番目 = 001
    initialArray[0] = '001';
    // 1番目 = 004
    initialArray[1] = '004';
    // 2番目 = 018
    initialArray[2] = '018';
    // 3番目 = 019
    initialArray[3] = '019';
    // 4番目 = 008
    initialArray[4] = '008';
    // 5番目 = 023
    initialArray[5] = '023';
    // 6番目 = 022
    initialArray[6] = '022';
    // 7番目 = 024
    initialArray[7] = '024';
    // 8番目 = 003
    initialArray[8] = '003';
    // 項番1925 START
    // 9番目 = 032
    initialArray[9] = '032';
    // 10番目 = 033
    initialArray[10] = '033';
    // 11番目 = 034
    initialArray[11] = '034';
    // 12番目 = 035
    initialArray[12] = '035';
    // 13番目 = 039
    initialArray[13] = '039';
    // 14番目 = 036
    initialArray[14] = '036';
    // 15番目 = 037
    initialArray[15] = '037';
    // 16番目 = 038
    initialArray[16] = '038';
    // 17番目 = 040
    initialArray[17] = '040';
    // 18番目 = 041
    initialArray[18] = '041';
    // 19番目 = 042
    initialArray[19] = '042';
    // 20番目 = 043
    initialArray[20] = '043';
    return initialArray;
  }

  /**
   * Ｐコード発注物流タブデータを設定する
   *
   * @private
   * @param {Object} data
   * @memberof KYMW0900Model
   */
  private setPCodeOrderPD(data: any): void {
    // 初期化
    this.stinkGoodsDiv = null;
    this.caseSupplyDiv = null;
    this.longKeepDiv = null;
    this.arrivalAreaDiv = null;
    this.arrivalGoodsTemp = null;
    this.arrivalAdminDays = null;

    // 臭い商品区分
    this.stinkGoodsDiv = PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.StinkGoodsDiv);

    // ケース供給区分
    this.caseSupplyDiv = PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.CaseSupplyDiv);

    // 長期保存区分
    this.longKeepDiv = PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.LongKeepDiv);

    // 入荷場所区分
    this.arrivalAreaDiv = PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.ArrivalAreaDiv);

    // 入荷許可品温
    this.arrivalGoodsTemp = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.ArrivalGoodsTemp));

    // 入荷管理日数
    this.arrivalAdminDays = PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.ArrivalAdminDays));

    // 項番1215 START
    // 業態区分（デイリー）
    this.dutiesFormDailyDiv = PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.DutiesFormDailyDiv);

    // 業態区分（スポット）
    this.dutiesFormSpotDiv = PlessViewUtilsSub.nullToBlank(data.PCodeOrderPD.DutiesFormSpotDiv);

    // 一時変数に業態区分（デイリー）をセット
    this.kymw0900Component.tmpDutiesFormDailyDiv = this.dutiesFormDailyDiv;

  }

  /**
   * Ｐコード組合員の声タブデータを設定する
   *
   * @private
   * @memberof KYMW0900Model
   */
  private setPCodePublishVoice(data: any): void {
    // 組合員の声リストの取得
    const tempPCodePublishVoice: Array<any> = data.PCodePublishVoice.CoopPublishVoiceList;

    // 生協コード1～8の初期化
    this.coopCodeArray = new Array(tempPCodePublishVoice.length);

    // 生協名称1～8の初期化
    this.coopNameArray = new Array(tempPCodePublishVoice.length);

    // 生協選択ロック1～8の初期化
    this.selectLockArray = new Array(tempPCodePublishVoice.length);

    // 生協選択フラグ1～8の初期化
    this.selectValueArray = new Array(tempPCodePublishVoice.length);

    // 組合員の声1～8の初期化
    this.inquiryContentsArray = new Array(tempPCodePublishVoice.length);

    // 受付番号1～8の初期化
    this.receiptNumArray = new Array(tempPCodePublishVoice.length);

    for (let i = Number(0); i < tempPCodePublishVoice.length; i++) {
      // 生協コード
      this.coopCodeArray[i] = PlessViewUtilsSub.nullToBlank(tempPCodePublishVoice[i].CoopCode);

      // 生協名称
      this.coopNameArray[i] = PlessViewUtilsSub.nullToBlank(tempPCodePublishVoice[i].PlanCoopName);

      // 受付番号
      this.receiptNumArray[i] = PlessViewUtilsSub.nullToBlank(tempPCodePublishVoice[i].ReceiptNum);

      // 生協選択ロック（受付番号が設定されている場合、選択ロックをかける）
      // ロック=true 未ロック=false
      this.selectLockArray[i] =
        PlessViewUtilsSub.isEmpty(PlessViewUtilsSub.nullToBlank(tempPCodePublishVoice[i].ReceiptNum)) ?
          (this.coopPriceList[i].DealCoopDiv ? (this.coopPriceList[i].Enabled === '1' ? true : false) : false) : false;

      // 組合員の声
      this.inquiryContentsArray[i] =
        PlessViewUtilsSub.trim(PlessViewUtilsSub.nullToBlank(tempPCodePublishVoice[i].CorrectInquiryContents));
    }
    // 組合員の声(表示時)
    this.inquiryContentsArrayBefore = this.inquiryContentsArray;
  }

  /**
   * Ｐコード計画数タブデータを設定する
   *
   * @private
   * @param {any} data
   * @memberof KYMW0900Model
   */
  private setPCodePlanNum(data: any): void {

    // 合計計画数
    this.plannumTotal = data.PCodePlanNum.PlanNumTotal;

    // 計画数一覧（データグリッド）の初期化
    if (this.planList === null) {
      this.planList = new Array<any>();
    }

    if (data != null) {
      // 計画数一覧（データグリッド）の設定
      const limitnumTotalList: Array<any> = data.PCodePlanNum.CoopPlanNumList;
      const tempPlanList = new Array<any>();
      let coopXml = {};

      // 一行目に合計計画数を設定する
      coopXml = ({
        CoopCode: '',
        CoopName: '合計',
        PlanNumAiPrediction: PlessViewUtilsSub.nullToBlank(data.PCodePlanNum.PlanNumAiPredictionTotal),
        Plannum: PlessViewUtilsSub.nullToBlank(data.PCodePlanNum.PlanNumTotal),
        LimitnumTotal: this.CalcLimitnumTotal(limitnumTotalList),
        LimitnumPerson: '',
        DeliveryLeadTimeType: '',
        DelivCatalogID: '',
        Enabled: '1',
      });
      tempPlanList.push(coopXml);

      for (let i = Number(0); i < limitnumTotalList.length; i++) {
        // Enableの値を取り出す
        let tempEnable: string = <string>'1';

        if (!this.coopPriceList[i].DealCoopDiv) {
          // 対象生協外
          tempEnable = '0';
        }
        coopXml = ({
          CoopCode: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].CoopCode),
          CoopName: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].PlanCoopName),
          PlanNumAiPrediction: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].PlanNumAiPrediction),
          Plannum: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].PlanNum),
          LimitnumTotal: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].LimitNumTotal),
          LimitnumPerson: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].LimitNumPerson),
          DeliveryLeadTimeType: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].DeliveryLeadTimeType),
          DelivCatalogID: PlessViewUtilsSub.nullToBlank(limitnumTotalList[i].DelivCatalogId),
          Enabled: tempEnable,
        });
        tempPlanList.push(coopXml);
        // manage.配達企画回がnullだった場合
        if (PlessViewUtilsSub.isEmpty(this.delivCatalogID)) {
          // manage.配達企画回に、サーバからのレスポンスのデータ.配達企画回をセットする
          this.delivCatalogID = tempPlanList[i + 1].DelivCatalogID;
        }
      }
      this.planList = tempPlanList;
    }
    // 比較用のリストに値を保持する
    this.setOldPlanList();
  }


  /**
   * 限定数量総数（合計）計算
   *
   * @private
   * @param {*} tempPlanList
   * @returns {number}
   * @memberof KYMW0900Model
   */
  private CalcLimitnumTotal(tempPlanList: any): number {
    // サーバからのレスポンスデータ（計画数一覧）を取得
    if (tempPlanList === null) {
      return 0;
    }
    let limitnumTotal: number = <number>0;
    for (let i = Number(0); i < tempPlanList.length; i++) {
      // limitnumTotal取得
      const tempVal = Number(PlessViewUtilsSub.nullToBlank(tempPlanList[i].LimitNumTotal));
      // 加算
      limitnumTotal += tempVal;
    }
    return limitnumTotal;
  }

  /**
   * Ｐコード案内タブデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPCodeGuide(data: any): void {

    // 案内一覧（データグリッド）の初期化
    if (this.guideList === null) {
      this.guideList = new Array<any>();
    }

    if (data != null) {
      // 案内一覧（データグリッド）の設定
      const tempGuideList: Array<any> = data.NextGuideInfoList;
      // 次回案内媒体区分リストの設定
      this.nextGuideMediumTypeList = data.NextGuideMediumTypeList;

      const guideList: Array<any> = new Array<any>();

      for (let i = Number(0); i < tempGuideList.length; i++) {
        const nextGuideMap: Array<any> = new Array<any>();
        for (const item of this.nextGuideMediumTypeList) {
          const nextGuide = tempGuideList[i].NextGuideList.find((nextGuide) => {
            return nextGuide.MediumType === item.MediumType;
          });
          if (nextGuide == null) {
            nextGuideMap[item.MediumType] = '';
          } else {

            nextGuideMap[nextGuide.MediumType] = nextGuide.NextGuide;
          }
        }

        const tempEnabled: string = this.coopPriceList[i].Enabled;

        const coopXml = {
          CoopCode: PlessViewUtilsSub.nullToBlank(tempGuideList[i].CoopCode),
          CoopName: this.convertCoopName(tempGuideList[i].CoopCode),
          OrderNum: PlessViewUtilsSub.nullToBlank(tempGuideList[i].OrderNum),
          AppearDiv: PlessViewUtilsSub.nullToBlank(tempGuideList[i].AppearDiv),
          NextGuideMap: nextGuideMap,
          Enabled: tempEnabled,
        };
        guideList.push(coopXml);
      }
      this.guideList = guideList;
      // ・案内タブ「案内一覧」の当該会員生協の行（登録区分、次回案内）を入力可能（活性化）にする。
      this.coopPriceList.forEach(coop => {
        this.setNextGuideListEnabled(coop.CoopCode, coop.SelectValue);
      })

    }
  }

  // 生協コードに応じて、生協名を返却する
  public convertCoopName(coopCode: string): string {
    let coopName = '';
    switch (coopCode) {
      case this.kymw0900Component.kymw00Model.COOP_CODE_IB:
        coopName = this.kymw0900Component.kymw00Model.COOP_IB;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_TO:
        coopName = this.kymw0900Component.kymw00Model.COOP_TO;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_GU:
        coopName = this.kymw0900Component.kymw00Model.COOP_GU;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_TI:
        coopName = this.kymw0900Component.kymw00Model.COOP_TI;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_SA:
        coopName = this.kymw0900Component.kymw00Model.COOP_SA;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_TK:
        coopName = this.kymw0900Component.kymw00Model.COOP_TK;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_NA:
        coopName = this.kymw0900Component.kymw00Model.COOP_NA;
        break;
      case this.kymw0900Component.kymw00Model.COOP_CODE_NI:
        coopName = this.kymw0900Component.kymw00Model.COOP_NI;
        break;
    }
    return coopName;
  }

  /**
   * 媒体別数COUNT
   *
   * @private
   * @param {Array<any>} mediumTextList
   * @param {string} str
   * @returns {number}
   * @memberof KYMW0900Model
   */
  private getListCount(mediumTextList: Array<any>, str: string): number {
    let count: number = <number>0;
    for (let i = Number(0); i < this.mediumTextList.length; i++) {
      const tempVO = this.mediumTextList[i];
      if (tempVO.textKindId === str) {
        count++;
      }
    }
    return count;
  }

  /**
   * 注文コード割当設定
   *
   * @private
   * @param {*} dataList
   * @memberof KYMW0900Model
   */
  private updateOrderNumQuotaList(dataList: any): void {

    // 各Listに空白を入れる
    this.orderNumQuotaList_Ibaraki.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Tochigi.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Gunma.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Chiba.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Saitama.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Tokyo.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Nagano.push(this.getBlankObjectForOrderNumQuota());
    this.orderNumQuotaList_Niigata.push(this.getBlankObjectForOrderNumQuota());

    if (dataList != null) {
      for (let i = Number(0); i < dataList.length; i++) {
        // 追加するObjectの生成
        const addObject = {
          OrderNumQuotaCode: '',
          OrderNumQuotaName: '',
          DelivCatalogID: '',
          DeliveryWeekFixFlag: '',
          OrderNumQuotaCodeName: '',
        };
        addObject.OrderNumQuotaCode = dataList[i].OrderNumQuotaCode;
        addObject.OrderNumQuotaName = dataList[i].OrderNumQuotaName;
        addObject.DelivCatalogID = dataList[i].DelivCatalogID;
        addObject.DeliveryWeekFixFlag = dataList[i].DeliveryWeekFixFlag;

        // ラベルに表示させる名称の設定
        addObject.OrderNumQuotaCodeName = '';
        if (!PlessViewUtilsSub.isEmpty(dataList[i].OrderNumQuotaCode) &&
          !PlessViewUtilsSub.isEmpty(dataList[i].OrderNumQuotaName)) {
          addObject.OrderNumQuotaCodeName = dataList[i].OrderNumQuotaCode + ':' + dataList[i].OrderNumQuotaName;
        } else {
          addObject.OrderNumQuotaCodeName = dataList[i].OrderNumQuotaCode + dataList[i].OrderNumQuotaName;
        }

        // 生協コードに応じて、どのListに追加するか決定する
        switch (dataList[i].CoopCode) {
          case this.kymw0900Component.kymw00Model.COOP_CODE_IB:
            this.orderNumQuotaList_Ibaraki.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_TO:
            this.orderNumQuotaList_Tochigi.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_GU:
            this.orderNumQuotaList_Gunma.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_TI:
            this.orderNumQuotaList_Chiba.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_SA:
            this.orderNumQuotaList_Saitama.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_TK:
            this.orderNumQuotaList_Tokyo.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_NA:
            this.orderNumQuotaList_Nagano.push(addObject);
            break;
          case this.kymw0900Component.kymw00Model.COOP_CODE_NI:
            this.orderNumQuotaList_Niigata.push(addObject);
            break;
        }
      }
    }
  }

  /**
   * 注文コード割当用の空白オブジェクトを取得する
   *
   * @private
   * @returns {Object}
   * @memberof KYMW0900Model
   */
  private getBlankObjectForOrderNumQuota(): any {
    const addObject = {
      OrderNumQuotaCode: '',
      OrderNumQuotaName: '',
      DelivCatalogID: '',
      DeliveryWeekFixFlag: '',
      OrderNumQuotaCodeName: '',
    };
    return addObject;
  }

  /**
   *
   *
   * @param {*} value
   * @returns {boolean}
   * @memberof KYMW0900Model
   */
  public isEditText(value: any): boolean {
    if (value === '1' || value === 'true') {
      // 閲覧モード時の設定
      if (this.permission === '1') {
        return false;
      } else {
        return true;
      }
    }
    return false;
  }

  /**
 * 計画数タブ「計画数一覧」の合計を再計算し、合計との一致チェックを行う
 * @return 計画数
 *
 */
  public checkPlanListSum(): boolean {

    // 現在表示中の計画数一覧（データグリッド）を取得
    const viewPlanList = this.kymw0900Component.dtg_PlanList.collectionView.items;
    // 計画数（合計）
    let planNumTotal: number = <number>0;
    // 戻り値
    let result: boolean = <boolean>true;

    // 各会員生協の計画数を再計算
    for (let j = Number(1); j < viewPlanList.length; j++) {
      // 計画数合計を計算
      planNumTotal += Number(viewPlanList[j].Plannum);
    }

    //  表示中の合計値と再計算した合計値の一致をチェック
    if (Number(viewPlanList[0].Plannum) !== planNumTotal) {
      result = false;
    }
    return result;
  }

  /**
   * プロモ設定タブ.抽選商品プロモーション.抽選商品当選数と月～金曜日当選数(予定)の合計値との一致チェックを行う
   * @return true：一致 / false：不一致
   */
  public checkWinningGoodsNum(item: any): boolean {
    // 戻り値
    let result: boolean = <boolean>true;
    // 全て空文字の場合は必須チェックでエラーになるようにするため、抽選商品当選数が空文字の場合は0とするように修正
    const viewWinningGoodsNum = item.winningGoodsNum !== '' ? PlessViewUtilsSub.stringToNumber(item.winningGoodsNum): 0;
    const mondayPlanNum = PlessViewUtilsSub.stringToNumber(item.mondayPlanNum);
    const tuesdayPlanNum = PlessViewUtilsSub.stringToNumber(item.tuesdayPlanNum);
    const wednesdayPlanNum = PlessViewUtilsSub.stringToNumber(item.wednesdayPlanNum);
    const thursdayPlanNum = PlessViewUtilsSub.stringToNumber(item.thursdayPlanNum);
    const fridayPlanNum = PlessViewUtilsSub.stringToNumber(item.fridayPlanNum);
    // 月～金曜日当選数(予定)の合計値
    const dayOfWeekPlanNumTotal = mondayPlanNum + tuesdayPlanNum + wednesdayPlanNum + thursdayPlanNum + fridayPlanNum;

    // 抽選商品当選数と再計算した合計値の一致をチェック
    if (viewWinningGoodsNum !== dayOfWeekPlanNumTotal) {
      result = false;
    }
    return result;
  }

  /**
 * 【アイテムコード変更、変更確認ボタン押下】
 * アイテム情報編集エリアの表示内容をアイテムコード情報リストにコピーする
 *
 */
  public copyDispContentsToItemCodeInfoList(): void {
    // アイテムコード変更前のアイテムコード情報
    const itemCodeInfo = this.itemCodeInfoList[this.selectedItemCodeIndex];
    // アイテムコード情報共通データをコピー
    this.copyDispDataToItemCodeCommon(itemCodeInfo.ItemCodeCommon);
    // アイテムコード情報アイテムタブデータをコピー
    this.copyDispDataToItemCodeBase(itemCodeInfo.ItemCodeBase);
    // アイテムコード情報仕様書１タブデータをコピー
    this.copyDispDataToItemCodeSpec1(itemCodeInfo.ItemCodeSpec1);
    // アイテムコード情報仕様書２タブデータをコピー
    this.copyDispDataToItemCodeSpec2(itemCodeInfo.ItemCodeSpec2);
    // アイテムコード情報環境タブデータをコピー
    this.copyDispDataToItemCodeEcology(itemCodeInfo.ItemCodeEcology);
  }

  /**
   * 変更確認画面表示
   *
   * @param {*} serverData
   * @memberof KYMW0900Model
   */
  public showChangeConfirmation(serverData: any): void {
    // ・『変更確認』画面（KYMW0901）を呼び出す。
    this.kymw0900Component.moveInfoKYMW0901();
  }

  /**
   * グループコンボボックスの変更値による供給促進マークの絞り込みを行う
   *
   * @param group グループ選択値
   */
  public narrowingMarkInfoList(group: string): void {
    this.markGroup = group;
    // 表示全情報保持リストより情報を取得
    let tempMarkInfoMain: Array<any> = PlessViewUtilsSub.getCloneArray(this.markInfoListMain);
    const tempMarkInfo: Array<any> = PlessViewUtilsSub.getCloneArray(this.markInfoList);
    // 表示用情報の初期化
    const tmpMarkInfoMainList: Array<any> = new Array<any>();
    const tmpMarkInfoList: Array<any> = new Array<any>();

    // グループ選択値無し時
    if (PlessViewUtilsSub.isEmpty(this.markGroup)) {
      // ループカウンタ
      // 項番2231 START 障害管理NO.U01596対応
      let count = Number(0);
      let selectValue1: boolean = <boolean>false;
      let selectValue2: boolean = <boolean>false;
      let selectValue3: boolean = <boolean>false;
      let selectValue4: boolean = <boolean>false;
      let selectValue5: boolean = <boolean>false;
      let selectValue6: boolean = <boolean>false;
      let selectValue7: boolean = <boolean>false;
      let selectValue8: boolean = <boolean>false;
      // 供給促進マーク一覧の再設定
      for (let i = Number(0); i < tempMarkInfoMain.length; i++) {
        if (tempMarkInfo[count].MarkCode === tempMarkInfoMain[i].MarkCode &&
          tempMarkInfo[count].MarkGroupCode === tempMarkInfoMain[i].MarkGroupCode) {
          // マークコードとマークグループコードが一致する場合、tempMarkInfoから設定
          selectValue1 = tempMarkInfo[count].SelectValue1;
          selectValue2 = tempMarkInfo[count].SelectValue2;
          selectValue3 = tempMarkInfo[count].SelectValue3;
          selectValue4 = tempMarkInfo[count].SelectValue4;
          selectValue5 = tempMarkInfo[count].SelectValue5;
          selectValue6 = tempMarkInfo[count].SelectValue6;
          selectValue7 = tempMarkInfo[count].SelectValue7;
          selectValue8 = tempMarkInfo[count].SelectValue8;
          if (count < tempMarkInfo.length - 1) {
            count++;
          }
        } else {
          // 上記以外の場合、保持した情報から設定
          selectValue1 = tempMarkInfoMain[i].SelectValue1;
          selectValue2 = tempMarkInfoMain[i].SelectValue2;
          selectValue3 = tempMarkInfoMain[i].SelectValue3;
          selectValue4 = tempMarkInfoMain[i].SelectValue4;
          selectValue5 = tempMarkInfoMain[i].SelectValue5;
          selectValue6 = tempMarkInfoMain[i].SelectValue6;
          selectValue7 = tempMarkInfoMain[i].SelectValue7;
          selectValue8 = tempMarkInfoMain[i].SelectValue8;
        }
        const tempMarkGroup = {
          MarkCode: PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[i].MarkCode),
          MarkGroupCode: PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[i].MarkGroupCode),
          MarkName: PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[i].MarkName),
          SelectValue1: selectValue1,
          SelectValue2: selectValue2,
          SelectValue3: selectValue3,
          SelectValue4: selectValue4,
          SelectValue5: selectValue5,
          SelectValue6: selectValue6,
          SelectValue7: selectValue7,
          SelectValue8: selectValue8,
        };
        tmpMarkInfoList.push(tempMarkGroup);
      }
    } else {  // グループ選択値有り時
      let count = 0;

      if (tempMarkInfoMain.length === tempMarkInfo.length) {
        tempMarkInfoMain = PlessViewUtilsSub.getCloneArray(tempMarkInfo);
      }
      // 供給促進マーク一覧の再設定
      for (let j = Number(0); j < tempMarkInfoMain.length; j++) {
        const markGroupCode = PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[j].MarkGroupCode);

        // 対象のマークグループのみ設定
        if (markGroupCode === this.markGroup) {
          const tempMarkGroup = {
            MarkCode: PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[j].MarkCode),
            MarkGroupCode: PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[j].MarkGroupCode),
            MarkName: PlessViewUtilsSub.nullToBlank(tempMarkInfoMain[j].MarkName),
            SelectValue1: tempMarkInfoMain[j].SelectValue1,
            SelectValue2: tempMarkInfoMain[j].SelectValue2,
            SelectValue3: tempMarkInfoMain[j].SelectValue3,
            SelectValue4: tempMarkInfoMain[j].SelectValue4,
            SelectValue5: tempMarkInfoMain[j].SelectValue5,
            SelectValue6: tempMarkInfoMain[j].SelectValue6,
            SelectValue7: tempMarkInfoMain[j].SelectValue7,
            SelectValue8: tempMarkInfoMain[j].SelectValue8,
          };
          tmpMarkInfoList.push(tempMarkGroup);
          tmpMarkInfoMainList.push(tempMarkGroup);
          count++;
        } else {
          tmpMarkInfoMainList.push(tempMarkInfoMain[j]);
        }
      }
      this.markInfoListMain = tmpMarkInfoMainList;
    }
    // 供給促進マーク一覧（データグリッド）を再表示
    this.markInfoList = tmpMarkInfoList;
  }

  /**
   * 【一括反映ボタン押下】
   * 一括反映ボタン押下時に、会員生協タブ「価格一覧」の今回供給価格、
   * 今回仕入価格、仕入価格を更新する
   *
   * @param priceDataProvider 会員生協タブの価格一覧dataProvider
   * @param supplyPrice 供給価格
   * @param costPrice   仕入価格
   */
  public reflectPriceList(priceDataProvider: any, supplyPrice: number, costPrice: number, workValue: any): void {

    // 現在表示中の会員生協価格一覧（データグリッド）を取得
    const viewCoopPriceList: Array<any> = priceDataProvider;

    // 再作成用の会員生協価格一覧リストの初期化
    const tempCoopPriceList: Array<any> = new Array<any>();

    for (let i = Number(0); i < viewCoopPriceList.length; i++) {
      // アイテムコードを取得
      const settingItemCode: string = viewCoopPriceList[i].SelectItemCode;
      // 今回供給価格、今回仕入価格、仕入価格を取得
      let settingThistimeSupplyPrice: string = viewCoopPriceList[i].ThistimeSupplyPrice;
      let settingThistimeCostPrice: string = viewCoopPriceList[i].ThistimeCostPrice;
      let settingCostPrice: string = viewCoopPriceList[i].CostPrice;

      // ※価格一覧の選択チェック有効かつ「アイテムコード」コンボボックスが選択されている生協を「今回供給価格」の一括反映対象とする。
      if (viewCoopPriceList[i].SelectValue && !PlessViewUtilsSub.isEmpty(settingItemCode) && settingItemCode !== '0') {
        // ・「供給（今回）」の価格が入力されている場合、各生協の「今回供給価格」にセットする。
        if (supplyPrice > 0) {
          settingThistimeSupplyPrice = String(supplyPrice);
        }
      }
      // ※価格一覧の「アイテムコード」コンボボックスが選択されている生協を「今回仕入価格」の一括反映対象とする。
      if (!PlessViewUtilsSub.isEmpty(settingItemCode) && settingItemCode !== '0') {
        // ・「仕入（今回）」の価格が入力されている場合、各生協の「今回仕入価格」にセットし、
        // 　「仕入（今回）」の価格と各生協に紐付くアイテム情報の「価格バンドル」を乗じた値を「仕入価格」にセットする。
        if (costPrice > 0) {
          const bundlePrice: number = <number>this.getBundlePriceForItemCode(viewCoopPriceList[i].SelectItemCode);
          settingThistimeCostPrice = String(costPrice);
          settingCostPrice = String(costPrice * bundlePrice);
        }
      }

      let selectedPricePattern: string = <string>'';
      // ※価格一覧の「アイテムコード」コンボボックスが選択されている生協を「価格パターン」一括反映対象とする。
      if (!PlessViewUtilsSub.isEmpty(workValue) && !PlessViewUtilsSub.isEmpty(settingItemCode) && settingItemCode !== '0') {
        selectedPricePattern = workValue.toString();
      } else {
        selectedPricePattern = viewCoopPriceList[i].SelectPricePattern.toString();
      }
      const coopXml = {
        CoopCode: viewCoopPriceList[i].CoopCode,
        CoopNum: viewCoopPriceList[i].CoopNum,
        CoopName: viewCoopPriceList[i].CoopName,
        CoopShortName: viewCoopPriceList[i].CoopShortName,
        SelectValue: viewCoopPriceList[i].SelectValue,
        SelectItemCode: settingItemCode,
        SelectPricePattern: selectedPricePattern,
        LSupplyPricecoefficient: viewCoopPriceList[i].LSupplyPricecoefficient,
        SupplyPricecoefficient: viewCoopPriceList[i].SupplyPricecoefficient,
        SupplyPriceSpecial1: viewCoopPriceList[i].SupplyPriceSpecial1,
        SupplyPriceSpecial2: viewCoopPriceList[i].SupplyPriceSpecial2,
        ThistimeSupplyPrice: settingThistimeSupplyPrice,
        LCostPriceCoefficient: viewCoopPriceList[i].LCostPriceCoefficient,
        CostPriceCoefficient: viewCoopPriceList[i].CostPriceCoefficient,
        CostPriceSpecial1: viewCoopPriceList[i].CostPriceSpecial1,
        CostPriceSpecial2: viewCoopPriceList[i].CostPriceSpecial2,
        ThistimeCostPrice: settingThistimeCostPrice,
        CostPrice: settingCostPrice,
        Enabled: viewCoopPriceList[i].Enabled,
        Caption: viewCoopPriceList[i].Caption,
        DealCoopDiv: viewCoopPriceList[i].DealCoopDiv,
        PromotionDiv: viewCoopPriceList[i].PromotionDiv,
        SupplyPriceToolTipText: viewCoopPriceList[i].SupplyPriceToolTipText,
        CostPriceToolTipText: viewCoopPriceList[i].CostPriceToolTipText,
        EnabledCheck: viewCoopPriceList[i].EnabledCheck,
      };
      tempCoopPriceList.push(coopXml);
    }
    // 作成したものを価格一覧（データグリッド）に再設定
    this.coopPriceList = tempCoopPriceList;
    this.kymw0900Component.pricePatternBtnClick();
    this.kymw0900Component.editCount++;
  }


  /**
   * 【アイテムコード変更】
   * アイテム情報編集エリアの表示内容を変更する
   *
   * @param itemCode アイテムコードの選択値（変更後の選択値）
   */
  public changeItemInfoEditArea(itemCode: string): void {
    // アイテム情報編集エリアの表示内容をアイテムコード情報リストにコピー
    this.copyDispContentsToItemCodeInfoList();

    // アイテムコードのindex件目を表示項目に設定
    this.setPlanGoodsItemForDisp(this.itemCodeInfoList, itemCode);
  }

  /**
   * 初期表示管理データをクリアする
   *
   */
  public resetInitData(): void {
    // 初期表示管理データ（アイテムコード一覧）
    this.initItemCodeList = new Array<any>();
    // 初期表示管理データ（企画商品（アイテムグリッド情報））
    this.initItemGridContent = new Array<any>();
    // 初期表示管理データ（企画商品（Ｐコード情報））
    this.initPlanGoodsBase = new Array<any>();
    // 初期表示管理データ（企画商品（アイテム情報））
    this.initPlanGoodsItem = new Array<any>();
    // 部門分類管理NO
    this.classDivNum = '';
    // バイヤーコード
    this.buyerCode = '';
    // 包材一括表示確認
    this.packMaterialShowFlag = false;
    // 部門コード
    this.classCode = '';
    this.kymw0900Component.cmb_ClassCode.selectedClassCode = '';
    // 大分類
    this.largeClassCode = '';
    // 中分類
    this.middleClassCode = '';
    // 小分類
    this.smallClassCode = '';
    // データ種別
    this.dataType = '';
    // 商品案内用商品名
    this.guideGoodsName = '';
    // 商品案内用規格名
    this.guideStandardName = '';
    // 媒体区分
    this.mediumType = '';
    // 登録日時
    this.registDate = '';
    // 更新日時
    this.updateDate = '';

    // Ｐコード基本情報タブデータ
    // お届け明細用商品名（漢字）
    this.deliveryGoodsNameKanji = '';
    // お届け明細用商品名（カナ）
    this.deliveryGoodsNameKana = '';
    // お届け明細用規格名（漢字）
    this.deliveryStandardNameKanji = '';
    // お届け明細用規格名（カナ）
    this.deliveryStandardNameKana = '';
    // OCR商品名
    this.ocrGoodsName = '';
    // 消費税区分
    this.consumeTaxDiv = '';
    // 消費税率
    this.consumeTaxDivRate = '';
    // サイクル期間
    this.cycleTerm = '';
    // ＥＤＬＰ商品区分
    this.edlpDiv = '';
    // 商品案内温度帯区分
    this.roomTempZoneDiv = '';
    // ユニットプライス区分
    this.unitPriceDiv = '';
    // ユニットプライス係数
    this.unitPriceCoefficient = '';
    // ユニットプライス単位
    this.unitPriceUnit = '';
    // 賞味期間
    this.consumeTerm = '';
    // 消費期限
    this.consumeByDate = '';
    // 残賞味期間（配達時）
    this.leaveConsumeTerm = '';
    // 関連Ｐコード（旧）
    this.relationPcodeOld = '';
    // 関連Ｐコード（新）
    this.relationPcodeNew = '';
    // 目隠し区分
    this.blindDiv = '';
    // ｅフレンズ送信要否
    this.eFriendsSendDiv = false;
    // 項番1808 START
    // コマ配置予定区分
    this.komaScheduleDiv = '';
    // 項番1808 END
    // 酒類コード
    this.liquorCode = '';
    // アルコール分別
    this.alcoholType = '';
    // 容器形態
    this.containerForm = '';
    // 容器容量
    this.containerCapacity = '';

    // Ｐコード会員生協タブ
    // 会員生協マーク一覧
    this.coopMarkList = new Array<any>();
    // 会員生協価格一覧
    this.coopPriceList = new Array<any>();

    // Ｐコード詳細情報タブ
    // 詳細情報一覧
    this.coopDetailList = new Array<any>();
    // 注文コード割当List いばらき
    this.orderNumQuotaList_Ibaraki = new Array<any>();
    // 注文コード割当List とちぎ
    this.orderNumQuotaList_Tochigi = new Array<any>();
    // 注文コード割当List ぐんま
    this.orderNumQuotaList_Gunma = new Array<any>();
    // 注文コード割当List ちば
    this.orderNumQuotaList_Chiba = new Array<any>();
    // 注文コード割当List さいたま
    this.orderNumQuotaList_Saitama = new Array<any>();
    // 注文コード割当List とうきょう
    this.orderNumQuotaList_Tokyo = new Array<any>();
    // 注文コード割当List ながの
    this.orderNumQuotaList_Nagano = new Array<any>();
    // 注文コード割当List にいがた
    this.orderNumQuotaList_Niigata = new Array<any>();
    // 表組用商品名
    this.listingGoodsName = null;
    // 表組用項目一覧
    this.listingItemList = new Array<any>();

    // Ｐコードマーク情報タブ
    // マーク情報
    this.markList = new Array<any>();
    // 選択マーク情報
    this.selectedMarkList = new Array<any>();

    // Ｐコード付加情報タブ
    // 文字情報種別1～11
    this.textInfoDivArray = new Array<any>();
    // 文字情報連番1～11
    this.textKindNumArray = new Array<any>();
    // バイヤーコメント
    this.textInfoA = '';
    // 商品説明
    this.textInfo1 = '';
    // キャッチコピー
    this.textInfo2 = '';
    // おすすめコメント(吹き出し)
    this.textInfo3 = '';
    // 便利情報（囲み）
    this.textInfo4 = '';
    // 便利情報（商品構成内容）
    this.textInfo5 = '';
    // 便利情報（その他）
    this.textInfo6 = '';
    // 便利情報（ｅフレンズ）
    this.textInfo7 = '';
    // 便利情報（サイズ他）
    this.textInfo8 = '';
    // 取扱注意
    this.textInfo9 = '';
    // EC用商品説明
    this.textInfoB = '';
    // 便利情報（月齢情報）
    this.textInfoC = '';
    // 人気商品情報
    this.textInfoD = '';
    // 健康管理情報
    this.textInfoE = '';
    // 成分情報
    this.textInfoF = '';
    // 吸水量
    this.textInfoG = '';
    // 調理時間の目安
    this.textInfoH = '';
    // 〇人前情報
    this.textInfoI = '';
    // 材料
    this.textInfoJ = '';
    // ご家庭で用意いただくもの
    this.textInfoK = '';
    // バイヤーコード
    this.buyerCode = '';

    // Ｐコード発注物流タブデータ
    // 臭い商品区分
    this.stinkGoodsDiv = '';
    // ケース供給区分
    this.caseSupplyDiv = '';
    // 長期保存区分
    this.longKeepDiv = '';
    // 入荷場所区分
    this.arrivalAreaDiv = '';
    // 入荷許可品温
    this.arrivalGoodsTemp = '';
    // 入荷管理日数
    this.arrivalAdminDays = '';
    // 項番1215 START
    // 業態区分
    this.dutiesFormDiv = '';
    // 業態区分（デイリー）
    this.dutiesFormDailyDiv = '';
    // 業態区分（スポット）
    this.dutiesFormSpotDiv = '';

    // Ｐコード組合員の声タブ
    // 生協コード1～8
    this.coopCodeArray = new Array<any>();
    // 生協名称1～8
    this.coopNameArray = new Array<any>();
    // 生協選択ロック1～8
    this.selectLockArray = new Array<any>();
    // 生協選択フラグ1～8
    this.selectValueArray = new Array<any>();
    // 組合員の声1～8の
    this.inquiryContentsArray = new Array<any>();
    // 項番2231 START 障害管理NO.U01130対応
    this.inquiryContentsArrayBefore = new Array<any>();
    // 項番2231 END 障害管理NO.U01130対応
    // 受付番号1～8
    this.receiptNumArray = new Array<any>();

    // Ｐコード計画数タブ
    // 合計計画数
    this.plannumTotal = '';
    // 計画数一覧
    this.planList = new Array<any>();

    // 保健機能タブ
    // 届出番号 誌面掲載フラグ
    this.licencedNoValue = false;
    // 届出番号
    this.licencedNo = '';
    // 届出表示・許可表示
    this.licencedDescription = '';

    // 企画商品（アイテム情報）
    // アイテムコード情報
    this.itemCodeInfoList = new Array<any>();
    // 価格バンドル（連想配列）
    this.bundlePriceListContents = new Array<any>();

    // アイテムコード情報共通
    // アイテムコード
    this.itemCode = '';
    // JANコード
    this.janCode = '';
    // JANコード識別フラグ
    this.janCodeDiv = false;

    // アイテムコード情報アイテムタブ
    // ＦＣ・ＭＣ手数料
    this.fcmcFee = '';
    // 特殊発注区分
    this.specialOrderType = '';
    // 在庫繰越区分
    this.stockType = '';
    // 分納指定回数
    this.installmentTimes = '';
    // 物流滞留日数
    this.pdPilingUpDays = '';
    // ＩＴＦコード
    this.itfCode = '';
    // 発注単位区分
    this.orderUnitType = '';
    // メーカー希望小売価格(参考)区分
    this.makerType = '';
    // メーカー希望小売価格(参考)価格
    this.makerPrice = '';
    // 発注先取引先
    this.orderClientCode = '';
    // 発注先取引先名称
    this.orderClientName = '';
    // 支払先取引先
    this.payeeClientCode = '';
    // 支払先取引先名称
    this.payeeClientName = '';
    // 価格バンドル
    this.bundlePrice = '';
    // 確定入数
    this.fixContainNum = '';
    // 組数
    this.setQuantity = '';

    // アイテムコード情報仕様書１タブ
    // ｅＢＡＳＥ仕様書No
    this.ebaseSpecCode = '';
    // 仕様書適用日
    this.ebaseSpecCode = '';
    // メーカー名称
    this.ebaseSpecCode = '';
    // メーカー名称表示
    this.ebaseSpecCode = '';
    // ピースサイズ（縦）
    this.ebaseSpecCode = '';
    // ピースサイズ（横）
    this.ebaseSpecCode = '';
    // ピースサイズ（高）
    this.ebaseSpecCode = '';
    // ピース重量
    this.ebaseSpecCode = '';
    // ケースサイズ（縦）
    this.ebaseSpecCode = '';
    // ケースサイズ（横）
    this.ebaseSpecCode = '';
    // ケースサイズ（高）
    this.ebaseSpecCode = '';
    // ケース重量
    this.ebaseSpecCode = '';
    // 文字情報種別1
    this.specTextInfoDiv1 = '';
    // 原産国加工地
    this.stringValue1 = '';
    // 文字情報種別2
    this.specTextInfoDiv2 = '';
    // 原材料情報
    this.stringValue2 = '';
    // 文字情報種別3
    this.specTextInfoDiv3 = '';
    // コンタミ情報
    this.stringValue3 = '';
    // 文字情報種別4
    this.specTextInfoDiv4 = '';
    // カロリー情報
    this.stringValue4 = '';
    // 文字情報種別5
    this.specTextInfoDiv5 = '';
    // 添加物情報
    this.stringValue5 = '';
    // 文字情報種別6
    this.specTextInfoDiv6 = '';
    // 遺伝子組換
    this.stringValue6 = '';
    // 遺伝子組換表示区分
    this.geneRecombinationDiv = '';

    // アイテムコード情報仕様書２タブ
    // アレルゲン調査対象
    this.allergenTergetType = '';
    // アレルゲン情報一覧
    this.allergenInfo = new Array<any>();
    // 分析単位
    this.analysisUnit = '';
    // 熱量(Kcal)
    this.calolie = '';
    // たんぱく質(g)
    this.protein = '';
    // 脂質(g)
    this.lipid = '';
    // 炭水化物(g)
    this.carbohydrate = '';
    // ナトリウム(mg)
    this.sodium = '';

    // アイテムコード情報プロモーションタブ
    // 供給促進マーク一覧
    this.markInfoList = new Array<any>();
    this.markInfoListMain = new Array<any>();

    // アイテムコード情報環境タブ
    // 環境区分なし／あり
    this.ecologyDiv = '';

    // 環境区分一覧
    this.goodsEcology = new Array<any>();
    // 温暖化防止一覧
    this.goodsGWStop = new Array<any>();

    // アイテムコード情報プロモーションタブ
    // 容器包装材一覧
    this.containPacking = new Array<any>();
    // コードマスタＰ栄養成分情報リスト
    this.codeMasterpNutritionalList = new Array<any>();
    this.coopPriceList = new Array<any>();
  }

  /**
   * 【一括反映ボタン押下】
   * 組合員の声（一括反映）を各生協へコピーする
   * （/KYMW09/getPublishVoiceHistory.xml発行後のコールバックメソッド）
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public copyVoiceHistoryAll(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {

      let isError: boolean = <boolean>false;
      let count: number = <number>0;

      // ・返却情報（サーバ処理の結果）を判定する。
      const tempCollection: Array<any> = serverData;

      for (let i = Number(0); i < tempCollection.length; i++) {
        const flg: string = tempCollection[i].PublishHistoryFlag;
        // b)【「組合員の声掲載」に既存データなし】の場合、該当生協へコピー処理する。
        if (flg === '1') {
          this.inquiryContentsArray[i] = this.inquiryContentsAll;
          this.receiptNumArray[i] = this.receiptNumAll;
          this.selectLockArray[i] = true;
          count++;
        } else {
          // a)【「組合員の声掲載」に既存データあり】の場合、該当会員生協へはコピー処理しない。
          // ※組合員の声は、同一内容を各生協で１回のみ掲載可能とする。
          // コピー対象の生協の場合はエラー
          if (this.selectValueArray[i] === '1') {
            isError = true;
          }
        }
      }

      // 【「組合員の声掲載」に既存データあり】の場合、エラーメッセージを表示する。
      if (isError) {
        // ID=E0164 %1="他で指定済み" %2="指定"
        this.kymw0900Component.showPublishVoiceErrorMessage();
      } else if (count > 0) {

        // 値が変更された場合は編集カウントをインクリメント
        if (this.inquiryContentsArrayBefore[0] !== this.inquiryContentsArray[0]
          || this.inquiryContentsArrayBefore[1] !== this.inquiryContentsArray[1]
          || this.inquiryContentsArrayBefore[2] !== this.inquiryContentsArray[2]
          || this.inquiryContentsArrayBefore[3] !== this.inquiryContentsArray[3]
          || this.inquiryContentsArrayBefore[4] !== this.inquiryContentsArray[4]
          || this.inquiryContentsArrayBefore[5] !== this.inquiryContentsArray[5]
          || this.inquiryContentsArrayBefore[6] !== this.inquiryContentsArray[6]
          || this.inquiryContentsArrayBefore[7] !== this.inquiryContentsArray[7]
          || this.inquiryContentsArrayBefore[8] !== this.inquiryContentsArray[8]
        ) {
          this.addEditCount();
        }
      }
    }
  }

  /**
   * 【組合員の声ボタン押下】
   * 組合員の声を特定会員生協へコピーする
   * （/KYMW09/getPublishVoiceHistory.xml発行後のコールバックメソッド）
   *
   * @param serverData サーバからのレスポンスのデータ部分
   * @param coopNum 各会員生協の順番（いばらき：0 ～ にいがた：7）
   */
  public copyVoiceHistory(serverData: any, coopNum: number): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      let isError: boolean = <boolean>false;

      // ・返却情報（サーバ処理の結果）を判定する。
      const tempCollection: Array<any> = serverData;

      // 返却情報は１件のみ
      for (let i = Number(0); i < tempCollection.length; i++) {
        const flg: string = tempCollection[i].PublishHistoryFlag;
        // 【「組合員の声掲載」に既存データなし：1】の場合、該当生協へコピー処理する。
        if (flg === '1') {
          // 組合員の声（『組合員の声選択』画面からの戻り値）を特定会員生協へコピー
          this.inquiryContentsArray[coopNum] = this.selectInquiryContents;
          // 受付番号（『組合員の声選択』画面からの戻り値）を特定会員生協へコピー
          this.receiptNumArray[coopNum] = this.selectReceiptNum;
          this.selectLockArray[coopNum] = true;

          // 値が変更された場合は編集カウントをインクリメント
          if (this.inquiryContentsArrayBefore[0] !== this.inquiryContentsArray[0]
            || this.inquiryContentsArrayBefore[1] !== this.inquiryContentsArray[1]
            || this.inquiryContentsArrayBefore[2] !== this.inquiryContentsArray[2]
            || this.inquiryContentsArrayBefore[3] !== this.inquiryContentsArray[3]
            || this.inquiryContentsArrayBefore[4] !== this.inquiryContentsArray[4]
            || this.inquiryContentsArrayBefore[5] !== this.inquiryContentsArray[5]
            || this.inquiryContentsArrayBefore[6] !== this.inquiryContentsArray[6]
            || this.inquiryContentsArrayBefore[7] !== this.inquiryContentsArray[7]
          ) {
            this.addEditCount();
          }
        } else {
          // ①【「組合員の声掲載」に既存データあり：0】の場合、エラーメッセージを表示する。
          isError = true;
        }
      }

      // ①【「組合員の声掲載」に既存データあり】の場合、エラーメッセージを表示する。
      if (isError) {
        // ID=E0164 %1="他で指定済み" %2="指定"
        this.kymw0900Component.showPublishVoiceErrorMessage();
      }
    }
  }

  /**
   * 【計画数按分ボタン、計画数自動設定ボタン押下】
   * 計画数一覧を更新する
   * （/KYMW09/getCoopPlanNum.xml発行後のコールバックメソッド）
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public updatePlanNumList(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // 合計計画数を設定
      this.plannumTotal = serverData.PlanNumTotal;
      // 現在表示中の計画数一覧（データグリッド）を取得
      const viewPlanList: Array<any> = this.kymw0900Component.dtg_PlanList.collectionView.items;
      // 再作成用の計画数一覧の初期化
      const tempPlanList: Array<any> = new Array<any>();
      // 1行目は合計計画数を設定する
      const coopXml1 = {
        CoopCode: '',
        CoopName: '合計',
        PlanNumAiPrediction: viewPlanList[0].PlanNumAiPrediction,
        Plannum: PlessViewUtilsSub.nullToBlank(serverData.PlanNumTotal),
        LimitnumTotal: viewPlanList[0].LimitnumTotal,
        LimitnumPerson: '',
        DeliveryLeadTimeType: '',
        DelivCatalogID: '',
        Enabled: '1',
      };
      tempPlanList.push(coopXml1);

      if (serverData.CoopPlanNumList != null) {
        // サーバからのレスポンスデータ（計画数一覧）を取得
        const tempCollection: Array<any> = serverData.CoopPlanNumList;
        // 現在表示中の計画数一覧（データグリッド）を取得
        const viewPlanInfoList: Array<any> = this.kymw0900Component.dtg_PlanList.collectionView.items;

        // 2行目以降に会員生協の計画数を設定（計画数以外は表示中の計画数一覧（データグリッド）から再設定する）
        for (let i = Number(1); i < viewPlanInfoList.length; i++) {
          const tempIndex = tempCollection.findIndex( obj => obj.CoopCode === viewPlanInfoList[i].CoopCode);
          // 計画数が変更されている場合は編集カウントをインクリメント
          if (tempIndex != -1 && this.oldPlannumList[i - 1] !== tempCollection[tempIndex].PlanNum) {
            this.addEditCount();
          }

          const coopXml2 = {
            CoopCode: viewPlanInfoList[i].CoopCode,
            CoopName: viewPlanInfoList[i].CoopName,
            PlanNumAiPrediction: viewPlanInfoList[i].PlanNumAiPrediction,
            Plannum: viewPlanInfoList[i].Enabled === '1'
              ? tempIndex != -1 ? PlessViewUtilsSub.nullToBlank(tempCollection[tempIndex].PlanNum) : ''
              : '',
            LimitnumTotal: viewPlanInfoList[i].Enabled === '1' ? viewPlanInfoList[i].LimitnumTotal : '',
            LimitnumPerson: viewPlanInfoList[i].Enabled === '1' ? viewPlanInfoList[i].LimitnumPerson : '',
            DeliveryLeadTimeType: viewPlanInfoList[i].DeliveryLeadTimeType,
            DelivCatalogID: viewPlanInfoList[i].DelivCatalogID,
            Enabled: viewPlanInfoList[i].Enabled,
          };
          tempPlanList.push(coopXml2);
        }
      }
      // 作成したものを計画数一覧（データグリッド）に再設定
      this.planList = tempPlanList;

      // 比較用のリストに値を保持する
      this.setOldPlanList();
    }
  }


  /**
   * 限定数量個人（合計）を返す。
   * @param tempPlanList 計画数タブ データグリッドのリスト
   * @return 限定数量個人（合計）
   */
  private CalcLimitnumPerson(tempPlanList: any): number {
    // サーバからのレスポンスデータ（計画数一覧）を取得
    if (tempPlanList === null) {
      return 0;
    }
    let limitnumPerson: number = <number>0;
    for (let i = Number(0); i < tempPlanList.length; i++) {
      // limitnumPersonを取り出す
      const tempVal = Number(PlessViewUtilsSub.nullToBlank(tempPlanList[i].LimitNumPerson));
      // 足し込む
      limitnumPerson += tempVal;
    }
    return limitnumPerson;
  }

  /**
   * 【（各会員生協毎の）計画数、限定数量総数テキスト入力完了】
   * 計画数タブ「計画数一覧」の合計を更新する
   *
   * @param data テキストが保持しているdataオブジェクト
   */
  public updatePlanList(data: any): void {

    // 現在表示中の計画数一覧（データグリッド）を取得
    const viewPlanList: Array<any> = this.kymw0900Component.dtg_PlanList.collectionView.items;
    let changeFlag: boolean = <boolean>false;
    // 値が変更されたかチェックする
    for (let i = Number(1); i < viewPlanList.length; i++) {
      if (viewPlanList[i].Plannum !== this.oldPlannumList[i - 1]) {
        changeFlag = true;
        break;
      } else if (viewPlanList[i].LimitnumPerson !== this.oldLimitnumPersonList[i - 1]) {
        changeFlag = true;
        break;
      } else if (viewPlanList[i].LimitnumTotal !== this.oldLimitnumTotalList[i - 1]) {
        changeFlag = true;
        break;
      }
    }
    // 比較用のリストに値を保持する
    this.setOldPlanList();
    // 入力値に変更がない場合は処理しない
    if (!changeFlag) {
      return;
    }
    // 編集カウントをインクリメント
    this.addEditCount();
    // 計画数（合計）
    let planNumTotal: number = <number>0;
    // 限定数量総数（合計）
    let limitnumTotal: number = <number>0;
    // 限定数量個人（合計）
    let limitnumPerson: number = <number>0;

    // 各会員生協の計画数を再設定
    for (let j = Number(1); j < viewPlanList.length; j++) {
      // 合計を計算
      planNumTotal += Number(viewPlanList[j].Plannum);
      limitnumTotal += Number(viewPlanList[j].LimitnumTotal);
      limitnumPerson += Number(viewPlanList[j].LimitnumPerson);
    }

    // 0行目に合計計画数を設定する
    const coopXml = {
      CoopCode: '',
      CoopName: '合計',
      PlanNumAiPrediction: viewPlanList[0].PlanNumAiPrediction,
      Plannum: planNumTotal,
      LimitnumTotal: limitnumTotal,
      LimitnumPerson: '',
      DeliveryLeadTimeType: '',
      DelivCatalogID: '',
      Enabled: '1',
    };
    this.planList.push(coopXml, 0);

    if (planNumTotal > 9999999) {
      // エラーメッセージを表示する。
      this.kymw0900Component.dialogServiceSub.openAlertGetMessage('E0207', ['計画数合計', '8桁以上', 'このままでは登録']);
    }
  }

  /**
   * 【次回案内自動設定ボタン押下】
   * 案内一覧を更新する
   * （/KYMW09/getNextGuide.xml発行後のコールバックメソッド）
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public updateNextGuideList(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // 現在表示中の案内一覧（データグリッド）を取得
      const viewGuideList: Array<any> = this.kymw0900Component.dtg_GuideList.collectionView.items;

      // 再作成用の案内一覧リストの初期化
      const tempGuideList: Array<any> = new Array<any>();

      // 次回案内を設定（次回案内以外は表示中の案内一覧（データグリッド）から再設定する）
      for (let i = Number(0); i < viewGuideList.length; i++) {
        // Enable = trueならば、次回案内を書き換える。
        let nextGuideMap: Array<any> = viewGuideList[i].NextGuideMap; // 現在の値
        // getEnabledCoopで次回案内が活性かどうかを判定（EC列以外・在庫限定フラグがfalseの場合）
        if (this.kymw0900Component.getEnabledCoop(viewGuideList[i].CoopCode) && !this.stockLimitFlg) {
          const coopGuide = serverData.CoopGuideList.find((data) => {
            return data.CoopCode === viewGuideList[i].CoopCode;
          })

          if (coopGuide) {
            for (const newNextGuide of coopGuide.MediumNextGuideList) {
              if (newNextGuide.MediumType !== 'EC0' && nextGuideMap[newNextGuide.MediumType] !== newNextGuide.NextGuide) {
                nextGuideMap[newNextGuide.MediumType] = newNextGuide.NextGuide;
                // 値が変更されている場合は編集カウントをインクリメント
                this.addEditCount();
              }
            }
          }
        }
        // getEnabledNextGuideECでECの次回案内が活性かどうか判定（EC列・在庫限定フラグがfalseの場合）
        if (this.kymw0900Component.getEnabledNextGuideEC(viewGuideList[i].CoopCode) && !this.stockLimitFlg) {
          const coopGuide = serverData.CoopGuideList.find((data) => {
            return data.CoopCode === viewGuideList[i].CoopCode;
          })

          if (coopGuide) {
            for (const newNextGuide of coopGuide.MediumNextGuideList) {
              if (newNextGuide.MediumType === 'EC0' && nextGuideMap[newNextGuide.MediumType] !== newNextGuide.NextGuide) {
                nextGuideMap[newNextGuide.MediumType] = newNextGuide.NextGuide;
                // 値が変更されている場合は編集カウントをインクリメント
                this.addEditCount();
              }
            }
          }
        }
        const coopXml = {
          CoopCode: viewGuideList[i].CoopCode,
          CoopName: viewGuideList[i].CoopName,
          OrderNum: viewGuideList[i].OrderNum,
          AppearDiv: viewGuideList[i].AppearDiv,
          NextGuideMap: nextGuideMap,
          Enabled: viewGuideList[i].Enabled,
        };
        tempGuideList.push(coopXml);
      }
      // 作成したものを案内一覧（データグリッド）に再設定
      this.guideList = tempGuideList;
    }
  }

  /**
   * 【発注先取引先テキスト入力完了】
   * 発注先取引先名称を設定する
   * （/KYMW09/getSupplier.xml発行後のコールバックメソッド）
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public setOrderClientName(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // ・返却情報（サーバ処理の結果）を判定する。
      // ①【該当あり】
      // ・「発注先取引先名称」を、画面にセットする。
      this.orderClientName = serverData.SupplierNameKanji;
      // 項番2231 END 障害管理NO.U01503対応
      // ②【該当なし】
      // ・該当なしエラーメッセージの表示。（ID=E0100）
      // → サーバ側で対応
    }
  }

  /**
   * 【支払先取引先テキスト入力完了】
   * 支払先取引先名称を設定する
   * （/KYMW09/getSupplier.xml発行後のコールバックメソッド）
   *
   * @param serverData サーバからのレスポンスのデータ部分
   */
  public setPayeeClientName(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // ・返却情報（サーバ処理の結果）を判定する。
      // ①【該当あり】
      // ・「支払先取引先名称」を、画面にセットする。
      // 項番2231 START 障害管理NO.U01503対応
      this.payeeClientName = serverData.SupplierNameKanji;
      // 項番2231 END 障害管理NO.U01503対応
      // ②【該当なし】
      // ・該当なしエラーメッセージの表示。（ID=E0100）
      // → サーバ側で対応
    }
  }

  /**
   * アイテムコード情報共通データを設定する
   *
   * @param data アイテムコード情報データ（アイテムコード共通）
   * @param view KYMW0900のViewHelper
   */
  private copyDispDataToItemCodeCommon(data: any): void {
    // アイテムコード
    data.ItemCode = this.itemCode;
    // JANコード
    data.JANCode = this.janCode;
    // JANコード識別フラグ
    data.JANCodeDiv = PlessViewUtilsSub.booleanTOString(this.janCodeDiv);
  }

  /**
   * アイテムコード情報アイテムタブデータを設定する
   *
   * @param data アイテムコード情報データ（アイテムコード基本）
   * @param view KYMW0900のViewHelper
   */
  private copyDispDataToItemCodeBase(data: any): void {
    // ＦＣ・ＭＣ手数料
    data.FCMCFee = this.fcmcFee;

    // 特殊発注区分
    data.SpecialOrderType = this.specialOrderType;

    // 在庫繰越区分
    data.StockType = this.stockType;

    // 分納指定回数
    data.InstallmentTimes = this.installmentTimes;

    // 物流滞留日数
    data.PDPilingUpDays = this.pdPilingUpDays;

    // ＩＴＦコード
    data.ITFCode = this.itfCode;

    // 発注単位区分
    data.OrderUnitType = this.orderUnitType;

    // メーカー希望小売価格(参考)区分
    data.PriceType = this.makerType;

    // メーカー希望小売価格(参考)価格
    data.MakerPrice = this.makerPrice;

    // 発注先取引先
    data.OrderClientCode = this.orderClientCode;

    // 発注先取引先名称
    data.OrderClientName = this.orderClientName;

    // 支払先取引先
    data.PayeeClientCode = this.payeeClientCode;

    // 支払先取引先名称
    data.PayeeClientName = this.payeeClientName;

    // 価格バンドル
    data.BundlePrice = this.bundlePrice;

    // 確定入数
    data.FixContainNum = this.fixContainNum;

    // 組数
    data.SetQuantity = this.setQuantity;
  }

  /**
   * アイテムコード情報仕様書１タブデータを設定する
   *
   * @param data アイテムコード情報データ（アイテムコード仕様書１）
   * @param view KYMW0900のViewHelper
   */
  private copyDispDataToItemCodeSpec1(data: any): void {

    // ｅＢＡＳＥ仕様書No
    data.EBaseSpecCode = this.ebaseSpecCode;

    // 仕様書適用日
    data.SpecApplyDate = this.specApplyDate;

    // メーカー名称
    data.MakerName = this.makerName;

    // メーカー名称表示
    data.MakerNamePublishType = PlessViewUtilsSub.booleanTOString(this.makerNamePublishType);

    // ピースサイズ（縦）
    data.PeaceSizeLength = this.peaceSizeLength;

    // ピースサイズ（横）
    data.PeaceSizeWidth = this.peaceSizeWidth;

    // ピースサイズ（高）
    data.PeaceSizeHight = this.peaceSizeHight;

    // ピース重量
    data.PeaceWeight = this.peaceWeight;

    // ケースサイズ（縦）
    data.CaseSizeLength = this.caseSizeLength;

    // ケースサイズ（横）
    data.CaseSizeWidth = this.caseSizeWidth;

    // ケースサイズ（高）
    data.CaseSizeHight = this.caseSizeHight;

    // ケース重量
    data.CaseWeight = this.caseWeight;

    const textInfoList: Array<any> = new Array<any>();

    let coopXml = null;

    // 原産国加工地を設定
    coopXml = {
      StringValue: this.kymw0900Component.txta_StringValue1.text,
      TextKindID: data.TextInfoList[0].TextKindID,
    };
    textInfoList.push(coopXml);
    // 原材料情報を設定
    coopXml = {
      StringValue: this.kymw0900Component.txta_StringValue2.text,
      TextKindID: data.TextInfoList[1].TextKindID,
    };
    textInfoList.push(coopXml);
    // コンタミ情報を設定
    coopXml = {
      StringValue: this.kymw0900Component.txta_StringValue3.text,
      TextKindID: data.TextInfoList[2].TextKindID,
    };
    textInfoList.push(coopXml);
    // カロリー情報を設定
    coopXml = {
      StringValue: this.kymw0900Component.txta_StringValue4.text,
      TextKindID: data.TextInfoList[3].TextKindID,
    };
    textInfoList.push(coopXml);
    // 添加物情報を設定
    coopXml = {
      StringValue: this.kymw0900Component.txta_StringValue5.text,
      TextKindID: data.TextInfoList[4].TextKindID,
    };
    textInfoList.push(coopXml);
    // 遺伝子組換を設定
    coopXml = {
      StringValue: this.kymw0900Component.txta_StringValue6.text,
      TextKindID: data.TextInfoList[5].TextKindID,
    };
    textInfoList.push(coopXml);
    data.TextInfoList = textInfoList;
    // 遺伝子組換表示区分
    data.GeneRecombinationDiv = this.kymw0900Component.cmb_GeneRecombinationDivList.selectedCodeValue;
  }

  /**
   * アイテムコード情報仕様書２タブデータを設定する
   *
   * @param data アイテムコード情報データ（アイテムコード仕様書２）
   * @param view KYMW0900のViewHelper
   */
  private copyDispDataToItemCodeSpec2(data: any): void {
    // アレルゲン調査対象
    data.AllergenTargetType = this.kymw0900Component.cmb_AllergenTergetType.selectedCodeValue;

    // 現在表示中のアレルゲン情報一覧（データグリッド）を取得
    const viewAllergenInfo: Array<any> = this.kymw0900Component.dtg_AllergenInfo.collectionView.items;

    // アレルゲン情報一覧
    for (let i = Number(0); i < data.AllergenList.length; i++) {
      data.AllergenList[i].AllergenSelect = PlessViewUtilsSub.booleanTOString(viewAllergenInfo[i].SelectValue);
    }
  }

  /**
   * アイテムコード情報環境タブデータを設定する
   *
   * @param data アイテムコード情報データ（アイテムコード環境）
   * @param view KYMW0900のViewHelper
   */
  private copyDispDataToItemCodeEcology(data: any): void {
    // 環境区分なし／あり
    data.EcologyDivFlag = PlessViewUtilsSub.booleanTOString(this.goodsEcologyFlag);

    // 現在表示中の環境区分（データグリッド）を取得
    const viewGoodsEcologyList: Array<any> = this.kymw0900Component.dtg_GoodsEcologyList.collectionView.items;
    // 環境区分
    for (let i = Number(0); i < viewGoodsEcologyList.length; i++) {
      data.EcologyDivList[i].EcologyDivSelect = PlessViewUtilsSub.booleanTOString(viewGoodsEcologyList[i].SelectValue);
    }

    // 現在表示中の温暖化防止一覧（データグリッド）を取得
    const viewGoodsGWStopList: Array<any> = this.kymw0900Component.dtg_GoodsGWStopList.collectionView.items;
    // 温暖化防止
    for (let i = Number(0); i < viewGoodsGWStopList.length; i++) {
      data.GWStopGoodsList[i].GWStopGoodsDivSelect = PlessViewUtilsSub.booleanTOString(viewGoodsGWStopList[i].SelectValue);
    }

    // 現在表示中の容器包装材一覧（データグリッド）を取得
    const viewContainPackingList: Array<any> = this.containPackingList;

    // 容器包装材
    for (let i = Number(0); i < viewContainPackingList.length; i++) {
      const s: string = viewContainPackingList[i].PackMaterialWeight;
      data.ContainList[i].ContainSelect = PlessViewUtilsSub.booleanTOString(viewContainPackingList[i].SelectValue);
      data.ContainList[i].PackMaterialWeight = viewContainPackingList[i].PackMaterialWeight;
    }
  }

  /**
   * 【価格パターン変更】
   * 価格一覧で価格パターンが変更されたときに、関連する会員生協の
   * 情報を更新する
   * （PricePatternComboBoxRendererからのコールバック）
   *
   * @param data チェックボックスが保持しているdataオブジェクト
   * @param pattern 価格パターン
   */
  public updatePricePattern(data: any, patternO: any, insInputSupplyPrice: boolean, insInputCostPrice: boolean): void {

    const pattern = String(patternO);
    const tempPriceList: Array<any> = new Array<any>();

    // 会員生協価格一覧の再設定
    for (let i = Number(0); i < this.coopPriceList.length; i++) {
      // 当該会員生協の場合
      if (data.CoopCode === this.coopPriceList[i].CoopCode) {
        // 今回供給価格
        let thisTimeSupplyPrice: string = <string>'';
        // 今回仕入価格
        let thisTimeCostPrice: string = <string>'';
        // 価格パターンにより、「供給価格(通常)」、「仕入価格通常)」、「仕入価格」を再設定
        switch (pattern) {
          // ①【0:通常価格】の場合
          case '0':
            // ・商品マスタの「供給価格（通常）」を「今回供給価格」にセット
            // ・商品マスタの「単品仕入価格（通常）」を「今回仕入価格」にセット
            if (insInputSupplyPrice) {
              thisTimeSupplyPrice = this.coopPriceList[i].SupplyPricecoefficient;
            } else {
              thisTimeSupplyPrice = this.coopPriceList[i].ThistimeSupplyPrice;
            }
            if (insInputCostPrice) {
              thisTimeCostPrice = this.coopPriceList[i].CostPriceCoefficient;
            } else {
              thisTimeCostPrice = this.coopPriceList[i].ThistimeCostPrice;
            }
            break;
          // ②【1:特価１】の場合
          case '1':
            // ・商品マスタの「供給価格（特価１）」を「今回供給価格」にセット
            // ・商品マスタの「単品仕入価格（特価１）」を「今回仕入価格」にセット
            if (insInputSupplyPrice) {
              thisTimeSupplyPrice = this.coopPriceList[i].SupplyPriceSpecial1;
            } else {
              thisTimeSupplyPrice = this.coopPriceList[i].ThistimeSupplyPrice;
            }
            if (insInputCostPrice) {
              thisTimeCostPrice = this.coopPriceList[i].CostPriceSpecial1;
            } else {
              thisTimeCostPrice = this.coopPriceList[i].ThistimeCostPrice;
            }
            break;
          // ③【2:特価２】の場合
          case '2':
            // ・商品マスタの「供給価格（特価２）」を「今回供給価格」にセット
            // ・商品マスタの「単品仕入価格（特価２）」を「今回仕入価格」にセット
            if (insInputSupplyPrice) {
              thisTimeSupplyPrice = this.coopPriceList[i].SupplyPriceSpecial2;
            } else {
              thisTimeSupplyPrice = this.coopPriceList[i].ThistimeSupplyPrice;
            }
            if (insInputCostPrice) {
              thisTimeCostPrice = this.coopPriceList[i].CostPriceSpecial2;
            } else {
              thisTimeCostPrice = this.coopPriceList[i].ThistimeCostPrice;
            }
            break;
          // ④【3:特価３】の場合
          case '3':
            // ・「今回供給価格」をクリアする。
            // ・「今回仕入価格」をクリアする。
            // ・「仕入価格」をクリアする。
            if (insInputSupplyPrice) {
            } else {
              thisTimeSupplyPrice = this.coopPriceList[i].ThistimeSupplyPrice;
            }
            if (insInputCostPrice) {
            } else {
              thisTimeCostPrice = this.coopPriceList[i].ThistimeCostPrice;
            }
            break;
        }

        // ・「今回仕入価格」と各生協に紐付くアイテム情報の「価格バンドル」を乗じた値を
        // 　「仕入価格」にセット
        let costPrice: string = <string>'0';
        if (thisTimeCostPrice.length > 0) {
          const bundlePrice: number = this.bundlePriceListContents[this.coopPriceList[i].SelectItemCode];
          costPrice = String(Number(thisTimeCostPrice) * bundlePrice);
        }
        const coopXml = {
          CoopCode: this.coopPriceList[i].CoopCode,
          CoopNum: this.coopPriceList[i].CoopNum,
          CoopName: this.coopPriceList[i].CoopName,
          CoopShortName: this.coopPriceList[i].CoopShortName,
          SelectValue: this.coopPriceList[i].SelectValue,
          SelectItemCode: this.coopPriceList[i].SelectItemCode,
          SelectPricePattern: pattern,
          LSupplyPricecoefficient: this.coopPriceList[i].SupplyPricecoefficient,
          SupplyPricecoefficient: this.coopPriceList[i].SupplyPricecoefficient,
          SupplyPriceSpecial1: this.coopPriceList[i].SupplyPriceSpecial1,
          SupplyPriceSpecial2: this.coopPriceList[i].SupplyPriceSpecial2,
          ThistimeSupplyPrice: thisTimeSupplyPrice,
          LCostPriceCoefficient: this.coopPriceList[i].CostPriceCoefficient,
          CostPriceCoefficient: this.coopPriceList[i].CostPriceCoefficient,
          CostPriceSpecial1: this.coopPriceList[i].CostPriceSpecial1,
          CostPriceSpecial2: this.coopPriceList[i].CostPriceSpecial2,
          ThistimeCostPrice: thisTimeCostPrice,
          CostPrice: costPrice,
          Enabled: this.coopPriceList[i].Enabled,
          DealCoopDiv: this.coopPriceList[i].DealCoopDiv,
          Caption: this.coopPriceList[i].Caption,
          PromotionDiv: this.coopPriceList[i].PromotionDiv,
          SupplyPriceToolTipText: this.coopPriceList[i].SupplyPriceToolTipText,
          CostPriceToolTipText: this.coopPriceList[i].CostPriceToolTipText,
          EnabledCheck: this.RegularFlg === this.REGULAR_FLG_ON,
        };
        tempPriceList.push(coopXml);
      } else {
        tempPriceList.push(this.coopPriceList[i]);
      }
    }
    this.coopPriceList = tempPriceList;
  }


  /**
   * 「アレルゲン調査対象区分」の選択値制御
   *   7大アレルゲンのいずれかが選択された場合 ：「0:対象」を設定する
   *   7大アレルゲンが全て選択解除された場合    ：「1:対象外」を設定する
   *   （AllergenInfoCheckRendererからのコールバック）
   */
  public editAllergenTargetType(selected: boolean, publishDiv: string): void {
    if (publishDiv === '1') {
      // 「アレルゲン調査対象区分」初期化
      let allergenTargetType: string = <string>'1';	// 「1:
      if (selected) {
        // 7大アレルゲンのいずれかが選択された場合「0:対象」
        allergenTargetType = '0';
      } else {
        // 7大アレルゲンのいずれかが選択解除された場合
        const allergenCheck: Array<any> = this.allergenInfo;
        // その他の7大アレルゲンの選択状態をチェック
        for (let i = Number(0); i < allergenCheck.length; i++) {
          if (allergenCheck[i].PublishDiv === '1' && allergenCheck[i].SelectValue) {
            // 7大アレルゲンのいずれかが選択されている場合「0:対象」
            allergenTargetType = '0';
            break;
          }
        }
      }

      const currentAllergenType = this.kymw0900Component.cmb_AllergenTergetType.selectedCodeValue;
      // アレルゲン調査対象区分が変更されたらコンボボックスの表示を更新する
      if (currentAllergenType !== allergenTargetType) {
        // 「アレルゲン調査対象区分」設定
        this.kymw0900Component.cmb_AllergenTergetType.setCodeValue(allergenTargetType);

        this.kymw0900Component.dtg_AllergenInfo.refreshCells(true);
      }
    }
  }

  /**
   * 各会員生協の活性状態を返す
   *
   * @param coopNum 各会員生協の順番（いばらき：0 ～ にいがた：7）
   * @return 活性：true、非活性：false
   */
  public isCoopEnabled(coopNum: number): boolean {
    // 会員生協のアイテムコード選択により、活性／非活性の設定を行う
    return PlessViewUtilsSub.isEmpty(this.coopPriceList[coopNum].SelectItemCode);
  }

  /**
   * プロモーションマークタブのﾁｪｯｸﾎﾞｯｸｽコントロール用
   *
   * @param coopNum 各会員生協の順番（いばらき：0 ～ にいがた：7）
   * @return 活性：true、非活性：false
   */
  public isCoopEnabled2(coopNum: number): boolean {
    // 該当生協コードの、ｱｲﾃﾑｺｰﾄﾞコンボボックスの値
    const selectItem: string = this.coopPriceList[coopNum].SelectItemCode;
    if (selectItem === '0' || PlessViewUtilsSub.isEmpty(selectItem)) {
      // アイテムが選ばれていない
      return false;
    } else {
      // アイテムが選ばれている
      return true;
    }
  }

  /**
   * 【容器包装財チェックボックス選択】
   * 環境タブ容器包装財の重量テキストの活性／非活性を更新する
   * （ContainPackingCheckRendererからのコールバック）
   *
   * @param data チェックボックスが保持しているdataオブジェクト
   */
  public updateContainPacking(data: any): void {
    if (!data.Check) {
      data.PackMaterialWeight = '';
    }

    this.kymw0900Component.dtg_ContainPackingList.refresh();
  }

  public updateProducingAreaComment(): void {
    const tempCoopdetailList: Array<any> = new Array<any>();

    for (let i = Number(0); i < this.coopDetailList.length; i++) {
      const coopXml = {
        CoopCode: this.coopDetailList[i].CoopCode,
        CoopName: this.coopDetailList[i].CoopName,
        BrandType: this.coopDetailList[i].BrandType,
        SetDiv: this.coopDetailList[i].SetDiv,
        AssortTempDiv: this.coopDetailList[i].AssortTempDiv,
        OrderNumQuotaCode: this.coopDetailList[i].OrderNumQuotaCode,
        ProducingAreaComment1: this.classCode === '01' ? this.coopDetailList[i].ProducingAreaComment1 : '',
        ProducingAreaComment2: this.classCode === '01' ? this.coopDetailList[i].ProducingAreaComment2 : '',
        DetailUseRegularFlg: this.coopDetailList[i].DetailUseRegularFlg,
        BackProducingAreaComment1: this.classCode === '01' ? this.coopDetailList[i].ProducingAreaComment1 : '',
        BackProducingAreaComment2: this.classCode === '01' ? this.coopDetailList[i].ProducingAreaComment2 : '',
        Enabled: PlessViewUtilsSub.isEmpty(this.coopPriceList[i].SelectItemCode) ? '0' : '1',
        ClassCode: this.classCode,
      };
      tempCoopdetailList.push(coopXml);
    }
    this.coopDetailList = tempCoopdetailList;
    this.kymw0900Component.dtg_CoopDetailList.editableCollectionView.refresh();
  }

  /**
   * 抽選商品プロモーションデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPlanGoodsLotteryPromotion(data: any): void {
    this.lotteryPromotionFlg = (data.LotteryPromotionFlg === '1') ? true : false;
    let lotteryList = <any>[];
    data.PlanGoodsLotteryList.map(_ => {
      const lotteryData = {
        check: false,
        itemCode: _.ItemCode,
        winningGoodsNum: PlessViewUtilsSub.nullToBlank(_.WinningGoodsNum),
        winningGoodsPerPersonNum: PlessViewUtilsSub.nullToBlank(_.WinningGoodsPerPersonNum),
        limitedMeaning: PlessViewUtilsSub.nullToBlank(_.LimitedMeaning),
        mondayPlanNum: PlessViewUtilsSub.nullToBlank(_.MondayPlanNum),
        tuesdayPlanNum: PlessViewUtilsSub.nullToBlank(_.TuesdayPlanNum),
        wednesdayPlanNum: PlessViewUtilsSub.nullToBlank(_.WednesdayPlanNum),
        thursdayPlanNum: PlessViewUtilsSub.nullToBlank(_.ThursdayPlanNum),
        fridayPlanNum: PlessViewUtilsSub.nullToBlank(_.FridayPlanNum)
      };
      lotteryList.push(lotteryData);
    });
    this.planGoodsLotteryList = lotteryList;

    // 抽選商品プロモーションフラグが「1:抽選商品プロモーション設定を使用する」の場合、「選択（アイテムコード）」のON/OFF制御を行う。
    // 当選商品数がNULL以外かつ、アイテムコードが「会員タブ」に存在する場合、「選択（アイテムコード）」をチェックボックスON状態に変更する。	
    this.setLotteryListCheck(false);

    // アコーディオンメニューの開閉設定
    this.kymw0900Component.acc_UseLotteryPromotion.isCollapsed = !this.lotteryPromotionFlg;
  }

  /**
   * 抽選商品プロモーションデータのチェック可否を設定する
   */
  public setLotteryListCheck(isLotteryPromotionCheck: boolean): void {
    // 初期表示時：「1:抽選商品プロモーション設定を使用する」かつ、当選商品数がNULL以外かつ、会員タブにアイテムコード存在時にチェックON状態
    // 「このプロモーション設定を使用する」チェックON時：「1:抽選商品プロモーション設定を使用する」かつ、会員タブにアイテムコード存在時にチェックON状態
    if (this.lotteryPromotionFlg) {
      for (const data of this.planGoodsLotteryList) {
        if (isLotteryPromotionCheck || data.winningGoodsNum !== '') {
          for (const coopPrice of this.coopPriceList) {
            if (coopPrice.SelectItemCode === data.itemCode) {
              data.check = true;
              break;
            }
          }
        } 
      }
    }
  }

  /**
   * 抽選商品プロモーションのチェック処理
   */
  public lotteryList_CHECKHandler(item: any, _event: Event): void {
    if (!item.check) {
      // 抽選商品プロモーションの以下画面項目の入力内容をクリア
      // ・当選商品数
      // ・1人あたりの抽選商品数
      // ・限定の訳
      // ・月曜
      item.winningGoodsNum = '';
      item.winningGoodsPerPersonNum = '';
      item.limitedMeaning = '';
      item.mondayPlanNum = '';
      item.tuesdayPlanNum = '';
      item.wednesdayPlanNum = '';
      item.thursdayPlanNum = '';
      item.fridayPlanNum = '';
    }

    // 全てのアイテムコードのチェックボックスがOFFになった場合は「このプロモーション設定を使用する」チェックボックスをOFFにする
    let isNonCheck = true;
    this.planGoodsLotteryList.map(lottery => {
      if (lottery.check) {
        isNonCheck = false;
      }
    });
    if (isNonCheck) {
      this.lotteryPromotionFlg = false;
      this.kymw0900Component.setLotteryPromotionMark(_event);
    }
  }

  /**
   * ポイント交換商品プロモーションデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPlanGoodsPointExchangePromotion(data: GetPlanGoodsPointExchangePromotionResponse): void {
    this.pointPromotionFlg = (data.PointPromotionFlg === '1') ? true : false;
    const tempPointExchangeList: Array<any> = new Array<any>();
    for (let i = Number(0); i < data.PointExchangeList.length; i++) {
      const tempCoopPointRateListCoopXml: Array<any> = new Array<any>();

      // 会員生協別ポイント一覧
      for (let j = Number(0); j < data.PointExchangeList[i].CoopPointRateList.length; j++) {
        const coopPointRateListCoopXml = {
          CoopCode: data.PointExchangeList[i].CoopPointRateList[j].CoopCode,
          CoopName: this.convertCoopName(data.PointExchangeList[i].CoopPointRateList[j].CoopCode),
          ThisTimeSupplyPrice: PlessViewUtilsSub.editPriceComma(data.PointExchangeList[i].CoopPointRateList[j].ThisTimeSupplyPrice, true),
          PointRate: data.PointExchangeList[i].CoopPointRateList[j].PointRate,
          ExchangePointWithoutTax: PlessViewUtilsSub.editPriceComma(data.PointExchangeList[i].CoopPointRateList[j].PointExchangeEquivalentAmount, true),
          ExchangePoint: PlessViewUtilsSub.editPriceComma(data.PointExchangeList[i].CoopPointRateList[j].ExchangePoints, true),
          RegistFlg: '0',
          DeleteFlg: '0',
          PlanGoodsCoopPointRateEnableFlg: data.PointExchangeList[i].ItemCode == data.PointExchangeList[i].CoopPointRateList[j].ItemCode ? true: false,
        };
        tempCoopPointRateListCoopXml.push(coopPointRateListCoopXml);
      }

      // 代表生協順（さ、い、と、ぐ、ち、とう、な、に）で最初にヒットした情報の交換ポイント、供給単価を取得
      let displayExchangePoint = '';
      let displayThisTimeSupplyPrice = '';
      let chkFlg = false;
      for(const e of this.coopDaihyoOrder) {
        tempCoopPointRateListCoopXml.map(c => {
          if (e === c.CoopCode) {
            displayExchangePoint = c.ExchangePoint;
            // 「会員生協タブ.今回供給価格」があればその値を、なければ「会員生協別ポイント情報取得.供給価格」
            const coopInfoPrice = this.coopPriceList.find(_ => e === _.CoopCode)?.ThistimeSupplyPrice;
            if (coopInfoPrice) {
              displayThisTimeSupplyPrice = coopInfoPrice;
            } else {
              displayThisTimeSupplyPrice = c.ThisTimeSupplyPrice;
            }
            chkFlg = true;
          }
        });
        if (chkFlg) {
          chkFlg = false;
          break;
        }
      }

      const pointExchangeListCoopXml = {
        itemCode: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].ItemCode),
        pointExchangeOrderNumQuotaCode: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].PointExchangeOrderNumQuotaCode),
        pointExchangeOrderNum: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].PointExchangeOrderNum),
        pointExchangeGoodsName: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].PointExchangeGoodsName),
        pointExchangeGoodsNameKana: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].PointExchangeGoodsNameKana),
        pointExchangeGuideName: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].PointExchangeGuideName),
        pointExchangeGuideNameKana: PlessViewUtilsSub.nullToBlank(data.PointExchangeList[i].PointExchangeGuideNameKana),
        consumeTaxRate: PlessViewUtilsSub.stringToNumber(data.PointExchangeList[i].ConsumeTaxRate),
        shortOfPointDiv: String(data.PointExchangeList[i].ShortOfPointDiv),
        ecOnlyFlg: data.PointExchangeList[i].EcOnlyFlg,
        coopPointRateList: tempCoopPointRateListCoopXml,
        displayExchangePoint: displayExchangePoint,
        displayThisTimeSupplyPrice: displayThisTimeSupplyPrice,
        registFlg: '0',
        deleteFlg: '0',
      };
      tempPointExchangeList.push(pointExchangeListCoopXml);
    }
    this.pointExchangeList = tempPointExchangeList;

    // 表示用
    this.pointExchangeListDisplay = this.pointExchangeList.map(_ => ({ ..._}));

    // アコーディオンメニューの開閉設定
    this.kymw0900Component.acc_PointPromotion.isCollapsed = !this.pointPromotionFlg;
  }

  /**
   * 1物N価媒体プロモーションデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPlanGoodsNbalPromotion(data: any): void {
    this.nvalPromotionFlg = (data.NvalPromotionFlg === '1') ? true : false;
    this.nvalOrderCodeList = data.OrderCodeList;
    this.nvalPromotionList = data.NvalPromotionVOList.map(_ => {
      return {
        nvalDetailId: _.NvalDetailId,
        orderCode: _.OrderCode,
        mediumType: _.MediumType,
        mediumName: _.MediumName,
        mediumTypeName: _.MediumType + '：' + _.MediumName,
        itemCode: _.ItemCode,
        nvalOrderNumQuotaCode: _.NvalOrderNumQuotaCode,
        nvalOrderNum: _.NvalOrderNum,
        ibnkssaKb: _.IbnkssaKb,
        shkkktantKb: _.ShkkktantKb,
        nvalGoodsName: _.NvalGoodsName,
        nvalGoodsNameKana: _.NvalGoodsNameKana,
        nvalGuideName: _.NvalGuideName,
        nvalGuideNameKana: _.NvalGuideNameKana,
        discountType: _.DiscountType,
        discountUnitPrice: _.DiscountUnitPrice,
        discountRate: _.DiscountRate,
        supplyPriceStandard: _.SupplyPriceStandard,
        nvalDiscountSupplyUnitPrice: _.NvalDiscountSupplyUnitPrice,
        pricePattern: _.PricePattern,
        usePrefecture1Flg: _.UsePrefecture1Flg,
        usePrefecture2Flg: _.UsePrefecture2Flg,
        usePrefecture3Flg: _.UsePrefecture3Flg,
        usePrefecture4Flg: _.UsePrefecture4Flg,
        usePrefecture5Flg: _.UsePrefecture5Flg,
        usePrefecture6Flg: _.UsePrefecture6Flg,
        usePrefecture7Flg: _.UsePrefecture7Flg,
        usePrefecture8Flg: _.UsePrefecture8Flg,
        remarks: _.Remarks,
        registFlg: _.RegistFlg,
        deleteFlg: _.DeleteFlg,

        // 値引情報を格納
        displayDiscount: this.setDisplayDiscount(_.DiscountType, _.DiscountUnitPrice, _.DiscountRate),

        // 商品企画メンテナスインプットVO.受注コードに一致しない受注コードの場合、
        // 列をグレーアウトする。コンテキストメニュー.削除、コンテキストメニュー.編集を非活性にする。
        otherOrderCode: this.orderCode !== _.OrderCode,
      }
    });
    this.nvalBundlePeriodVOList = data.BundlePeriodVOList.map(_ => {
      return {
        mediumType: _.MediumType,
        startOrderCode: _.StartOrderCode,
        endOrderCode: _.EndOrderCode
      }
    });

    // 媒体、注文コード、アイテムコード、1物N価詳細情報IDをリスト化・重複削除
    const medOrderItemId = this.nvalPromotionList.map(_ => {
      return {
        mediumType: _.mediumType,
        mediumName: _.mediumName,
        mediumTypeName: _.mediumTypeName,
        nvalOrderNum: _.nvalOrderNum,
        itemCode: _.itemCode,
        id: _.nvalDetailId,
      }
    });
    const nvalDetailIdList = Array.from(new Map(medOrderItemId.map((list) => [list.id, list])).values());

    // 媒体、アイテムコード、1物N価詳細情報IDが同一のものを受注コードごとに格納する配列を作成
    let idOrderCodeList = [];
    for (const e of nvalDetailIdList) {
      let setDataList = this.nvalPromotionList.filter(_ => {
        if (_.mediumType === e.mediumType && _.itemCode === e.itemCode && _.nvalDetailId === e.id) {
          return true;
        }
      });
      const target = setDataList.find(d => d.orderCode === this.orderCode);
      idOrderCodeList.push({mediumType: e.mediumType, mediumName: e.mediumName, mediumTypeName: e.mediumTypeName, nvalOrderNum: target?.nvalOrderNum ?? '', itemCode: e.itemCode, nvalDetailId: e.id, dataList: setDataList});
    }

    this.nvalPromotionListDisplay = idOrderCodeList;

    // アコーディオンメニューの開閉設定
    this.kymw0900Component.acc_NvalPromotion.isCollapsed = !this.nvalPromotionFlg;
  }

  /**
   * プロモ設定タブで画面に表示する値引情報を設定する
   * @param discountType 値引区分
   * @param discountPrice 値引単価
   * @param discountRate 値引率
   * @returns 
   */
  public setDisplayDiscount(discountType: string, discountPrice?: string, discountRate?: string): string {
    let displayDiscount = '';
    if (discountType === '0') {
      // 値引区分が「0:値引きなし」の場合
      displayDiscount = '値引きなし';
    } else if (discountType === '1') {
      // 値引区分が「1:単価指定」の場合
      displayDiscount = discountPrice + '円引き';
    } else if (discountType === '2') {
      // 値引区分が「2:率指定」の場合
      displayDiscount = discountRate + '%引き';
    }
    return displayDiscount;
  }

  /**
   * クーポン商品プロモーションデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPlanGoodsCouponPromotion(data: any): void {
    this.couponPromotionFlg = (data.CouponPromotionFlg === '1') ? true : false;
    this.couponPromotionList = data.CouponPromotionVOList.map(_ => {
      return {
        couponGoodsNo: _.CouponGoodsNo,
        itemCode: PlessViewUtilsSub.nullToBlank(_.ItemCode),
        couponType: PlessViewUtilsSub.nullToBlank(_.CouponType),
        couponTypeName: PlessViewUtilsSub.nullToBlank(_.CouponTypeName),
        displayCouponType: !PlessViewUtilsSub.isEmpty(_.CouponType) ? _.CouponType + '：' + _.CouponTypeName : '',
        groupType: PlessViewUtilsSub.nullToBlank(_.GroupType),
        couponOrderNumQuotaCode: PlessViewUtilsSub.nullToBlank(_.CouponOrderNumQuotaCode),
        couponOrderNum: PlessViewUtilsSub.nullToBlank(_.CouponOrderNum),
        notificationFlg: PlessViewUtilsSub.nullToBlank(_.NotificationFlg),
        notificationFlgName: PlessViewUtilsSub.nullToBlank(_.NotificationFlgName),
        displayNotificationFlg: !PlessViewUtilsSub.isEmpty(_.NotificationFlg) ? _.NotificationFlg + '：' + _.NotificationFlgName : '',
        deliveryFlg: PlessViewUtilsSub.nullToBlank(_.DeliveryFlg),
        deliveryFlgName: PlessViewUtilsSub.nullToBlank(_.DeliveryFlgName),
        displayDeliveryFlg: !PlessViewUtilsSub.isEmpty(_.DeliveryFlg) ? _.DeliveryFlg + '：' + _.DeliveryFlgName : '',
        newsletterFlg: PlessViewUtilsSub.nullToBlank(_.NewsletterFlg),
        newsletterFlgName: PlessViewUtilsSub.nullToBlank(_.NewsletterFlgName),
        displayNewsletterFlg: !PlessViewUtilsSub.isEmpty(_.NewsletterFlg) ? _.NewsletterFlg + '：' + _.NewsletterFlgName : '',
        standardUsageAmount: PlessViewUtilsSub.nullToBlank(_.StandardUsageAmount),
        startMembershipWeeks: PlessViewUtilsSub.nullToBlank(_.StartMembershipWeeks),
        endMembershipWeeks: PlessViewUtilsSub.nullToBlank(_.EndMembershipWeeks),
        couponName: PlessViewUtilsSub.nullToBlank(_.CouponName),
        couponNameKana: PlessViewUtilsSub.nullToBlank(_.CouponNameKana),
        couponGuideName: PlessViewUtilsSub.nullToBlank(_.CouponGuideName),
        couponGuideNameKana: PlessViewUtilsSub.nullToBlank(_.CouponGuideNameKana),
        couponTitleEc: PlessViewUtilsSub.nullToBlank(_.CouponTitleEc),
        couponTitleDelivery: PlessViewUtilsSub.nullToBlank(_.CouponTitleDelivery),
        contentOne: PlessViewUtilsSub.nullToBlank(_.ContentOne),
        contentTwo: PlessViewUtilsSub.nullToBlank(_.ContentTwo),
        contentThree: PlessViewUtilsSub.nullToBlank(_.ContentThree),
        contentFour: PlessViewUtilsSub.nullToBlank(_.ContentFour),
        validatedDate: PlessViewUtilsSub.nullToBlank(_.ValidatedDate),
        staffCouponFlg: PlessViewUtilsSub.nullToBlank(_.StaffCouponFlg),
        registFlg: PlessViewUtilsSub.nullToBlank(_.RegistFlg),
        deleteFlg: PlessViewUtilsSub.nullToBlank(_.DeleteFlg),
        couponApplicablePriceList: _.CouponApplicablePriceList.map(coopInfo => {
          return {
            coopCode: coopInfo.CoopCode,
            coopName: this.convertCoopName(coopInfo.CoopCode),
            planGoodsCoopCouponApplicablePriceFlg: coopInfo.PlanGoodsCoopCouponApplicablePriceFlg === '1',
            thisTimeSupplyPrice: PlessViewUtilsSub.editPriceComma(coopInfo.ThisTimeSupplyPrice, true),
            discountUnitPrice: PlessViewUtilsSub.nullToBlank(coopInfo.DiscountUnitPrice),
            discountRate: PlessViewUtilsSub.nullToBlank(coopInfo.DiscountRate),
            limitNum: PlessViewUtilsSub.nullToBlank(coopInfo.LimitNum),
            discountedUnitPrice: PlessViewUtilsSub.nullToBlank(coopInfo.CouponDiscountSupplyUnitPrice),
            display: false,
          }
        })
      }
    });

    this.couponPromotionListDisplay = this.couponPromotionList.map(_ => ({ ..._}));

    // アコーディオンメニューの開閉設定
    this.kymw0900Component.acc_CouponPromotion.isCollapsed = !this.couponPromotionFlg;
  }

  /**
   * 予約商品フラグを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPreOrderFlag(data: any): void {
    this.preOrderFlag = data.PreOrderFlag === '1';
  }

  /**
   * 予約設定タブデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPreOrder(data: any): void {
    // Pコード変更時に再表示するためリストを空にする
    this.preOrderDetailList = [];
    for(const e of data.PreOrderList) {
      this.preOrderDetailList.push({
        preOrderDetailId: e.PreOrderDetailId,
        itemCode: e.ItemCode,
        preOrderNumQuotaCode: e.PreOrderNumQuotaCode,
        preOrderNum: e.PreOrderNum,
        delivCatalogId: e.DelivCatalogId,
        delivMonday: e.DelivMonday === '1',
        delivTuesday: e.DelivTuesday === '1',
        delivWednesday: e.DelivWednesday === '1',
        delivThursday: e.DelivThursday === '1',
        delivFriday: e.DelivFriday === '1',
        preOrderGoodsName: e.PreOrderGoodsName,
        preOrderGoodsNameKana: e.PreOrderGoodsNameKana,
        preOrderStandardName: e.PreOrderStandardName,
        preOrderStandardNameKana: e.PreOrderStandardNameKana,
        discountType: e.DiscountType,
        discountUnitPrice: e.DiscountUnitPrice,
        discountRate: e.DiscountRate,
        discountSupplyUnitPrice: e.DiscountSupplyUnitPrice,
        preOrderPoints: e.PreOrderPoints,
        // セット企画（1:true、0:false）
        setPreOrderType: e.SetPreOrderType === '1',
        pricePattern: e.PricePattern,
        supplyPriceStandard: e.SupplyUnitPrice,
        preOrderCoopList: e.PreOrderCoopList.map(_ => {
          return {
            coopCode: _.CoopCode,
            planNum: _.PlanNum,
            // 生協コードがある場合はチェックを付ける
            checked: _.CoopCode !== '',
            registFlg: '0',
            deleteFlg: '0',
          }
        }),
        registFlg: '0',
        deleteFlg: '0',
      });
    }
    this.preOrderDetailListDisplay = this.preOrderDetailList.map(_ => ({ ..._}));

    this.setGoodsPlanNumListAll();
  }

  /**
   * 予約設定タブデータの全選択チェックボックス制御
   *
   * @memberof KYMW0900Model
   */
  public setGoodsPlanNumListAll(): void {
    // すべてのチェックボックスがONの場合のみ全選択チェックボックスをON
    let flg = true;
    for (const e of this.goodsPlanNumList) {
      if (e.coopName === '合計') {
        continue;
      }
      if (!e.usePrefectureFlg) {
        flg = false;
        break;
      }
    }
    this.goodsPlanNumListEnableFlgAll = flg;
  }

  /**
   * EC設定タブの企画商品EC情報を設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setPlanGoodsEC(data: any): void {
    this.cmFlg = data.CmFlg === '1';
    this.recommendFlg = data.RecommendFlg === '1';
    this.orderLimitFlg = data.OrderLimitFlg === '1';
    this.webLimitFlg = data.WebLimitFlg === '1';
    this.recommendCommentFlg = data.RecommendCommentFlg === '1';
    this.orderGoodsDiv = data.OrderGoodsDiv;
    this.minOrderNum = PlessViewUtilsSub.isEmpty(String(data.MinOrderNum)) ? '1' : String(data.MinOrderNum);
    this.maxOrderNum = String(data.MaxOrderNum);
    this.nonDispFlg = data.NonDispFlg === '1';
  }

  /**
   * EC設定タブのEC使用画像情報を設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setImageData(data: any): void {
    this.imageList = data.ImageList.map((_) => {
      return {
        coopCode: _.CoopCode,
        coopName: this.kymw0900Component.kymw00Model.COOP_MAP[_.CoopCode],
        coopImageList: _.CoopImageList.map((__) => {
          return {
            imageId: __.ImageId,
            imageName: __.ImageName,
            imageFileName: __.ImageFileName,
            startOrderCode: __.StartOrderCode,
            showSeq: __.ShowSeq,
            imagePreviewUrl: __.ImagePreviewUrl,
            textCaption: __.TextCaption,
          }
        })
      }
    });
    this.enableCoopList = data.EnableCoopList.map((_) => {
      return _.CoopCode;
    });
    if (this.enableCoopList.length > 0) {
      this.selectCoopImage = this.enableCoopList[0];
    }
    for (const e of this.imageList) {
      this.imageMap[e.coopCode] = e.coopImageList;
    }
  }

  /**
   * EC設定タブの在庫数情報を設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setStockInfo(data: any): void {
    this.stockLimitFlg = data.StockLimitFlg === '1';
    this.stockNumTotal = String(data.StockNumTotal);
    this.stockNumShowFlg = data.StockNumShowFlg === '1';
    this.brandName = data.BrandName;
    this.stockList = [{
      coopName: '合計',
      coopCode: '',
      stockNum: this.stockNumTotal,
      supplyPrice: '-',
      supplyPriceExplanation: '-',
    }]
    for (const _ of data.StockList) {
      this.stockList.push({
        coopName: this.kymw0900Component.kymw00Model.COOP_MAP[_.CoopCode],
        coopCode: _.CoopCode,
        stockNum: String(_.StockNum),
        supplyPrice: String(_.SupplyPrice),
        supplyPriceExplanation: _.SupplyPriceExplanation,
      })
    }
  }

  /**
   * EC設定タブのグルーピング情報を設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setGroupingInfo(data: any): void {
    this.groupingCode = data.GroupingCode;
    this.groupingList = [{
      groupingCode: data.GroupingCode,
      groupingName: data.GroupingName,
      groupingDivIBK: data.GroupingDivIBK,
      groupingDivTTG: data.GroupingDivTTG,
      groupingDivGNM: data.GroupingDivGNM,
      groupingDivTIB: data.GroupingDivTIB,
      groupingDivSTM: data.GroupingDivSTM,
      groupingDivTYO: data.GroupingDivTYO,
      groupingDivNGN: data.GroupingDivNGN,
      groupingDivNGT: data.GroupingDivNGT,
      remarks: data.Remarks,
    }];
  }

  /**
   * EC設定タブのWebリンク情報を設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setWebLinkInfo(data: any): void {
    this.coopGoodsUrlTitle = data.CoopGoodsUrlTitle;
    this.coopGoodsUrl = data.CoopGoodsUrl;
    this.relatedUrlTitle = data.RelatedUrlTitle;
    this.relatedUrl = data.RelatedUrl;
  }

  /**
   * EC設定タブのグルーピングコード一覧を設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setGroupingList(data: any): void {
    this.groupingCodeList = data;
  }

  /**
   * EC設定タブのグルーピングデータを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setGroupingData(data: any): void {
    this.groupingList = [{
      groupingCode: data.GroupingCode,
      groupingName: data.GroupingName,
      groupingDivIBK: data.GroupingDivIBK,
      groupingDivTTG: data.GroupingDivTTG,
      groupingDivGNM: data.GroupingDivGNM,
      groupingDivTIB: data.GroupingDivTIB,
      groupingDivSTM: data.GroupingDivSTM,
      groupingDivTYO: data.GroupingDivTYO,
      groupingDivNGN: data.GroupingDivNGN,
      groupingDivNGT: data.GroupingDivNGT,
      remarks: data.Remarks,
    }];
  }

  /**
   * 取扱生協であるかどうかを判定する
   *
   * @memberof KYMW0900Model
   */
  public isEnabledCoop(coopCode: string): boolean {
    return this.enableCoopList.includes(coopCode);
  }

  /**
   * タグタブのタグ一覧データを設定する
   *
   * @param {*} data
   * @memberof KYMW0900Model
   */
  public setTagListData(data: any): void {
    this.tagList = data.map((_) => {
      return {
        tagGroupName: _.TagGroupName,
        tagName: _.TagName,
      }
    })
  }

  /**
   * 【プロモ設定タブ：クーポン商品プロモーション】
   * 値引き前本体価格・税込み価格、値引き後本体価格・税込み価格の表示用フォーマット処理（現行デリシステムの表記）
   * 例：本体　１００円（税込　１１０円）
   */
  public formatUnitRatePrice(unitPrice: number, taxRate: number): string {
    let result = '';
    if (unitPrice) {
      // 消費税区分が「0:外税」以外の場合、税込み価格には本体価格と同値を表示する
      if (this.getConsumeTaxDiv() !== '0') {
        result = KYMW0900Model.DISCOUNT_PRICE_FORMAT.replace('{0}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(unitPrice)));
        result = result.replace('{1}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(unitPrice)));
      } else {
        result = KYMW0900Model.DISCOUNT_PRICE_FORMAT.replace('{0}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(unitPrice)));
        result = result.replace('{1}', PlessViewUtilsSub.toFullWidth(PlessViewUtilsSub.numberToString(Math.floor(unitPrice + (unitPrice * taxRate)))));
      }
    }
    return result;
  }

  /**
   * アイコン設定タブのグルーピングデータを設定する
   * @param data
   * @memberof KYMW0900Model
   */
  public setPCodeIcon(data: any): void {
    this.iconList = data.PCodeIcon.IconList.map((_) => {
      return {
        iconCode: _.IconCode,						
        iconName: _.IconName,
        arrangeDiv: _.ArrangeDiv,
        publishOrder: _.PublishOrder,
        icon0: _.Icon0 === '1',
        icon1: _.Icon1 === '1',
        icon2: _.Icon2 === '1',
        icon3: _.Icon3 === '1',
        icon4: _.Icon4 === '1',
        icon5: _.Icon5 === '1',
        icon6: _.Icon6 === '1',
        icon7: _.Icon7 === '1'
      }
    });
  }

  /**
   * 価格一覧のアイテムコードが空かどうかを判定する（true:空、false:空ではない）
   * @param coopCode 
   * @returns 
   */
  public isEmptyCoopListItemCode(coopCode: string): boolean {
    const flg = this.coopPriceListItemCodeEmpty.find(_ => _.coopCode === coopCode).flg;
    return flg;
  }

  /**
   * プロモ設定タブ「1物N価媒体プロモーション」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 生協コード
   * @param enabled  活性：true、非活性：false
   */
  public setNvalPromotionListEnabled(coopCode: string, enabled: boolean): void {
    const nvalList: Array<any> = this.nvalPromotionListDisplay;

    // 会員生協の活性を変更
    for (let i = Number(0); i < nvalList.length; i++) {
      const item = nvalList[i].dataList.find(_ => _.orderCode === this.orderCode);
      if (item) {
        // 当該会員生協の場合
        switch(coopCode) {
          case this.kymw00Model.COOP_CODE_IB:
            item.usePrefecture1Flg = enabled === false ? '0' : item.usePrefecture1Flg;
            break;
          case this.kymw00Model.COOP_CODE_TO:
            item.usePrefecture2Flg = enabled === false ? '0' : item.usePrefecture2Flg;
            break;
          case this.kymw00Model.COOP_CODE_GU:
            item.usePrefecture3Flg = enabled === false ? '0' : item.usePrefecture3Flg;
            break;
          case this.kymw00Model.COOP_CODE_TI:
            item.usePrefecture4Flg = enabled === false ? '0' : item.usePrefecture4Flg;
            break;
          case this.kymw00Model.COOP_CODE_SA:
            item.usePrefecture5Flg = enabled === false ? '0' : item.usePrefecture5Flg;
            break;
          case this.kymw00Model.COOP_CODE_TK:
            item.usePrefecture6Flg = enabled === false ? '0' : item.usePrefecture6Flg;
            break;
          case this.kymw00Model.COOP_CODE_NA:
            item.usePrefecture7Flg = enabled === false ? '0' : item.usePrefecture7Flg;
            break;
          case this.kymw00Model.COOP_CODE_NI:
            item.usePrefecture8Flg = enabled === false ? '0' : item.usePrefecture8Flg;
            break;
        }
      }
    }
    this.nvalPromotionListDisplay = nvalList;
  }

  /**
   * プロモ設定タブ「クーポン商品プロモーション」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 生協コード
   * @param enabled  活性：true、非活性：false
   */
  public setCouponPromotionListEnabled(coopCode: string, enabled: boolean): void {
    const couponList: Array<any> = this.couponPromotionListDisplay;

    // 会員生協の活性を変更
    for (let i = Number(0); i < couponList.length; i++) {
      // 当該会員生協の場合
      couponList[i].couponApplicablePriceList.map(ca => {
        if (ca.coopCode === coopCode) {
          ca.disable = !enabled;
          if (!enabled) {
            // 非活性の場合false
            ca.planGoodsCoopCouponApplicablePriceFlg = enabled;
            // 非活性の場合項目クリア
            ca.discountRate = '';
            ca.discountUnitPrice = '';
            ca.discountedUnitPrice = '';
            ca.limitNum = '';
            ca.thisTimeSupplyPrice = '';
          }
        }
      })
    }
    this.couponPromotionListDisplay = couponList;
  }

  /**
   * プロモ設定タブ「ポイント交換商品プロモーション」の当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 生協コード
   * @param enabled  活性：true、非活性：false
   */
  public setPointExchangePromotionListEnabled(coopCode: string, enabled: boolean): void {
    const pointList: Array<any> = this.pointExchangeListDisplay;

    // 会員生協の活性を変更
    for (let i = Number(0); i < pointList.length; i++) {
      // 当該会員生協の場合
      pointList[i].coopPointRateList.map(cp => {
        if (cp.CoopCode === coopCode) {
          cp.DisabledFlg = !enabled;
          if (!enabled) {
            // 非活性の場合false
            cp.PlanGoodsCoopPointRateEnableFlg = enabled;
            // falseの場合削除フラグ'1'
            cp.DeleteFlg = '1';
            // falaseの場合項目クリア
            cp.ExchangePoint = '';
            cp.ExchangePointWithoutTax = '';
            cp.PointRate = '';
            cp.ThisTimeSupplyPrice = '';
          }
        }
      })
    }
    this.pointExchangeListDisplay = pointList;
  }

  /**
   * 予約設定タブの当該会員生協の活性／非活性を更新する
   *
   * @param coopCode 生協コード
   * @param enabled  活性：true、非活性：false
   */
  public setPreOrderListEnabled(coopCode: string, enabled: boolean): void {
    const preOrderList: Array<any> = this.preOrderDetailListDisplay;

    // 会員生協の活性を変更
    for (let i = Number(0); i < preOrderList.length; i++) {
      // 当該会員生協の場合
      preOrderList[i].preOrderCoopList.map(p => {
        if (p.coopCode === coopCode) {
          p.disabled = !enabled;
          if (!enabled) {
            // 非活性の場合false
            p.checked = enabled;
            // falseの場合削除フラグ'1'
            p.deleteFlg = '1';
            // falseの場合項目クリア
            p.planNum = '';
          }
        }
      })
    }
    this.preOrderDetailListDisplay = preOrderList;
  }
}
